var _defineProperty = require("/home/ubuntu/workspace/bom-ui-preprod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _months, _pes, _liveVitalStats, _offline;

var mobile = {
  "nav": {
    "today": "Estado",
    "history": "Energia",
    "layout": "Arranjos",
    "menu": "Menu"
  },
  "button": {
    "cancel": "Cancelar",
    "done": "Feito",
    "login": "Entrar",
    "today": "Hoje",
    "submit": "Enviar",
    "ok": "OK",
    "choose_file": "Escolher arquivo",
    "refresh": "Atualizar",
    "send": "Mandar",
    "skip": "Avançar",
    "continue": "Prosseguir",
    "clickHere": "Clique aqui",
    "confirm": "Confirmar",
    "reset": "Restabelecer",
    "edit": "Editar",
    "update": "Atualizar",
    "next": "Próximo",
    "save": "Guardar",
    "no": "Não",
    "yes": "Sim",
    "enable": "Ativar",
    "setNow": "Definir agora",
    "gotIt": "Percebi",
    "okGotIt": "Ok, entendi",
    "knowMore": "Saber mais",
    "noExportCredit": "Não recebo crédito de exportação",
    "tryLater": "Tentar mais tarde",
    "otherNetworks": "Outras redes"
  },
  "form": {
    "topic": "Tópico",
    "contactSupport": {
      "success": {
        "message": "Agradecemos seu contato.",
        "description": "Estamos ansiosos por ajudar a resolver sua questão. Um especialista da Enphase entrará em contato em breve.",
        "email_notify": "O relatório será enviado em breve para %{email}."
      },
      "error": {
        "message": "Falha no envio da mensagem.",
        "description": "Tente novamente.",
        "reset_password": "Senha expirada. Solicitamos que redefina sua senha."
      }
    },
    "default": {
      "success": "Salva com sucesso.",
      "error": "Tente novamente",
      "pleaseEnterAValue": "Insira um valor",
      "permissionDenied": "Permissão negada",
      "activeBatteryProfile": "Tem um pedido ativo no perfil da bateria. Aguarde pela confirmação ou cancele o pedido para continuar."
    },
    "search": "Procurar"
  },
  "common": {
    "please": "Por favor",
    "contactSupport": "Contacte a assistência",
    "forHelp": "para obter ajuda.",
    "videos": "Vídeos",
    "articles": "Artigos",
    "new": "Novo",
    "startDate": "Data de início",
    "endDate": "Data de fim",
    "clearedDate": "Data de autorização",
    "startTime": "Hora de início",
    "endTime": "Hora de fim",
    "duration": "Duração"
  },
  "errors": {
    "error": "Fahla",
    "errors": "Erros",
    "warning": "Aviso",
    "retry": "Voltar a tentar",
    "email": "Endereço de correio eletrônico",
    "password": "Digite sua senha",
    "login": "E-mail e senha inseridos não conferem com nossos registros. ",
    "accInactive": "A conta está inativa. Entre em contato com seu instalador e tente novamente assim que seu sistema estiver totalmente ativo.",
    "expired": "Seu login expirou.",
    "loggedout": "A sua sessão terminou.",
    "report": "Desculpe! Ocorreu um erro.",
    "offline": "Verifique a conexão com a Internet e tente novamente.",
    "noInternet": "Sem conexão com a Internet",
    "message": "Mensagem",
    "tryagain": "tente novamente",
    "resetNow": "Redefina agora",
    "resetPassword": "Sua senha expirou. Redefina a senha para visualizar o relatório.",
    "validEmail": "Digite um endereço válido de e-mail",
    "validPhone": "Digite um número válido de telefone",
    "fileError": "O logo da empresa deve ter entre 0,05kb e 4MB.",
    "400": "Bad Request",
    "401": "Acesso não autorizado",
    "403": "Acesso proibido",
    "404": "Recurso não encontrado",
    "422": "Entidade não processável",
    "500": "Erro interno do servidor.",
    "502": "Nieprawidłowa brama.",
    "503": "Serviço indisponível.",
    "504": "Limit czasu bramy.",
    "default": "Server error.",
    "400_text": "Bad Request",
    "401_text": "Acesso não autorizado",
    "403_text": "Acesso proibido",
    "404_text": "Recurso não encontrado",
    "422_text": "Entidade não processável",
    "500_text": "Erro interno do servidor. Por favor, tente novamente mais tarde.",
    "502_text": "Problema no gateway. Por favor, tente novamente mais tarde.",
    "503_text": "Serviço indisponível. Por favor, tente novamente mais tarde.",
    "504_text": "Tempo limite do Gateway Por favor, tente novamente mais tarde.",
    "default_text": "Erro do servidor. Por favor, tente novamente mais tarde.",
    "noDeviceFound": "Nenhum dispositivo encontrado",
    "noBackupHistoryFound": "Não foi encontrado histórico de reserva",
    "noWiFiNetworkFound": "Não foi encontrada rede Wi-fi",
    "noResultFound": "Não foi encontrado resultado",
    "allSites": "Todos os locais",
    "favorites": "Favoritos",
    "changesNotSaved": "As alterações não foram salvas",
    "wantToExit": "Deseja sair sem salvar?",
    "rateNotFound": "Taxa não encontrada"
  },
  "login": {
    "forgot": "Esqueci a senha",
    "signup": "Nova conta",
    "header": "Faça login no Enphase",
    "intro_content": "Digite seu endereço de e-mail e senha para fazer login",
    "remember_me": "Lembre-me",
    "forgot_password": "Esqueceu sua senha?",
    "forgot_password_success": "Se você já se registrou na Enphase, verifique seu e-mail para obter instruções de redefinição.",
    "caps_lock_warning": "Caps Lock está ativado",
    "welcome_back": "Bem-vindo de volta, %{user_name}. ",
    "en_us_installer_html": "Bem-vindo %{user_name}. Visite nosso <a href='http://go.enphase.com/gettingstarted' target='_blank'> site de primeiros passos</a> para aprender tudo o que você precisa saber sobre o projeto, instalação e comissionamento dos sistemas Enphase.  ",
    "en_aunz_installer_html": "Bem-vindo %{user_name}. Visite nosso <a href='http://go.enphase.com/au/gettingstarted' target='_blank'>site de primeiros passos</a> para aprender tudo o que você precisa saber sobre o projeto, instalação e comissionamento de sistemas Enphase. ",
    "provide_email_password": "Forneça um nome de usuário e uma senha.",
    "request_account": "Solicite uma conta",
    "subheader": {
      "new_user": "Novo no Enphase?",
      "enphasePES": "Enphase PES"
    },
    "new_user_content_html": "Os produtos da Enphase Energy melhoram drasticamente o desempenho dos sistemas de energia solar. Usando os Microinversores Enphase, os responsáveis e operadoras aumentam a produtividade e a confiabilidade de sua instalação solar.<br/><br/>Para ver o Enphase em ação, <a href='%{systems_list_link}'> dê uma olhada nas instalações de nossos clientes.</a>",
    "public_system_content_html": "Quer ver o Enphase em ação? <a href='%{systems_list_link}'> Ver sistemas públicos</a>",
    "register_new_user_html": "Instalando seu primeiro sistema Enphase? <a href='%{register_user_link}'>Inscreva-se no Enphase</a>",
    "recommended_browsers": "O aplicativo Enphase é compatível com os seguintes navegadores: Chrome 5 ou superior, Firefox 3.6 ou superior, Internet Explorer 10 ou superior, Microsoft Edge para Windows, Safari 4 ou superior. O aplicativo Enphase requer o Adobe Flash Player 10.",
    "recommended_browsers_3x": "O aplicativo Enphase é compatível com os seguintes navegadores: Chrome 44 ou superior, Firefox 41 ou superior, Internet Explorer 11, Microsoft Edge para Windows, Safari 8 ou superior.",
    "cookies_required": "Cookies must be enabled.",
    "no_community": "Esta comunidade é dedicada a discussões técnicas para instaladores Enphase. Convidamos você a participar das discussões em nossa <a href='https://www.facebook.com/EnphaseEnergy'> página do Facebook</a>.",
    "required": "Você deve fazer login para acessar essa página",
    "findInstaller": "Procurar um instalador",
    "sizeYourSystem": "Dimensionar o seu sistema",
    "getEnphase": "Obtenha Enphase",
    "experienceTheApp": "Experimentar aplicação",
    "viewStorageSystem": "Visualize o sistema de armazenamento",
    "meetEnphase": "Onde encontrar o Enphase",
    "enphaseSolar": "Enphase Solar",
    "enphaseStorage": "Enphase Storage"
  },
  "logout": {
    "confirm_logout": "Você foi desconectado. Obrigado pela visita."
  },
  "password_recovery": {
    "activate_account": {
      "header": "Ativar conta",
      "link": "Ative sua conta agora"
    },
    "header": "Redefinição de senha",
    "intro_content": "Digite seu e-mail registrado na Enphase. Enviaremos um link para redefinição da senha para o e-mail.",
    "login": "Entrar",
    "try_again": "Tente novamente.",
    "sent_message_html": "Enviamos uma mensagem para %{email}. Clique no link do e-mail para redefinir a senha. <span style = 'color: red'> Se você não recebeu o e-mail, verifique sua pasta de lixo eletrônico/spam. </span>",
    "invalid_request": "Pedido inválido",
    "invalid_link": "Não foi possível redefinir a senha. O link de redefinição de senha é válido por 7 dias. Tente novamente.",
    "success": "Senha redefinida com sucesso.",
    "failed_password_reset": "Problema encontrado. Tente novamente.",
    "password_requirements": "Your password must be at least six characters, must contain at least one number or special character, and can't be the same as your email address.",
    "note": "Senha ",
    "OK": "OK",
    "sent_email": "Enviamos um e-mail para",
    "rest_pwd": "Clique no link do e-mail para redefinir a senha."
  },
  "users": {
    "new": "Registo de novo usuário",
    "company_details": "Detalhes da Empresa",
    "edit": "Editar usuário",
    "re-upload_documents": "Novo upload do ID da empresa",
    "site_accesses": "Acesso ao sistema",
    "login": "Entrar",
    "logged_in_as": "%{admin}, você está conectado como %{user}",
    "logout_as": "Pare",
    "reset_password": "Redefinir senha",
    "preview_marketing_description": "Apenas visualização. As alterações ainda não foram salvas.",
    "preview_custom_welcome_message": "Apenas visualização. As alterações ainda não foram salvas.",
    "reset_password_confirm_html": "<b> Tem certeza de que deseja redefinir a senha deste usuário? </b> <p> Isso enviará um e-mail de redefinição de senha para o usuário. </p>",
    "reset_password_success": "Um email para redefinir a senha será enviado para %{email}.",
    "reset_password_failed": "Falha ao redefinir a senha.",
    "enlighten_manager_access": "Este usuário possui o Enlighten Manager com acesso a dados em nível de módulo.",
    "myenlighten_access_note": "(apenas para usuários que NÃO estão associados a uma empresa)",
    "module_level_access_note": "(com acesso a dados em nível de módulo)",
    "complimentary_note": "NOTE: NOTA: Mudar um usuário de MyEnlighten para Enlighten Manager constitui dar uma ativação de software no valor de %{price}. Esta transação será registrada e relatada ao departamento financeiro.",
    "purchase_note": "A ativação do software foi comprada por %{email} por %{price} em %{date}.",
    "enlighten_version_title": "Versão do aplicativo Enphase",
    "unlock_account": "Desbloquear a conta",
    "enlighten_version": {
      "enlighten_manager": "Enlighten Manager",
      "my_enlighten": "MyEnlighten"
    },
    "self_installer_true": "Eu sou um faz-você-mesmo instalando produtos Enphase em minha própria casa ou empresa",
    "self_installer_false": "Sou um profissional de energia solar registrado em nome da minha empresa",
    "self_register_independent": "Outros",
    "opt_in": "Eu concordo em receber boletins informativos, promoções e pesquisas sobre os produtos ou serviços da Enphase.",
    "opt_in_info": "Você pode retirar seu consentimento a qualquer momento. Para mais informações, consulte a <a href='%{privacy_url}' target='_blank'>Política de Privacidade</a> da Enphase ou <a href='%{contact_url}' target='_blank'>entre em contato conosco</a>.",
    "personal_details": "Detalhes pessoais",
    "enable_camera": "Ative o acesso à câmera de seu aplicativo a partir da aba de configurações",
    "dont_allow": "Não permita",
    "cameraText": "Isto permitirá selecionar a imagem que gostaria de enviar como logo de sua empresa."
  },
  "company": {
    "id": "Identyfikator firmy",
    "active_users": "Usuários ativos",
    "address1": "Ulica i numer",
    "optional": "Opcional",
    "address2": "Ulica i numer 2",
    "address_id": "Localização",
    "branch_name": "Nome da Filial",
    "branch_of": "Filial de",
    "city": "Cidade",
    "companies": "Branches",
    "country": "País",
    "duplicate_of": "Substituído por",
    "latitude": "Latitude",
    "logo_img": "Logotipo da Empresa",
    "file_type_size": "Deve ser um arquivo JPEG ou PNG que não seja maior do que 4MB.",
    "file_recommendation": "Para melhores resultados, recomendamos uma imagem quadrada com fundo transparente de pelo menos 400px de largura por 400px de altura.",
    "file_examples": "Por exemplo: Licença C-46, Número GST",
    "logo_img_file_size": "Logotipo da Empresa",
    "logo_img_content_type": "Logotipo da Empresa",
    "longitude": "Długość geograficzna",
    "long_name": "Nome da empresa",
    "marketing_description": "Descrição da Empresa",
    "custom_welcome_message": "Mensagem de e-mail de boas-vindas ao cliente",
    "show_logo_in_welcome_email": "Exibir o logotipo da empresa no e-mail de boas-vindas ao cliente",
    "name": "Nome",
    "parent": "Matriz",
    "phone": "Telefone",
    "role": "Função",
    "roles": {
      "admin": "Suporte/Call Center",
      "installer": "Instalador",
      "distributor": "Distribuidor",
      "third_party_owner": "Proprietário Terceiro"
    },
    "state": "Estado/Province",
    "support_email": "Email de Suporte ao Cliente",
    "support_phone": "Telefone de Suporte ao Cliente",
    "timezone": "Fuso horário",
    "url": "URL do site",
    "zip": "CEP/Código Postal",
    "is_installer": "Esta empresa instala sistemas Enphase",
    "errors": {
      "name_not_found": "Não foi possível encontrar o nome da empresa"
    },
    "success": {
      "msg": "Sua conta foi criada. Verifique seu e-mail para obter instruções sobre como fazer login."
    }
  },
  "forecast": {
    "nodata": "Os dados da previsão não estão disponíveis!",
    "nodata5": "Necessitamos de, pelo menos, 5 dias de dados de produção para uma previsão precisa dos dados de produção.",
    "nodata10": "É necessário pelo menos 5 dias de dados de produção nos últimos 15 dias para exibir a sua previsão.",
    "apifail": "Não é possível apresentar os dados previstos!",
    "apifailSub": "Erro na apresentação dos dados de previsão devido a questões técnicas. Por favor, consulte após algum tempo.",
    "weatherErr": "Erro na apresentação dos dados de previsão devido à indisponibilidade de dados meteorológicos.",
    "weatherProdErr": "Erro na exibição dos dados previstos devido à indisponibilidade de dados de produção ou meteorológicos.",
    "genErr": "Erro na apresentação dos dados de previsão devido a questões técnicas.",
    "envoyErr1": "Os dados de produção não estão disponíveis uma vez que o seu gateway não reporta à nuvem.",
    "envoyErr2": "Os dados de produção não atualizam uma vez que o seu gateway não reporta à nuvem.",
    "microErr1": "Os dados de produção não estão disponíveis porque nenhum dos microinversores comunica",
    "microErr2": "Os dados de produção não atualizam porque nenhum dos microinversores comunica",
    "accCTA": "Por que motivo a sua produção real não corresponde à previsão?",
    "ctainfo": "A previsão tem por objetivo apenas ajudar a planear as suas necessidades de energia. Tenha em atenção que os seus valores de produção podem ser diferentes da previsão.",
    "ctainfoRes": "Possíveis razões das diferenças entre produção real e previsão",
    "ctainfoRes1": "Alterações meteorológicas frequentes na sua localidade",
    "ctainfoRes2": "Alguns microinversores não estão a comunicar",
    "ctainfoRes3": "O seu sistema não comunica há mais de um dia",
    "today": "Hoje",
    "forecast": "Previsão",
    "actual": "Real",
    "timeFrom": "A mostrar: 12:00",
    "actualProd": "Actual Production",
    "sunrise": "Nascer do sol",
    "sunset": "Pôr do sol",
    "clearDay": "Geralmente limpo",
    "clearNight": "Mostly clear",
    "rain": "Geralmente chuvoso",
    "snow": "Geralmente nevoso",
    "sleet": "Geralmente chuvoso e nevoso",
    "wind": "Geralmente ventoso",
    "fog": "Geralmente enevoado",
    "cloudy": "Nublado",
    "partlycloudy": "Parcialmente nublado",
    "unknown": "Unknown",
    "at12": "Às 12:00",
    "title": "Saiba qual é a sua previsão da produção",
    "infoIconPopup": "A previsão da produção é a previsão da quantidade de energia que os seus painéis produziriam hoje e durante os próximos 5 dias. A previsão é calculada com base na sua produção de energia anterior e na previsão meteorológica na sua região.",
    "fiveday": "Previsão de 5 dias",
    "tomo": "Amanhã"
  },
  "user": {
    "id": "ID do usuário",
    "api_key": "Chave API",
    "company": "Empresa",
    "company_id": "Identyfikator firmy",
    "consumer": "MyEnlighten",
    "country": "País",
    "email": "Endereço de correio eletrónico",
    "email_confirm": "Confirmar e-mail",
    "password": "Senha",
    "first_name": "Primeiro nome",
    "last_name": "Sobrenome",
    "sfdc_email": "Correio eletrónico",
    "sfdc_subject": "Sujeito",
    "sfdc_message": "Mensagem",
    "sfdc_siteId": "Enphase Site ID",
    "created_at": "Criado em",
    "name": "Nome",
    "updated_at": "Atualizado em",
    "status": "Estado",
    "phone": "Telefone",
    "locale": "Local preferido",
    "preferred_metric": "Unidades",
    "preferred_alert_level": "Nível de alerta padrão",
    "preferred_array_builder": "Pode construir arrays",
    "preferred_show_dashboard_help": "Preferências de ajuda do painel",
    "preferred_new_look": "Preview Enlighten 3.0",
    "preferences": "Preferências",
    "role": "Função",
    "roles_mask": "Máscara de papéis",
    "sales_demo": "Demonstração de Vendas",
    "sees_modules": "Pode ver os dados do módulo",
    "notes": "Notas",
    "prefers_monthly_email": "Assine o e-mail mensal",
    "preferred_enphase_email": "Inscreva-se para receber o e-mail da Enphase",
    "prefers_privacy_policy_assent": "Termos de política de privacidade aceitos",
    "active": "Ativo",
    "inactive": "Inactive",
    "add_user": "Adicionar usuário",
    "self_installer": "Autoinstalador",
    "site_access_id": "ID do local",
    "user_access_id": "ID do usuário",
    "with_company": "Incluir detalhes da empresa em meu registro",
    "last_login": "Último Login",
    "acknowledge": "Confirmo que li e entendi a política da Enphase",
    "privacy_url": "Política de Privacidade",
    "terms_url": "Condições do serviço",
    "acknowledgementHead": "Eu li da Enphase",
    "acknowledgementBody": "e li e concordo com"
  },
  "privacy_policy_broadcast": {
    "modal": {
      "title": "Nossa Política de Privacidade mudou em %{policy_date}",
      "acknowledgement": "Confirmo que li e entendi a <a href='%{privacy_url}' target='_blank'>Política de Privacidade</a> da Enphase.",
      "continue_button": "Prosseguir",
      "privacy_settings_button": "Continue para as configurações de privacidade",
      "privacy_policy_agreement_required": "Confirmo que li e entendi a <a target='_blank' href='%{privacy_url}'>Política de Privacidade</a>\ne <a target='_blank' href='%{terms_url}'>Condições do serviço</a>\n da Enphase."
    }
  },
  "jquery_validate": {
    "messages": {
      "required": "Este campo é obrigatório."
    }
  },
  "validate": {
    "privacy_policy_accept": "Se você não concordar com os termos da Política de Privacidade e Termos de Serviço da Enphase, você não poderá se registrar no aplicativo Enphase."
  },
  "period": {
    "hours": "Dia",
    "days": "Mês",
    "week": "Semana",
    "months": "Ano",
    "years": "Tempo de vida",
    "custom": "Personalizada"
  },
  "history": {
    "totals": "Totais",
    "graph": "Casa",
    "production": "Produzido",
    "consumption": "Consumida",
    "grid": "Concessionária",
    "export": "Exportado",
    "import": "Importada",
    "netExported": "Exportada líquida",
    "netImported": "Importado líquido",
    "battery": "Bateria",
    "charge": "Carregado",
    "discharge": "Descarregado",
    "soc": "Bateria",
    "hours": "",
    "months": "",
    "today": "Hoje",
    "battery_status": "carga",
    "bulbs": "Lâmpada de 100w",
    "last_updated": "Atualizado",
    "power": "Potência",
    "solar_produced": "Produção solar",
    "solar_consumed": "Consumo solar",
    "saved": "Guardado",
    "emission_saved": "Economia na emissão de CO2",
    "refrigerator": "Geladeira",
    "produced_today": "Produção de hoje",
    "produced_yesterday": "Produced yesterday",
    "this_week": "Esta semana",
    "last_week": "semana passada",
    "this_month": "este mês",
    "last_month": "mês passado",
    "this_year": "Este ano",
    "last_year": "Ano passado",
    "selected_day": "Dia selecionado ",
    "previous_day": "Dia anterior",
    "selected_week": "Semana selecionada",
    "previous_week": "Semana anterior",
    "selected_month": "Mês selecionado",
    "previous_month": "Mês anterior",
    "selected_year": "Ano selecionado",
    "previous_year": "Ano passado",
    "produced_this_week": "Produzido esta semana",
    "produced_last_week": "Produzido na semana passada",
    "produced_this_year": "Produzido este ano",
    "produced_last_year": "Produzido no ano passado",
    "produced_this_month": "Produzido este mês",
    "produced_last_month": "Produzido este mês",
    "produced_lifetime": "Produção ao longo de todo o tempo",
    "imported-exported": "Importada/Exportado",
    "yesterday": {
      "hours": "Ontem",
      "days": "Mês passado",
      "months": "Ano passado",
      "years": "Produzido"
    },
    "lastyear": {
      "hours": "Ano passado",
      "days": "Ano passado",
      "months": "Ano passado",
      "years": "Produzido"
    },
    "generator": "Gerador"
  },
  "custom_report": {
    "dataType": "Choose data type",
    "frequency": {
      "dataFrequency": "Escolher a frequência de dados",
      "daily": "Diariamente",
      "weekly": "Semanalmente",
      "monthly": "Mensalmente",
      "yearly": "Anualmente",
      "generateReport": "Precisamos, pelo menos, dos dados de uma semana para gerar o relatório"
    }
  },
  "calendar": {
    "select": "Selecione uma data",
    "scale": {
      "production": "Produção",
      "consumption": "Consumo"
    },
    "weekDays": {
      "monday": "Segunda-Feira",
      "tuesday": "Terça-feira",
      "wednesday": "Quarta-feira",
      "thursday": "Quinta-feira",
      "friday": "Sexta-feira",
      "saturday": "Sábado",
      "sunday": "Domingo"
    },
    "months": (_months = {
      "january": "Janeiro",
      "february": "Fevereiro",
      "march": "Março",
      "april": "Abril",
      "may": "Maio",
      "june": "Junho",
      "july": "Julho",
      "august": "Agosto",
      "september": "Setembro",
      "october": "Outubro",
      "november": "Novembro",
      "december": "Dezembro",
      "jan": "Jan",
      "feb": "Fev",
      "mar": "Mar",
      "apr": "Abr"
    }, _defineProperty(_months, "may", "Maio"), _defineProperty(_months, "jun", "Jun"), _defineProperty(_months, "jul", "Jul"), _defineProperty(_months, "aug", "Ago"), _defineProperty(_months, "sep", "Set"), _defineProperty(_months, "oct", "Out"), _defineProperty(_months, "nov", "Nov"), _defineProperty(_months, "dec", "Dez"), _months),
    "time": {
      "hour": "hora",
      "hours": "horas",
      "minute": "minuto",
      "minutes": "minutos",
      "second": "segundo",
      "seconds": "segundos",
      "millisecond": "milissegundo",
      "milliseconds": "milissegundos",
      "day": "dia",
      "h": "h",
      "hrs": "h",
      "min": "min",
      "mins": "min"
    }
  },
  "status": {
    "nameChangeNormal": "Normal",
    "nameChangeError": 'Erro',
    "nameChangeWarning": 'Aviso',
    "dayTitle": "Situação de hoje",
    "dayAltTitle": "Situação mais recente",
    "monthTitle": "Situação deste mês",
    "monthAltTitle": "Situação mensal mais recente",
    "yearTitle": "Stan w tym roku",
    "yearAltTitle": "Situação anual mais recente",
    "lifetimeTitle": "Situação do tempo total",
    "lifetime": "Tempo de vida",
    "system_normal": "Sistema normal",
    "system_error": "Erro do sistema",
    "latest_power": "Última potência",
    "peak_power": "Pico de potência",
    "energyConsumed": "Energia consumida",
    "energyProduced": "Energia Produzida",
    "powerProduced": "Energia produzida",
    "powerConsumed": "Energia consumida",
    "moreDetails": "Mais detalhes",
    "latest_power_text": "A Energia solar mais recente é a saída de energia informada mais recente de seu sistema fotovoltaico",
    "peak_power_text": "O pico de energia é a saída máxima de energia de seu sistema fotovoltaico para o período de tempo escolhido",
    "addEnphaseStorage": "Adicionar bateria da Enphase",
    "getAQuote": "Obter um orçamento",
    "production": {
      "title": "Solar",
      "label": "Produzido",
      "section": "Destinos da energia"
    },
    "consumption": {
      "title": "Uso",
      "label": "Consumida",
      "section": "Fontes de energia"
    },
    "grid": {
      "title": "Energia líquida",
      "export": "Exportado",
      "import": "Importada",
      "label": "Energia líquida com importada/exportada",
      "section": "Fontes de energia",
      "progressbarTitle": "Energia líquida da rede elétrica"
    },
    "breakdown": {
      "consumption": "Casa",
      "battery": "Armazenar",
      "production": "Solar",
      "grid": "Concessionária",
      "export": "Exportado",
      "import": "Importada",
      "soc": "Armazenado",
      "total": "Total",
      "peak": "Pico de potência",
      "latest": "latest",
      "next": "Relatório líquido"
    },
    "battery": {
      "title": "Armazenar",
      "label": {
        "none": "Inativo",
        "positive": "Carregando",
        "negative": "Descarregamento"
      },
      "section": "Energia disponível"
    },
    "charge": "carga",
    "stormAlertOn": "Alerta de tempestade: Ligado",
    "batteryProfile": "Perfil",
    "batteryInfo1": "Com base no consumo das últimas 24 h (%{consumption}) O seu sistema Enphase funcionará durante aproximadamente ",
    "batteryInfo2": "sem rede ou energia solar.",
    "batteryInfoWOSolar": " sem rede elétrica.",
    "batteryErrorInfo": "Não temos dados suficientes para estimar o tempo de backup de sua bateria.",
    "to": "até",
    "batteryZeroErrorInfo": "Tem zero horas de reserva, pois as suas baterias estão sem carga.",
    "hours": "horas",
    "minutes": "minuto(s)",
    "gridControls": {
      "verifyOtp": "Verificar código",
      "verificationCode": "Código de verificação",
      "offGridContent": "Perderá a ligação à rede. A potência disponível para consumo será limitada.",
      "tryAgainContent": "Não é possível estabelecer uma conexão com o Gateway.",
      "verifyOtpEmail": "Insira o código de 4 dígitos enviado para o endereço de e-mail registrado.",
      "verifyOtpEmailMobile": "Introduza o código de 4 dígitos que foi enviado para o seu endereço de correio eletrónico e telemóvel registados.",
      "verifyOtpUpdateMobile": "O código de 4 dígitos será enviado para o endereço de e-mail registrado.",
      "onGridContent": "Deseja ligar o seu sistema novamente à rede agora?",
      "pleaseTryAgain": "Tente novamente",
      "enterValidOtp": "Introduza um código válido",
      "didntReceiveOtp": "Não recebeu o código?",
      "goOffGrid": "Desligado da rede",
      "goOnGrid": "Ligar à rede",
      "tryAgain": "tente novamente",
      "resend": "Reenviar",
      "alert": "O acesso de controlo da rede está desativado uma vez que está a decorrer uma atualização do seu sistema. Esta atualização pode demorar até 24 horas. Aguarde que a atualização esteja concluída.",
      "sendCode": "Enviar código",
      "mobileStatus": "O número de telemóvel não está atualizado",
      "myInfoButton": "Clique aqui para atualizar",
      "wpc1l1": "Os seus níveis atuais de consumo são superiores à produção de energia solar disponível.  Reduza o consumo para evitar o desligamento do sistema durante a transição.​",
      "wpc1l2": "Pode ver a sua produção de energia solar atual e o consumo de carga essencial em %{liveStatus}.",
      "wpc2l1": "O seu consumo médio ao longo dos últimos 15 minutos é superior à sua produção de energia solar média. Certifique-se de que a sua produção de energia solar atual é suficiente para suportar as exigências do consumo, evitando o desligamento do sistema quando estiver fora da rede.",
      "wpcOnGrid": "O seu sistema é atualmente alimentado pelo gerador. Mudar para o modo 'Na rede' pode levar a uma falha de energia temporária, se o seu consumo for muito elevado. Reduza o consumo para evitar falhas. ",
      "wpcOnGrid2": "Pode ver o seu consumo atual em %{liveStatus}."
    },
    "viewDetails": "Ver detalhes",
    "socMessageError1": "O armazenamento agregado",
    "socMessageError2": "exclui os percentuais de armazenamento de",
    "socMessageError3": "Bateria (s)",
    "socMessageThreshold": "A carga da bateria é desconhecida, pois nenhuma das baterias reportou dados durante o último ciclo de relatório"
  },
  "menu": {
    "supportHistory": "Histórico de apoio",
    "supportHistorySearch": "",
    "connectedAppliances": "Aparelhos ligados",
    "connectedAppliancesSubtitle": "Monitorize e controle os aparelhos inteligentes",
    "homeConnect": "Home Connect",
    "homeConnectSubtitle": "Monitorize e controle os seus electrodomésticos habilitados para Home Connect",
    "appTutorial1": "Pode consultar todos os tutoriais do sistema a qualquer momento navegando até",
    "appTutorial2": "Conheça o seu sistema",
    "appTutorial": "Conheça o seu sistema",
    "appTutorial3": "em",
    "appTutorial4": "Sistema",
    "viewallsystutorial": "Ver todos os tutoriais do sistema",
    "voiceAssistant": "Assistente de voz",
    "voiceAssistantSubtitle": "Ativar controlo de vos para a Enphase",
    "alexa": "Alexa",
    "googleAssistant": "Google Assistant",
    "solarForecast": "Previsão da produção",
    "dryContactLoads": "Cargas",
    "generator": "Gerador",
    "generatorDevice": "Gerador",
    "loadControl": "Controlo da carga",
    "advanceSettings": "Definições avançadas",
    "advanceBatterySettings": "Definições avançadas",
    "advancedBatterySettings2": "Definições avançadas",
    "loadControlSubtitle": "Controle a potência das suas cargas",
    "evCharge": "Electric Vehicle Charging",
    "evChargeSubtitle": "Smart suggestions for EV charging",
    "notices": "Avisos",
    "newNotices": "Avisos",
    "reports": "Relatórios",
    "exploreEnphase": "Explorar o Enphase",
    "exploreEnphaseNewMenu": "Explorar",
    "details": "Detalhes",
    "detailSite": "DETALHES DO LOCAL",
    "detailsInstaller": "DETALHES DO INSTALADOR",
    "systemDescription": "Descrição do sistema",
    "systemStatistics": "Estatísticas do sistema",
    "settings": "Definições ",
    "account": "Conta",
    "support": "Suporte",
    "supportFaq": "Perguntas frequentes",
    "emergencySupport": "Entre em contato conosco",
    "contactUs": "Entre em contato conosco",
    "contactSupport": "Escreva para nós!",
    "devices": "Dispositivos",
    "addStorage": "Adicionar armazenamento",
    "devicesOld": "Dispositivos",
    "configure": "Configurar",
    "batteryStorage": "Armazenamento de bateria",
    "batteryStorageNewMenu": "Bateria",
    "connectivity": "Conectividade",
    "connectGateway": "Conectividade",
    "batteryReserve": "Reserva de bateria",
    "expertModeEdit": "Modo Avançado",
    "eventsHistory": "Histórico de eventos",
    "backupHistory": "Histórico de backup",
    "outageHistory": "Outage History",
    "event": "Evento",
    "events": "Eventos",
    "totalEvents": "Total de eventos",
    "totalBackup": "Do backup total",
    "backupDuration": "Duração do backup",
    "hours": "horas",
    "minutes": "minutos",
    "siteDetails": "Detalhes do local",
    "wifi": "Tipo de ligação",
    "liveVitals": "Sinais vitais ao vivo",
    "envoy": "Gateway",
    "envoyNotReport": "Gateway não reportando",
    "microInverterNotReporting": "Microinversores não reportando",
    "enpowerNotReporting": "Controlador do sistema não reportando",
    "enchargeNotReporting": "Bateria não reportando",
    "enchargeError": "Erro de bateria",
    "enpowerError": "Erro do controlador do sistema",
    "microinverters": "Microinversores",
    "stringInverters": "Inversor String",
    "storage": "Bateria",
    "reconnectToEnvoy": "Conectividade",
    "configureWiFi": "Configurar Wi-Fi",
    "envoyInternetConnection": "Para alterar a conectividade com a Internet do Gateway",
    "enpower": "Controlador do sistema",
    "theme": "Tema",
    "darkmode": "Tryb ciemny",
    "devmode": "Modo de desenvolvedor",
    "registerOjasBox": "Portable Energy System",
    "appUpdate": "Atualizações da App",
    "feedback": "Comentários",
    "logout": "Sair",
    "help": "Ajuda",
    "siteid": "ID do local",
    "visitTommorrowForReport": "Por favor, verifique novamente amanhã. A nuvem Enphase não coletou os dados necessários para criar relatórios.",
    "email_report": "Relatório por e-mail",
    "will_send": "Será enviado para",
    "ojasSurroundLight": "Luz envolvente",
    "ojasSurroundLightSt": "Modificar as definições de luz do dispositivo",
    "batterySubtitle": "Otimize a bateria com base no uso e na tarifa",
    "batteryEmeaSubtitle": "Otimize a bateria com base no uso",
    "connectivitySubtitle": "Altere a conectividade da Internet do Gateway",
    "generatorSubtitle": "Otimize o gerador com base nos cenários",
    "eventsHistorySubtitle": "Ver registo de eventos do sistema fundamentais",
    "backupHistorySubtitle": "Ver histórico de interrupção de potência",
    "registerOjasBoxSubtitle": "Register your Portable Energy System",
    "accountSubtitle": "Detalhes pessoais, idioma, definições de privacidade",
    "wifiSubtitle": "Largura de banda, dados de relatório a cada 15 minutos",
    "liveVitalsSubtitle": "Ver estado vivo do sistema",
    "themeSubtitleOn": "O modo escuro está ligado",
    "themeSubtitle": "O modo escuro está desligado",
    "devmodeSubtitle": "Opções do modo de programador",
    "appUpdateSubtitle": "Notas de versão para as mais recentes atualizações e notas de atualização",
    "appUpdateSuccessSubtitle": "O aplicativo está atualizado",
    "requestReplacement": "Solicitar reposição",
    "changeShippingAddress": "Mudar endereço de entrega",
    "tariffEditor": "Taxa de eletricidade",
    "tariffEditorNewMenu": "Taxa de eletricidade",
    "currencyConversion": "Moeda equivalente",
    "currencyConversionNewMenu": "Moeda",
    "currencySubtitle": "Converte os dados de energia em taxas de moeda equivalentes",
    "showCurrency": "Exibir moeda equivalente",
    "showCurrencySubtitle": "Turn on to show conversion widget",
    "passwordReset": "Redefinição de senha",
    "tariffAdded": "Ver/editar a estrutura da taxa de eletricidade do seu serviço público",
    "showCurrencySubtitleOff": "Desative para ocultar o widget de moeda",
    "tariffNotAdded": "Estrutura da taxa de eletricidade não adicionada",
    "enlightenManager": "Visualizar no Enlighten Manager (Gerenciador do Enlighten)",
    "sgipIncentive": "Incentivo de armazenamento (SGIP)",
    "gridServices": "Serviços de rede elétrica",
    "enphaseHome": "Recém chegado de mudança a uma casa que tenha o Enphase",
    "systemAccess": "Tudo configurado, mas precisa de acesso ao sistema",
    "woSiteSystemAccess": "Acesso ao sistema",
    "enphaseProducts": "Saiba mais sobre os produtos da Enphase",
    "enphaseTeam": "Obter ajuda da equipe Enphase",
    "gridSwitch": "Controlo da rede",
    "onGrid": "Na rede",
    "chatWithUs": "Fale conosco",
    "referFriends": "Indicar Amigos",
    "referralTnC": "Termos e Condições",
    "hello": "Olá",
    "homeControls": "Controlos de início",
    "systemDetails": "Sistema",
    "pesDetails": "System",
    "community": "Comunidade",
    "settingsMenu": "Definições",
    "enphaseStore": "Armazenamento Enphase",
    "upgrades": "Atualizações",
    "services": "Serviços",
    "generatorSubtitle2": "Controlar o gerador quando em Off-grid",
    "devicesSubtitle": "Ver todos os dispositivos e o seu estado",
    "siteDetailsSubtitle": "Ver o Site e os detalhes do instalador",
    "reportsSubtitle": "Gerar e enviar relatórios",
    "appSettings": "Definições da app",
    "accountSettings": "Definições da conta",
    "addStorageSubtitle": "Adicionar armazenamento para evitar apagões",
    "addSolarPanels": "Adicionar painéis solares",
    "addSolarPanelsSubtitle": "Aumentar o seu consumo próprio",
    "sgipIncentiveSubtitle": "Candidatar-se ao incentivo SGIP",
    "gridServicesSubtitle": "Ganhar benefícios ao contribuir para a rede com a IQ Battery",
    "incentives": "Incentivos",
    "accountMenu": "Conta",
    "myInformation": "As minhas informações",
    "myNotificationPreferences": "As minhas preferências de notificação",
    "myPrivacy": "A minha privacidade",
    "myAccessControl": "O meu controlo de acesso",
    "myInformationSubtitle": "Atualizar dados pessoais e do sistema",
    "myNotificationPreferencesSubtitle": "Gerenciar minhas notificações",
    "myPrivacySubtitle": "Controlar como o Enphase utiliza as informações do sistema",
    "myAccessControlSubtitle": "Gerir o acesso aos dados do sistema",
    "systemSettings": "Definições do sistema",
    "deviceSettings": "Definições do dispositivo",
    "wirelessRangeExtender": "Amplificador de sinal sem fio",
    "cacheAction": "Limpar o cache local",
    "cacheResult": "Navegar pelos dados apagados de energia",
    "noActiveNotices": "Não existem avisos ativos para si.",
    "appInfo": "Informação sobre a App",
    "whatsNew": "Novidades",
    "privacyPolicy": "Política de Privacidade",
    "tos": "Condições do Serviço",
    "rateUs": "Avalie-nos",
    "gridToggle": {
      "infoPopupTitle": "Sistema de reserva de luz solar",
      "infoPopupContentP1": "O seu sistema é um sistema de reserva de luz solar e mudar para o modo \"Fora da rede\" não é recomendado no período sem luz solar.",
      "pIt1": "Quando o sistema entra no modo \"Fora da rede\", as cargas não essenciais serão desligadas da alimentação.",
      "pIt2": "Entrar no modo \"Fora da rede\" só é possível durante as horas em que as cargas essenciais tenham alimentação agendada em %{scheduledMode}.",
      "pIt3": "O seu sistema pode ser desligado no modo \"Fora da rede\" se não houver luz solar suficiente.",
      "scheduledMode​": "Modo agendado",
      "infoPopupContentP2": "Quando o sistema entra no modo \"Fora da rede\", as cargas serão desligadas da fonte de alimentação, exceto as cargas essenciais. Mudar para o modo \"Fora da rede\" não é permitido fora das horas agendadas. O seu sistema pode ser desligado no modo \"Fora da rede\" se não houver luz solar suficiente."
    },
    "ojas": {
      "ojasBoxInfo": "Run the devices on the go with Portable Energy System, your personal portable energy system designed exclusively for home backup and outdoor Off grid use.",
      "ojasTitleQuestion": "Don't have the Portable Energy System yet?",
      "knowurOjas": "Conheça o seu dispositivo",
      "enphasePESSubheading": "Enphase Portable Energy System",
      "enphasePESDesc": "PES is designed exclusively for your home backup and outdoor energy needs ",
      "enphasePESKnowMore": "Know more",
      "enphasePESTitle": "Portable Energy System",
      "enphasePESDescription": "Leve a sua energia consigo. Energia segura em movimento.",
      "enphasePESConnectDevice": "Ligar um dispositivo",
      "enphasePESLearnMore": "Saber mais",
      "enphasePESBuy": "Buy",
      "enphasePESConnect": "Connect",
      "registerYourOjasBox": "Registe o seu dispositivo",
      "buyOjas": "Buy Portable Energy System",
      "registerOjasInfo": "Certifique-se de que o Bluetooth do seu telefone está ligado.",
      "registerStep1": "Login/Cadastre-se na conta Enphase",
      "registerStep2": "Emparelhe o seu dispositivo e o telefone via Bluetooth​",
      "registerStep3": "Dê um nome ao seu dispositivo",
      "registerStep4": "Podłącz urządzenie do sieci Wi-Fi​",
      "register": "Registar",
      "start": "Iniciar",
      "later": "Mais tarde",
      "fserialNumber": "Introduzir n.º de série",
      "enterSeriaNumber": "Enter Portable Energy System Serial No.",
      "collectName": "Nome do dispositivo",
      "enterBoxName": "Nome do dispositivo",
      "connectToWiFi": "Conecte o dispositivo à rede Wi%{nbh}Fi",
      "connectToWiFiNotice": "Selecione a sua rede Wi-Fi preferida e introduza a palavra-passe.",
      "takeFewMinutes": "Isto pode demorar alguns minutos",
      "connectingToWifi": "Ligar a Wi-Fi",
      "pleaseContactSupport": "Contacte a assistência para ajuda.",
      "unableToCompleteConnect": "Não foi possível concluir a ligação",
      "incomplete": "Incompleta",
      "congratulations": "Parabéns!",
      "incorrectPasswordTryAgain": "Palavra-passe incorreta. Tente novamente",
      "yourOjasBox": "Your Portable Energy System",
      "isRegistered": "está registrada",
      "startMonitoring": "Iniciar a monitorização",
      "turnOnBluetoothOnNotice": "Turn on your phone’s Bluetooth to connect with your Portable Energy System.",
      "scanningForOjasDevices": "Scanning for Portable Energy System",
      "noOjasDevicesFound": "Nenhuma Estação Portátil de Alimentação encontrada",
      "noOjasAroundNotice": "No Portable Energy Systems could be found. Make sure that your device is switched on and you are near it. If the problem persist",
      "incorrectPassCode": "Código incorreto",
      "incorrectPassCodeNotice": "Unable to match the code with any of the surrounding Portable Energy Systems.",
      "capturingDeviceDetails": "Captar detalhes do dispositivo",
      "capturedDeviceDetails": "Detalhes do dispositivo captados",
      "capturedDeviceDetailsNotice": "Connect Portable Energy System to Wi-Fi",
      "registrationError": "Erro de registo",
      "registrationErrorNotice": "Tente novamente registar-se. Se o problema persistir, ",
      "deviceAlreadyRegistered": "O dispositivo já está registado",
      "deviceAlreadyRegisteredNotice": "Este Sistema Portátil de Energia já está cadastrado em outra conta enphase.",
      "proceed": "Avançar",
      "rename": "Atribuir novo nome",
      "nameAlreadyExist": "O nome já existe",
      "nameAlreadyExistNotice": "This name already exists for an Portable Energy System registered with this account. Please use different name.",
      "bluettoothConnected": "Ligação bluetooth estabelecida!!",
      "enter4DigitCode": "Introduza o código de 4 dígitos",
      "bluetoothCodeDetail": "The 4 digit code displayed on your Portable Energy System`s display screen",
      "resendBluetoothCode": "Reenviar código",
      "connWithOJASBLE": "Conecte a Estação Portátil de Alimentação via Bluetooth",
      "noBLEDevicesFound": "Nenhum dispositivo Bluetooth encontrado",
      "backupTime": "Tempo de backup",
      "timeToCharge": "Tempo de carga",
      "powerSaving": "Economia de energia,",
      "poweredOn": "Ligado",
      "powerOn": "Ligar",
      "powerOff": "Desligar",
      "close": "Fechar",
      "powerSavingHeader": "O dispositivo está em modo de economia de energia",
      "powerOnHeader": "O dispositivo está ligado",
      "powerSavingSubHeader": "(saída CA desativada)",
      "powerSavingContent": "É possível, remotamente, ligar e ativar a saída CA ou desligar o dispositivo e desativar todas as entradas e saídas da fonte de alimentação.",
      "powerOnContent": "É possível, remotamente, desligar o dispositivo e desativar todas as entradas e saídas da fonte de alimentação.",
      "shuttingDown": "Desligamento",
      "topenojas": "Select Portable Energy System from the drop-$splitdown list to start monitoring.",
      "foundDevice": "Portable Energy System found",
      "pps": "Portable Energy System",
      "lightSettings": {
        "light": "Light",
        "on": "Always On",
        "off": "Always Off",
        "auto": "Automatic",
        "onMsg": "Stays On",
        "autoMsg": "Turns on when someone is nearby",
        "offMsg": "Stays Off"
      },
      "ojasConnectivity": {
        "1_title": "O dispositivo não está conectado ao aplicativo Enphase!",
        "1_description": "Certifique-se de que seu dispositivo esteja ligado e conectado à rede Wi-Fi. Caso esteja próximo do dispositivo, é possível emparelhar o telefone com o dispositivo via Bluetooth.",
        "1_action": "Conectar via Bluetooth",
        "3_title": "Bluetooth não suportado!",
        "3_description": "Bluetooth não é compatível com o seu dispositivo. Verifique se o dispositivo apresenta as opções de Bluetooth e Localização.",
        "4_title": "Ligue o Bluetooth",
        "4_description": "Turn on your phone’s Bluetooth to connect with your Portable Energy System.",
        "5_title": "Buscando por dispositivos Bluetooth...",
        "7_title": "Dispositivos Bluetooth",
        "8_title_success": "Nenhum dispositivo Bluetooth encontrado",
        "8_title_error": "O problema persistiu durante a busca.",
        "8_title_noUnits": "No Units nearby",
        "8_description": "No PES devices could be found. Make sure that your device is switched on and you are near it. If the problem persist.",
        "9_title": "Estabelecer ligação Bluetooth...",
        "10_title": "Insira o PIN de prova de possessão para",
        "10_subTitle": "PIN de prova de possessão",
        "11_title": "Conexão via Bluetooth estabelecida!",
        "11_description_1": "Bluetooth connection with your Portable Energy System::",
        "11_description_2": " está estabelecida com sucesso.",
        "12_title": "Bluetooth não está conectado.",
        "12_description_1": "Bluetooth connection with your Portable Energy System:",
        "12_description_2": " falhou. Tente novamente.",
        "13_title": "Buscando por redes Wi-Fi...",
        "14_title": "Ligar o PES à Wi-Fi",
        "14_description": "Selecione a sua rede Wi-Fi e introduza a palavra-passe.",
        "15_title": "Wi-Fi Networks",
        "15_title_success": "Não foi encontrada rede Wi-fi.",
        "15_title_error": "O problema persistiu durante a busca.",
        "15_description": "Keep the Wi-Fi router on and your Portable Energy System unit in the Wi-Fi range.",
        "18_title_1": "Enviando credenciais do Wi-Fi",
        "18_title_2": "Aplicando conexão Wi-Fi",
        "18_description": "provisionado com sucesso,",
        "19_title": "Incompleta!",
        "19_description": "Unable to complete the connection with Portable Energy System:"
      },
      "deviceId": "Identificador do dispositivo",
      "ojasSettings": {
        "profile": "Perfis",
        "acPorts": "Portas de CA",
        "dcPorts": "Portas de CC",
        "on": "Ativado",
        "off": "Desativado",
        "brightnesSettings": {
          "brightness": "Luminosidade",
          "customBrightness": "Luminosidade predefinida",
          "auto": "Ajustar automaticamente a luminosidade"
        },
        "lightSettings": {
          "light": "Luz",
          "on": "Sempre ligado",
          "off": "Sempre desligado",
          "auto": "Automático",
          "onMsg": "Ficar Ligado",
          "autoMsg": "Ativa-se quando há alguém por perto",
          "offMsg": "Mantém-se desligado"
        },
        "powerSettings": {
          "mode": "Power Mode",
          "powerON": "Ligar",
          "powerOff": "Desligar",
          "powerSave": "Poupança de energia"
        },
        "ojasModes": {
          "on": "Todas as portas de CA e CC estão ligadas. Mantenha o dispositivo neste modo se tiver ferramentas ou aparelhos ligados à porta de CA.",
          "save": "Apenas as portas de CA estão ligadas e prontas para ligar dispositivos eletrónicos. Este modo poupa energia porque as portas de CA estão desligadas.",
          "off": "Todas as fontes de alimentação de entrada e saída serão desligadas."
        },
        "displaySetting": "Display Settings",
        "deviceSetting": "Device Settings",
        "appSetting": "App Settings"
      }
    },
    "iq8dEditSavings": "Poupanças",
    "appTutorialPage": {
      'all-topics-empty': 'Nenhum tópico disponível',
      'videos-empty': 'Nenhum vídeo disponível',
      'articles-empty': 'Nenhum artigo disponível',
      'noResults': "Nenhum resultados para \"%{searchValue}\""
    }
  },
  "environmentCard": {
    "title": "Ambiente",
    "label": "Impacto ambiental",
    "rightText": "Fonte: epa.gov",
    "equivalent": "Equivalente",
    "planted": "PLANTADA(S)",
    "carbon_offset": "COMPENSAÇÃO DE CARBONO",
    "charged": "CARREGADO",
    "trees": {
      "zero": "árvores",
      "one": "árvore",
      "other": "árvores"
    },
    "phone": {
      "one": "telefone",
      "other": "telefones"
    },
    "tonne": {
      "one": "tonelada",
      "other": "toneladas"
    },
    "lb": {
      "one": "libra",
      "other": "libras"
    },
    "ton": {
      "one": "tonelada",
      "other": "toneladas"
    }
  },
  "connectionType": {
    "wifi": "Wi-Fi",
    "cellular": "Modem da célula",
    "ethernet": "Ethernet",
    "reportsAt15Mins": "Comunica dados a cada 15 min",
    "reportsAt6Hrs": "Comunica dados a cada 6 h",
    "idle": "Inativo",
    "notAvailable": "Não disponível",
    "configureWiFiSettings": "Configurar definições sem fios",
    "configureWiFiSettings2": "Configurar",
    "switchToWiFi": "Mudar para Wi-Fi",
    "connectToWiFi": "Ligar a Wi-Fi",
    "bluetooth": 'Bluetooth',
    "bluetoothOff": 'Bluetooth DESLIGADO'
  },
  "details": {
    "connection_type": "Tipo de ligação",
    "description": "Descrição do sistema",
    "installer": "Instalado por",
    "maintainer": "Gestor do sistema",
    "micros": {
      "one": "Microinversor",
      "other": "Microinversores"
    },
    "acbs": {
      "one": "Bateria",
      "other": "Baterias"
    },
    "arrays": {
      "one": "Arranjo",
      "other": "Arrays"
    }
  },
  "notices": {
    "enlighten": "Enlighten"
  },
  "layout": {
    "more_yesterday": "% superior à de ontem na mesma altura",
    "less_yesterday": "% inferior à de ontem na mesma altura",
    "same_yesterday": "Semelhante à de ontem na mesma altura",
    "more_last_year": "% superior à do ano passado na mesma altura",
    "less_last_year": "% inferior à do ano passado na mesma altura",
    "same_last_year": "Semelhante à do ano passado na mesma altura",
    "more_yesterday_prev": "% a mais do que esta hora do dia anterior",
    "less_yesterday_prev": "% menos do que esta hora do dia anterior",
    "same_yesterday_prev": "Quase o mesmo que esta hora do dia anterior",
    "more_last_year_prev": "% a mais do que esta vez no ano anterior",
    "less_last_year_prev": "% menos do que esta vez no ano anterior",
    "same_last_year_prev": "Quase o mesmo que este ano passado",
    "system": "Sistema",
    "emptyArray": "Nenhum desenho do arranjo disponível",
    "storageArray": "Painel de armazenamento",
    "solarArray": "Painel solar",
    "contactInstForpersonalizedLayout": "Entre em contato com o instalador para obter visualização personalizada do conjunto de armazenamento",
    "cntcInstPopP1": "O conjunto de armazenamento mostra a imagem das unidades de armazenamento instaladas em sua casa, junto com os níveis de carga.",
    "cntcInstPopP2": "Entre em contato com o instalador para criar um conjunto de armazenamento no aplicativo Installer Toolkit ou no aplicativo Enlighten Manager para obter uma visualização personalizada"
  },
  "support": {
    "enphase": "Suporte da Enphase",
    "enphaseLink": "Suporte da Enphase",
    "maintainer": "Suporte e manutenção do sistema",
    "maintainerLink": "Contato do Gestor",
    "contactEnphase": "Contactar a Enphase",
    "enphaseSupport": "Suporte da Enphase",
    "ensembleSupport": "Entre em contato com o Suporte do Ensemble",
    "writeToUs": "Escreva para nós!",
    "visitSupport": "Visite o site do Suporte",
    "talkToUs": "Fale conosco",
    "talkToUsAnytime": "Fale conosco a qualquer momento",
    "customerSupport24by7": "Suporte ao cliente 24/7",
    "needHelpTitle": "Como Podemos Ajudar",
    "envoyNotReporting": "Sistema ou Gateway não reportando",
    "microinvertersNotReporting": "Microinversores não reportando",
    "productionIssue": "Problema de produção",
    "productionDifference": "Diferença em produção por painel",
    "needMoreHelpTitle": "Precisa de mais ajuda",
    "askEnphaseCommunity": "Pergunte à Comunidade da Enphase",
    "browseTopics": "Pesquise em todos os tópicos de ajuda",
    "chatWithUs": "Fale conosco",
    "contactUs": "Entre em contato conosco",
    "helpTopics": "Tópicos de ajuda",
    "brwsAllFaqs": "Procurar todas as FAQ",
    "askEnphaseCommunitySubtitle": "Contacte outros clientes Enphase perto de si",
    "systemOwnerGuide": "Consulte o guia do proprietário do sistema",
    "faq": {
      "usingManualOverride": "Utilizar o cancelamento manual",
      "understandingEnpower": "Compreender o IQ System Controller",
      "understandingEncharge": "Compreender o IQ Battery",
      "understandIQCombiner": "Entendendo o IQ Combiner, Gateway, Comms Kit e Celular Modem",
      "stormGaurdFeatureDetails": "Detalhe da função de proteção contra tempestade",
      "settingElectricityRateStructure": "Definir a estrutura da taxa de eletricidade",
      "recoverShutdownLL": "Recuperar de desligamento devido a cargas grandes",
      "recoverShutdownCF": "Recuperar de desligamento devido a falha de comunicações",
      "recoverShutdownBD": "A recuperar de um desligamento devido ao esgotamento da bateria",
      "PowerHomeInBCK": "Alimentar as cargas domésticas em reserva",
      "partialHomeBCK": "Configuração de reserva doméstica parcial",
      "monitorUrSys": "Monitorizar o seu sistema",
      "mngLgApplianceBck": "Gerir grande aparelhos em reserva",
      "incentivesAvlbTou": "Incentivos disponíveis para si",
      "grdTrnxToOffGrd": "Transição de rede para fora da rede",
      "allHomeBck": "Reserva doméstica total",
      "envLEDstatus": "Status do LED do Gateway",
      "dsgnUrSys": "Desenhar o seu sistema",
      "cntctCustSupp": "Contactar o seu apoio ao cliente",
      "batSmrtPrfSel": "Seleção de perfil inteligente da bateria",
      "accsEnchrgDcswtch": "Acessando a chave CC da bateria",
      "mcrInvNtReprt": "O microinversor não está a responder",
      "sysEnvNtReprt": "Gateway não reportando",
      "hwUrSysWrk": "Como funciona o seu sistema?",
      "enchrLedStatus": "Status do LED da bateria",
      "noPwNebDo": "A minha alimentação está desligada mas a rede está ligada",
      "consBatDurGridOut": "Poupar a vida da bateria durante uma interrupção da rede",
      "emgSupCallSteps": "Selecione 2 para suporte ao cliente e 1 para proprietários de sistema. Selecione 2 no submenu para suporte de armazenamento.",
      "preLoginCallSteps": "Selecione 2 para Suporte ao cliente ou selecione 4 para Vendas.",
      "sysProdIssue": "Problema de produção do sistema",
      "diffInPerPanProd": "Diferença em produção por painel",
      "installCellModem": "Guia de instalação do modem celular",
      "whatIsEI": "Classificação da independência energética",
      "howEnHomeEngSysWork": "Como é que o sistema de energia doméstica funciona?",
      "understandEnv": "Entendendo o Gateway",
      "findEnv": "Procurando meu Gateway",
      "envReplaced": "Gateway foi susbtituído",
      "rebootEnv": "Reiniciando ou reinicializando o Gateway",
      "hwChangeEmail": "Como altero o meu endereço de correio eletrónico?",
      "hwResetPasswd": "Como restabeleço a minha palavra-passe?",
      "accessEnvLocalIntf": "Acessando a interface local do Gateway",
      "envLocIntfLogCred": "Credenciais de login da interface local do gateway",
      "hwDisbaleNotification": "Como ativo e desativo relatórios mensais do Envoy e outras notificações de correio eletrónico?",
      "MontEngProd": "Monitorizar a minha produção de energia",
      "whyNotSeeConsumption": "Porque não consigo ver o meu consumo?",
      "hwMonConsumpt": "Como monitorizo o meu consumo doméstico?",
      "calEngUsageWoConsumptionMonitoring": "Calcular a minha utilização de energia sem monitorização de consumo",
      "undersNetEng": "Compreender a energia líquida",
      "understTrueUpStmt": "Compreender uma declaração verdadeira",
      "diffPaidENLMvsPerpanelDataaoffering": "Diferença entre o Enlighten Manager pago e a oferta de dados de energia do painel gratuita",
      "blkInPerpanMon": "Painel preto em vista por painel",
      "gryorBlnkInPerpanMon": "Painel cinzento (em branco) em vista por painel",
      "hwToMovePnl": "Como movo um painel?",
      "hwfindInst": "Como procuro um novo instalador?",
      "whtdoIfonePanelNotreproduc": "O que devo fazer se um dos painéis estiver a produzir abaixo da produção ou a não produzir?",
      "haveaSelfPoweredHome": "O que significa ter uma casa autoalimentada?",
      "yourSystemPaysForItself": "Durante quanto tempo o seu sistema se paga a si próprio?",
      "enphaseSystemsAreSafe": "Porque é que os sistemas da Enphase são seguros?"
    },
    "webBackButton": "Retroceder",
    "supportHistory": "Histórico de apoio"
  },
  "evse": {
    "tariffErr": "Please input your %{tariff} details to be able to view the suggested schedule to charge your Electric Vehicle",
    "errfail": "Unable to display suggested schedule. Please try reloading the page after some time.",
    "errcons": "Unable to suggest charging schedule because of insufficient consumption data",
    "errprod": "Unable to suggest charging schedule because of insufficient production data",
    "errprodcons": "Unable to suggest charging schedule because of insufficient consumption and production data",
    "addev": "Adicionar um VE",
    "addevSub": "Diga-nos se está a utilizar um sistema Enphase para carregar o seu VE para que possamos oferecer-lhe informações e recomendar os períodos ideais para carregar o seu veículo de forma eficiente.",
    "haveEv": "Tenho um VE.",
    "qbrand": "Qual é a marca do seu VE?",
    "qbrandErr": "*The above field is mandatory",
    "qmodel": "Qual é o nome do modelo do seu VE?",
    "diffcharger": "Carrego o meu VE em casa utilizando o carregador de outra empresa",
    "qcharger": "Qual é a marca do seu carregador?",
    "qcapacity": "Qual é a capacidade da bateria do seu VE (em kWh)?",
    "notcompulsory": "*esta pergunta não é obrigatória. Pode ignorar se não souber.",
    "qtime": "Quando carrega o seu veículo?",
    "morning": "De manhã",
    "afternoon": "À tarde",
    "evening": "Ao fim do dia",
    "night": "Durante a noite",
    "other": "Outro (especifique)",
    "qmiles": "Quantos quilómetros normalmente percorre num dia?",
    "brand": "Detalhes da marca",
    "tech": "Detalhes técnicos",
    "operational": "Detalhes operacionais",
    "ev": "Veículo elétrico:",
    "suggsch": "Agendamento sugerido",
    "suggschInfo": "The schedule to charge your electric vehicle is suggested based on your battery profile, production forecast and electricity rate.",
    "charge": "To charge your electric vehicle",
    "weekday": "For Mon, Tue, Wed, Thur & Fri",
    "weekend": "For Sun & Sat",
    "everyday": "Everyday",
    "removeEV": "Remover veículo elétrico",
    "userfail": "Unable to display Electric Vehicle details!",
    "userfailDesc": "We are unable to display your Electric Vehicle details because of some technical issues. Please try again after sometime."
  },
  "storage": {
    "stormGuardEnablePopUpHeader": "Habilitar Storm Guard",
    "stormGuardEnablePopUpFooter": "Quer habilitar o Storm Guard?",
    "stormGuardDisablePopUpHeader": "Desativar Storm Guard",
    "stormGuardDisablePopUpFooter": "Você ainda deseja desativar o Storm Guard?",
    "backupTime": "Tempo de reserva",
    "encharge_battery": "Selecione um perfil inteligente para controlar sua bateria",
    "encharge_battery_emea": "Perfil inteligente para controlar sua bateria",
    "savings": "Modo economia de energia",
    "expert": "Modo Avançado",
    "self-consumption": "Auto - Consumo",
    "battery_bkup": "Backup completo",
    "savings_text": "Minimize o uso de eletricidade da rede elétrica quando a tarifa de eletricidade estiver alta. Durante os horários de pico, sua casa é energizada na seguinte ordem de prioridade: bateria, solar e rede elétrica. Qualquer energia solar extra é exportada para a rede elétrica.",
    "savings_mode_notSet": "Aumenta a sua Poupança de Energia com base nas suas taxas de eletricidade",
    "savings_mode_dc_tou": "Solar e a bateria são utilizados durante as horas de ponta para minimizar a importação de eletricidade da rede.",
    "savings_mode_dc_all_day": "Durante as horas de ponta, a energia solar é exportada para a rede. A bateria alimenta a sua Casa até atingir a carga de reserva.",
    "viewElectricityRate": "Ver Taxas de Eletricidade",
    "optForDC": "Otimizado para a Poupança de Energia da Taxa de Potência",
    "optForIncExport": "Otimizado para Aumentar a Exportação",
    "consumption_text": "Utilize a energia solar armazenada para alimentar sua casa após o pôr do sol. A bateria é usada quando a energia solar não está disponível.",
    "consumption_text_pv_yield": "Carregue a bateria durante as horas de pico de produção para otimizar a produção fotovoltaica. A bateria é usada quando a energia solar não está disponível.",
    "bkup_text": "100% da bateria é reservada para backup.",
    "reserve": "Reserva",
    "optimization": "Otimização baseada em",
    "utility_rates": "Tarifas da concessionária",
    "increase_consumtion": "Aumentar o autoconsumo para",
    "max_consumption": "Maximize a independência energética",
    "optimize_pv_production": "Otimize a produção fotovoltaica",
    "activate": "Ativar",
    "active": "Ativo",
    "save": "Guardar",
    "edit": "Editar",
    "error": "Não é possível salvar as definições de armazenamento.",
    "requestTakingLonger": "O pedido está a demorar mais do que o esperado. Verifique novamente mais tarde",
    "batterySettingsTakingLonger": "A atualização das definições da bateria atualizadas está a demorar mais do que o esperado. Verifique novamente mais tarde",
    "completed": "As configurações da bateria foram atualizadas com sucesso.",
    "completedAdvance": "Configurações avançadas da bateria atualizadas com sucesso.",
    "requestPending": "Pedido pendente. Aguardando confirmação do gateway. Por favor, volte mais tarde.",
    "editRequest": "Você tem uma solicitação ativa. Por favor, aguarde a confirmação ou cancele a solicitação para seguir com a seleção.",
    "editRequestVls": "Você tem uma solicitação ativa nas configurações avançadas da bateria. Aguarde a confirmação ou cancele a solicitação para prosseguir com a seleção.",
    "cancelRequest": "Solicitação foi cancelada.",
    "timeoutRequest": "O seu pedido chegou ao fim de tempo. Tente novamente mais tarde",
    "updatedSuccesfully": "Atualizado com sucesso",
    "pendingRequestText": "pedido pendente",
    "cancelRequestText": "Cancelar pedido",
    "pendingText": "Pendente",
    "processingText": "A processar",
    "battery_reserve": "da energia armazenada será reservada para backup",
    "cancelFailed": "Falha ao cancelar tarefa.",
    "noPendingTask": "O sistema não tem nenhuma tarefa pendente para cancelar",
    "noEncharges": "O sistema não tem baterias",
    "severeWeatherText": "Proteção contra tempestade",
    "disabled": "Desativado",
    "enabled": "Ativado",
    "weatherWatchDescription": "Cancela o seu perfil de bateria para o modo Reserva completa quando é emitido localmente um alerta de condições climáticas severas.",
    "disabledModeInfo": "Quando ativado, o Enphase se comunica com o {%s} para detectar alertas de eventos climáticos severos e define seu perfil de bateria para o modo de backup completo para fornecer backup durante o evento. Após o evento ter passado, o perfil da bateria retornará à configuração anterior.",
    "enabledModeInfo": "O Enphase se comunicará com o {%s} para detectar alertas de eventos climáticos severos e definirá seu perfil de bateria para o modo de backup completo. Após o evento, o perfil da bateria retornará à configuração anterior.",
    "activeModeInfo": "O Enphase detectou um alerta de evento climático severo do {%s} e seu perfil de bateria está definido para o modo de backup completo. Após a hora de término do evento, o perfil da bateria retornará à configuração anterior.",
    "stormGuardModeInfo": "Quando no %{status}, a função Proteção contra tempestade monitoriza alertas de condições climáticas severas emitidos por %{nws}. Cancela o seu perfil de bateria para o modo ‘Full Backup’ se for emitido localmente um alerta. Isto permite que toda a sua capacidade de bateria seja reservada para uso durante uma possível interrupção da rede.%{nl}Se um alerta for emitido para a sua localidade, então 'Alerta de tempestade: Ligado' será exibido em 'Profile' na página Estado e na página Estado em direto.%{nl}Quando o alerta terminar, o perfil da bateria regressará às configurações anteriores.",
    "editActiveWeatherAlert": "A Proteção contra tempestades está ativa. Aguarde que o evento passe (recomendado) ou desative a proteção contra tempestades para seguir com a seleção.",
    "enabledToActiveAlert": "O Enphase detectou um alerta de evento climático severo do serviço meteorológico nacional e seu perfil de bateria será definido para o modo de backup completo. Após a hora de término do evento, o perfil da bateria retornará à configuração anterior.",
    "activeToEnabledAlert": "O evento passou e o perfil da bateria retornará à configuração anterior.",
    "okayText": "OK, percebi!",
    "disclaimerText": "A função Proteção contra tempestade utiliza informações provenientes da administração nacional oceânica e atmosférica dos EUA/serviço nacional de meteorologia, como (sem limitação) alertas meteorológicos severos, que as informações são de domínio público e não estão sujeitas à proteção de direitos de autor. A Enphase não reclama deter ou controlar tais informações. Acorda expressamente que a utilização desta função é de seu próprio risco. E assume o risco total relacionado com a ativação desta função e subsequente utilização. A Enphase fornece tais informações através do recurso de proteção contra tempestade \"como está\", e isenta toda e qualquer garantia, expressa ou implícita, incluindo (sem limitação) quaisquer garantias implícitas de comercialização ou aptidão para um propósito específico. Em caso algum a Enphase será responsável perante si ou terceiros por quaisquer danos indiretos, incidentais, consequentes, especiais ou exemplares ou de perfil perdido resultante de qualquer uso ou uso indevido desses dados.",
    "disclaimer": "Exoneração de responsabilidade",
    "agreeText": "Concordar & Continuar",
    "disagreeText": "Discordo",
    "nationalWeather": "Instituto Nacional de Meteorologia (INMET)",
    "dataNotAvailable": "N/D",
    "errorTitle": "Fahla",
    "errorCode": "Código de erro",
    "thresholdError": "Erro ao reportar",
    "PopupError": "Sua bateria S.NO",
    "thresholdPopupError": "Nenhum dado foi enviado no último ciclo de relatório. A porcentagem total de armazenamento, portanto, não inclui a porcentagem de armazenamento desta bateria. A bateria deve começar a enviar dados novamente a partir do próximo ciclo de relatório. Entre em contato com o suporte se o problema persistir.",
    "errorPopup1": "está apresentando um problema (Erro Des:",
    "errorPopup2": ", Código de erro:",
    "errorPopup3": "). Este evento de erro torna a porcentagem de armazenamento relatada desta bateria não confiável. Portanto, o percentual de armazenamento agregado mencionado acima exclui o percentual de armazenamento desta Bateria. Entre em contato com o Suporte se o problema persistir.",
    "contactSupport": "Contacte a assistência",
    "errorSubmitButton": "OK, percebi!",
    "microinvertorError": "O microinversor da bateria não está ativo",
    "microinvertorsError": "Microinversores de bateria não estão ativos",
    "touAlert": "O modo de poupanças funciona apenas se a taxa de importação de eletricidade variar com o tempo de utilização. Atualize a sua taxa de importação de eletricidade para ativar este modo.",
    "touAlert2": "Defina a sua taxa de importação de eletricidade como TdU e o seu plano de taxa de exportação como CEL para ativar o modo de poupança.%{nl}O modo de poupança funciona apenas se tiver uma contagem de energia líquida (CEL) e a sua taxa de eletricidade variar com tempo de utilização (TdU).",
    "touAlert3": "Defina a sua taxa de importação de eletricidade como TdU para ativar o modo de poupança",
    "touAlert4": "Defina a sua taxa de importação de eletricidade para ativar o modo de poupança",
    "updateElectricityRate": "Atualizar taxa de eletricidade",
    "batteryChangeAlert": "O perfil da sua bateria foi alterado para o modo Autoconsumo uma vez que o modo poupanças funciona apenas se a sua taxa de importação de eletricidade variar com o tempo de utilização.",
    "batteryChangeAlert2": "O perfil da sua bateria foi alterado para o modo de consumo próprio uma vez que o modo de poupança funciona apenas se tiver uma contagem de energia líquida (CEL) e a sua taxa de eletricidade variar com tempo de utilização (TdU).",
    "viewDetails": "Ver detalhes",
    "ok": "Ok",
    "systemRequest": "Os pedidos gerados pelo sistema não podem ser cancelados.",
    "featureDetailsButton": "Detalhe da função de proteção contra tempestade",
    "stormGuardEnablePopUp": "A ativação do Storm Guard permite que a capacidade total da bateria seja reservada para uso durante uma possível interrupção da rede, substituindo o perfil da bateria para 'Backup Completo' em caso de alertas de clima severo.",
    "stormGuardDisablePopUp": "Desativar Storm Guard não é recomendado. Em caso de alertas de clima severo, ele ajuda você a ficar protegido contra interrupções da rede relacionadas ao clima severo.",
    "batterySmartProfile": {
      "title": "Seleção de perfil inteligente da bateria",
      "description": "Saiba como escolher o perfil certo para o seu sistema de bateria",
      "viewDetails": "Ver detalhes"
    },
    "reserveDisclaimer": "A reserva da bateria não pode estar abaixo de  %{minSoc}%. Um mínimo de  %{minSoc}% de energia é armazenado na bateria para ativar cargas críticas da casa durante alguma interrupção da rede elétrica.",
    "eIpopDesc": "%{enabled}: A sua bateria descarregará para economizar dinheiro durante os horários de pico, quando as tarifas de eletricidade são altas. Ao final do horário de pico , a independência energética é prioridade. Isto aumentará a autosuficiência da sua energia até atingir a carga de reserva da bateria. A sua bateria carregará através de energia solar de manhã para ficar pronta para o próximo horário de pico.%{nl}%{disabled}: A sua bateria descarregará apenas durante horários de pico quando as tarifas de eletricidade são altas. Durante outros momentos, a sua bateria estará inativa ou carregará através de energia solar de manhã para ficar pronta para o próximo horário de pico.",
    "errActiveCostSave": "Ative o Modo Economia de Energia para utilizar esta função",
    "eiDescreption": "Independência de energia após horas de ponta",
    "advSetting": {
      "cfg": {
        "title": "Carregar a bateria a partir da rede",
        "descrDisable": "A sua bateria carrega a partir da energia solar.",
        "descrEnabled": "A sua bateria carrega a partir da energia solar. Também pode carregar a partir da rede pública quando a sua bateria se encontrar no modo “Reserva total” ou quando o nível da carga da bateria se encontrar abaixo da capacidade de reserva nos modos “Poupanças” ou “Autoconsumo”.",
        "descrEnabledFR": "A sua bateria irá carregar a partir da rede no intervalo agendado. A mesma não será descarregada durante este período.",
        "popUpDescrFR": "%{enabled}: A sua bateria irá carregar a partir da rede no intervalo agendado. A mesma não será descarregada durante este período. %{nl}%{disabled}: A sua bateria carrega a partir da energia solar.",
        "popUpDescr": "%{enabled}: A sua bateria carrega a partir da energia solar. Também pode carregar a partir da rede pública quando a sua bateria se encontrar no modo “Reserva total” ou quando o nível da carga da bateria se encontrar abaixo da capacidade de reserva nos modos “Poupanças” ou “Autoconsumo”.%{nl}%{disabled}: A sua bateria carrega a partir da energia solar.",
        "disclaimer": "Utilizar uma fonte de energia não renovável para carregar o seu sistema Enphase Storage poderá afetar a sua elegibilidade para obter o CFI. Consulte o seu consultor financeiro para obter mais informações.",
        "dlgTitle": "Carregar a partir da rede?",
        "dlgInfo": "Após a ativação, a sua bateria irá carregar a partir da rede no intervalo agendado. A mesma não será descarregada durante este período. Verifique os regulamentos dos serviços públicos antes de ativar esta opção.",
        "selfDeclrFR": "Compreendo que o carregamento a partir da rede pode ser contra os regulamentos da empresa de serviços públicos.",
        "selectSchedule": "Selecione o agendamento para carregar a sua bateria a partir da rede.",
        "titleFR": "Agendar carregamento a partir da rede",
        "saveSch": "Guardar agendamento",
        "chargeSch": "Agendamento de carregamentos",
        "selfDeclr": "Compreendo que a minha elegibilidade para obter o Crédito Fiscal de Investimento (CFI) pode ser afetada.",
        "disclaimer_itk": "O uso de uma fonte de energia não renovável para alterar o sistema Enphase Storage pode afetar a elegibilidade para reivindicar o ITC. Consulte o proprietário para obter sua aprovação",
        "selfDeclr_itk": "O proprietário reconhece que a capacidade de reivindicar o crédito fiscal do investimento pode estar comprometida.",
        "activeStormAlert": "Storm alert is on for your system. Please wait for the alert to end to update this setting."
      }
    },
    "exM": {
      "title": "Modo Avançado",
      "subTitle1": "Agendar perfis de baterias",
      "subTitle2": "Perfis de baterias agendados",
      "schedule": "Agendar",
      "tariffNotSetDlgtitle": "Taxa de Eletricidade não definida",
      "tariffNotSetDlgContent": "Defina sua tarifa de eletricidade para ativar o Modo de economia.%{nl}A Enphase precisa dos detalhes da sua tarifa para determinar a melhor programação para sua bateria.",
      "setRate": "Definir Taxa",
      "tariffUpdateDlgtitle": "Atualizar Taxa de Eletricidade",
      "tariffUpdateDlgContent": "O Modo Poupança funciona apenas se tiver o Medidor de Energia Líquida (NEM) e a sua taxa de eletricidade variar de acordo com o Tempo de Utilização (ToU).",
      "updateRate": "Atualizar Taxa",
      "setNemDlgTitle": "A Taxa de Exportação de Eletricidade não foi definida",
      "setNemDlgContent": "Defina a sua taxa de importação de eletricidade como NEM para ativar este modo.",
      "setNemCta": "Definir como NEM",
      "preview": "Pré-visualizar",
      "addBatProfile": "Adicionar Perfil da Bateria",
      "pViewPop": {
        "l1": "O gráfico retrata os perfis de baterias agendados para um período de 24 h.",
        "l2": "A reserva da bateria é apenas aplicável ao Autoconsumo e ao Modo Poupança. Em Reserva Total, a reserva da sua bateria será de 100%.",
        "l3": "Aumenta a sua Independência Energética",
        "l4": "Aumenta a sua Poupança de Energia com base nas suas taxas de eletricidade",
        "l5": "Permite uma poupança de energia da sua bateria de 100% para reserva",
        "batteryProfiles": "Perfis da Bateria"
      },
      "batReserveDisclaimer": "A reserva da bateria é apenas aplicável ao Autoconsumo e ao Modo Poupança. Em Reserva Total, a reserva da sua bateria será de 100%."
    },
    "prfAssist": {
      "t0": "Já está no perfil recomendado",
      "t1": "Nós recomendamos",
      "t2": "Modo de economia com baixa reserva de bateria e a independência de energia habilitada.",
      "t3": "Modo de economia com baixa reserva de bateria e a independência de energia desabilitada.",
      "t4": "Modo de autoconsumo com baixa reserva de bateria.",
      "t5": "Modo de autoconsumo com reserva de bateria moderada.",
      "t6": "Modo de backup completo.",
      "t7": "Modo de economia com alta reserva de bateria e a independência de energia desabilitada.",
      "t8": "Modo de autoconsumo com alta reserva de bateria.",
      "batResText": "Reserva de bateria entre",
      "learnHowEmea": "Saiba mais sobre o perfil da bateria",
      "learnHow": "Aprenda como funcionam os perfis de bateria",
      "editPref": "Editar preferências",
      "c1": "Poupar dinheiro",
      "c1Sub": "Maximizar as economias nas contas mensais",
      "c2": "Independência energética",
      "c2Sub": "Alimente a energia da sua casa por conta própria e seja ecologicamente correto",
      "c3": "Backup",
      "c3Sub": "Backup durante interrupções",
      "p1": "Prioridade máxima",
      "p2": "Prioridade secundária",
      "optional": "Opcional",
      "ques": "Quais são suas expectativas do sistema da Enphase?",
      "priority": "Arraste e solte as metas da mais importante para a menos importante.",
      "ftrpTutorialText": "Selecione e arraste os cartões para cima ou para baixo para organizá-los de acordo com sua prioridade. O primeiro cartão do topo representa a prioridade mais alta.",
      "updateBatteryProfile": "Atualize o perfil da Bateria",
      "activatedSavingsMode": "Sua bateria está atualmente no modo de economia com %{soc}% de reserva e a independência de energia após o horário de pico é %{eiStatus}.",
      "activatedSelfConsumptionMode": "YSua bateria está atualmente em autoconsumo com uma reserva de %{soc}%.",
      "activatedFullBackupMode": "Seu perfil de bateria atual é Backup completo.",
      "activatedSavingsModeWithoutSoc": "A sua bateria está atualmente no modo de poupança e a independência energética após as horas de ponta %{eiStatus}.",
      "activatedSelfConsumptionModeWithoutSoc": "A sua bateria está atualmente no modo de consumo próprio.",
      "activateProfile": "Você deseja ativar o perfil recomendado?"
    }
  },
  "envoy": {
    "all": "Todos os gateways",
    "pvAll": "Tudo",
    "dropDwnHelper": "Mostar dados de",
    "envSN": "NS do gateway:",
    "reconnect": "Por favor, reconecte seu Gateway.",
    "extraContent": "Enquanto isso, se você estiver próximo ao seu sistema, poderá conectar-se localmente ao Gateway para visualizar o status atual.",
    "btnText": "Saiba como se conectar ao Wi-Fi do Gateway",
    "getHelp": "Conecte seu Gateway novamente ao Wi-Fi ",
    "envoyConfirmation": "Conecte-se ao Gateway via modo AP para prosseguir.",
    "title": "Descobrimos que você está usando Envoy-S ou IQ Gateway e Wi-Fi.",
    "steps": "Siga as etapas para conectar o Gateway à rede Wi-Fi",
    "steps_ap": "Siga os passos para se ligar à rede do gateway",
    "ap_button": "Pressione o botão do modo AP",
    "ap_modeDescription": "Pressione e solte brevemente (não segure) o botão do menu Gateway abaixo do ícone do telefone. Isso ativará o Modo AP em seu Gateway, que cria uma rede sem fio à qual você pode se conectar com seu telefone.",
    "disable_data": "Desligue os dados móveis.",
    "disable_dataDescription": "Desligue os dados móveis (dados do celular) nas configurações de seu dispositivo móvel. Vá até Configurações > Dados móveis e desligue a opção correspondente.",
    "envoy_network": "Junte-se à rede do Gateway",
    "envoy_description": "Junte-se à rede do Gateway usando as configurações de Wi-Fi do seu telefone. Envoy_029655 é o nome da mini-rede na qual você ingressará, onde “029655” são os últimos seis dígitos do número de série do seu Gateway.",
    "home_wifi": "Conecte o Gateway ao Wi-Fi",
    "wifi_description": "Toque no botão configurar Wi-Fi e selecione a rede de sua casa e insira a senha da rede Wi-Fi.",
    "configure_wifi": "Configure o Wi-Fi de sua casa.",
    "cancel": "Cancelar",
    "stickyNotification": "Por favor, não toque no botão Voltar ou feche o aplicativo (você pode minimizá-lo) enquanto estiver tentando reconectar seu Gateway.",
    "enter_password": "Insira a senha para",
    "password": "Senha",
    "incorrect_password": "Senha incorreta",
    "wifi_failureMsg": "O gateway não pôde se conectar à sua rede Wi-Fi",
    "wifi_successMsg": "O gateway está conectado ao Wi-Fi com sucesso",
    "envoyConnectToCellular": "Agora você pode desconectar seu dispositivo móvel da rede Gateway e conectá-lo ao seu Wi-Fi / habilitar seus dados móveis.",
    "envoyToastMessage": "Seu Gateway está conectado com sucesso. Mas pode levar até 30 minutos para que o status do seu Gateway seja atualizado.",
    "wifi_congratsMsg": "Parabéns! Você está de volta online. Agora pode reconectar o dispositivo móvel à rede Wi-Fi de sua casa.",
    "tryagain": "tente novamente",
    "okay": "Ok, percebi",
    "failedToFetchWiFiNetworks": "Problema em encontrar redes Wi-fi. Tente novamente após algum tempo.",
    "noWifiNetworkFound": "Nenhuma rede Wi-fi encontrada. Reinicie o seu router Wi-Fi e tente novamente.",
    "option2": "Se as etapas acima não funcionarem, saiba como fazer isso manualmente",
    "learnhow": "Aprenda como",
    "ensureOn": "Certifique-se de que o Gateway está ligado",
    "connectToPower": "Certifique-se de que seu Gateway esteja conectado a uma fonte de alimentação."
  },
  "whatsnews": {
    "monitorTitle": "Monitor",
    "monitorContent": "Consulte a condição do sistema rapidamente com as principais métricas em uma única tela",
    "trackTitle": "Rastrear",
    "trackContent": "Rastreie e navegue pela visualização da produção de energia e tendências de consumo por dia, mês e ano ou total",
    "reportTitle": "Relatório",
    "reportContent": "Gere relatórios de produção e consumo de energia a partir do aplicativo por período: diário, semanal, mensal ou personalizado à sua escolha"
  },
  "theme": {
    "instructions": "Esquema de cores atual",
    "night": "noite",
    "day": "Dia"
  },
  "devices": {
    "model": "Model",
    "dryContactLoads": "Cargas",
    "generator": "Gerador",
    "noDeviceFound": "Nenhum dispositivo encontrado",
    "searchMicroinverters": "Procure pelo número de série dos Microinversores",
    "serialNumber": "NS (número de série)",
    "configure": "Configurar",
    "connect": "Conectar",
    "envoy": "Gateway",
    "microinverters": "Microinversores",
    "microinverter": "Microinversore",
    "stringInverters": "Inversor String",
    "storage": "Bateria",
    "enpower": "Controlador do sistema",
    "skuNumber": "SKU",
    "firmwareVersion": "Firmware",
    "cycleCount": "Contagem de ciclos",
    "cycleCountInfo": "A contagem de ciclos para uma bateria é o número total de ciclos de carga e descarga completos. É calculada como energia total acumulada dividida pela capacidade utilizável da bateria. O número aqui exibido representa o ciclo concluído.",
    "status": "Estado",
    "array": "Arranjo",
    "help": "Ajuda",
    "not_reporting": "Não reportando",
    "not_reporting_lowercase": "Não reportando",
    "normal": "Normal",
    "home": "Casa",
    "no_microinverters": "Nenhum microinversor encontrado",
    "no_storage": "Nenhum armazenamento encontrado",
    "no_envoy": "Nenhum gateway encontrado",
    "no_enpower": "Nenhum controlador de sistema encontrado",
    "wirelessRangeExtender": "Extensão do alcance sem fios",
    "no_wirelessRangeExtender": "Não foi encontrado um amplificador de sinal sem fio",
    "lastReported": "Último relatório",
    "manufacturer": "Nome do fabricante",
    "startType": "Tipo de início",
    "fuelType": "Tipo de combustível",
    "modelNumber": "Modelo número",
    "onOffCycles": "Total de ciclos de manipulação",
    "maintainenceInfo": "Informação sobre a manutenção",
    "maintainenceSub": "Atualize estes detalhes para receber notificações sobre a manutenção do seu gerador e os requisitos de combustível.",
    "lastMaintainenceDate": "Data da última manutenção",
    "lastRefuellingDate": "Data do último reabastecimento",
    "lastRefuellingTime": "Hora do último reabastecimento",
    "lastMaintainenceTime": "Hora da última manutenção",
    "litresOfFuel": "Litros de combustível cheio",
    "additionalInfo": "Para informação adicional",
    "statistics": "As suas estatísticas desde a última manutenção:",
    "timeElapsed": "Tempo decorrido",
    "cycles": "Ciclos de ligar/desligar:",
    "runningHours": "Tempo de execução:",
    "Days": "dias",
    "update": "Atualizar",
    "clickHere": "clique aqui",
    "savedSuccessfully": "As suas definições foram guardado com êxito.",
    "loads": {
      "status": "Estado",
      "smartControl": "Controle Inteligente",
      "auxillaryContact": "Contato Auxiliar"
    },
    "devicegenerator": {
      "on": "Ligada",
      "off": "Desligada"
    },
    "connected": {
      "true": "Conectado à nuvem Enphase",
      "false": "Desconectado da nuvem Enphase"
    },
    "envoyConnected": {
      "wait": "Procurando por Gateway...",
      "true": "Gateway detectado com sucesso.",
      "false": "Gateway não detectado."
    },
    "stepOne": "Por favor, conecte-se diretamente ao Gateway. Para fazer isso, primeiro pressione o botão de conexão no Gateway.",
    "stepTwo": "Em seguida, vá para suas configurações de wifi e conecte-se à rede do Gateway:",
    "stepThree": "Uma vez conectado, volte a esta tela. Você será temporariamente desconectado da internet.",
    "connectLocally": "Conexão local",
    "connectEnvoy": "Conecte-se ao Gateway usando",
    "connectEnvoyUser": "Nome de usuário",
    "connectEnvoyPassword": "Password",
    "notAllowAPMode": "O Gateway não suporta conectividade local.",
    "localEnvoyConnected": {
      "true": "Gateway detectado com sucesso",
      "false": "Nenhum Gateway encontrado na rede local",
      "wait": "Aguarde..."
    },
    "envoyPwd": {
      "urenvPwd": "Sua senha do Gateway",
      "retrivePwd": "para recuperar sua senha do Gateway.",
      "infoTitle": "Senha do Gateway",
      "infoDescription": "Você precisará dessa senha para reconectar seu Gateway ao seu Wi-Fi. Isso geralmente acontece quando a senha do Wi-Fi ou o provedor de serviços é alterado.",
      "infoLearnMore": "Clique aqui para saber mais."
    },
    "ensemble3_0Provisioning": {
      "bleOff": "Ligue o Bluetooth do seu telemóvel para ligar ao seu IQ Gateway",
      "tryApMode": "Experimentar o modo AP",
      "gatewayNotFound": "IQ Gateway não detetável. Certifique-se de que o seu IQ Gateway está perto e ligado.",
      "bleNotSupported": "Bluetooth não suportado",
      "bleNotSupportedDesc": "O Bluetooth não é suportado pelo seu dispositivo. Certifique-se de que o seu dispositivo tem as opções Bluetooth e Localização.",
      "bleConnected": "Ligado por Bluetooth",
      "scanningGateway": "A procurar o IQ Gateway",
      "fewMints": "Isto pode demorar alguns minutos",
      "noWifi": "Não foram encontrados dispositivos Wi-Fi",
      "password": "Palavra-passe",
      "gatewayConnected": "O IQ Gateway foi ligado ao Wi-Fi com sucesso.",
      "okGotIt": "OK, compreendi",
      "noGateway": "IQ Gateway não encontrado",
      "gatewayNearByWarning": "Certifique-se de o seu gateway está perto e ligado.",
      "noNetwork": "Sem rede",
      "wifiRouterWarning": "Mantenha o router do Wi-Fi ligado e o seu IQ Gateway dentro do alcance de Wi-Fi.",
      "connectionError": "Erro de ligação",
      "turnOn": "Ativar",
      "failedWifiConnect_1": "Falha ao ligar à rede Wi-Fi. Por favor ",
      "failedWifiConnect_2": "Contactar o suporte",
      "failedWifiConnect_3": " para obter ajuda.",
      "failedIQConnect_1": "Falha ao ligar ao IQ Gateway. Por favor ",
      "failedIQConnect_2": "Contactar o suporte",
      "failedIQConnect_3": " para obter ajuda.",
      "bleDevices": "Dispositivos Bluetooth",
      "wifiNetworks": "Redes Wi-Fi",
      "connectBle": "Ligar ao Bluetooth",
      "gatewayToWifi": "A ligar o IQ Gateway ao Wi-Fi...",
      "bleStatus": "A verificar o estado do Bluetooth...",
      "searchingWifi": "A procurar redes Wi-Fi...",
      "connectingBle": "A estabelecer ligação ao Bluetooth",
      "turnOnBle": "Ativar o Bluetooth",
      "tryAgain": "spróbuj ponownie",
      "wifiSsIdConfigFailedDesc": "Ocorreu um erro desconhecido ao ligar à rede Wi-Fi. Tente mais tarde ou ligue-se a uma rede diferente.",
      "wifiCommunicationError": "Erro de comunicação do Wi-Fi",
      "wifiCommunicationErrorDesc": "Não é possível estabelecer a ligação ao módulo BLE do IQ Gateway. Tente novamente mais tarde.",
      "networkNotFound": "Rede não encontrada",
      "networkNotFoundDesc": "A rede à qual está a tentar ligar não foi encontrada. Certifique-se de que o router Wi-Fi está ligado ou tente utilizar outra rede."
    }
  },
  "notification": {
    "offline": "Offline",
    "apmode": "Modo AP"
  },
  "siteempty": {
    "nosystemassociated": "Sua conta não está atualmente associada a nenhum sistema.",
    "systemowner": "Você é proprietário de um sistema Enphase?",
    "contactyourinstaller": "Entre em contato com o instalador para verificar a conta associadaao seu sistema.",
    "interestedonsystem": "Está interessado em um sistema da Enphase?",
    "initiatetransferofwarranty": "Inicia a transferência de garantia em caso de ter adquirido uma propriedade com um sistema Enphase.",
    "applytransferownership": "Solicite uma transferência de propriedade aqui.",
    "ownershiptransfer": "Transferência de propriedade",
    "visita": "Visite uma",
    "publicsystempage": "página pública do sistema",
    "monitoringexperience": "para ver a experiência de monitoramento da Enphase."
  },
  "recaptcha": {
    "verification_failed": "verificação do reCAPTCHA falhou, tente novamente.",
    "recaptcha_unreachable": "Ops. Houve uma falha ao validar o reCAPTCHA.  Tente novamente."
  },
  "mobile_app_rating": {
    "enjoying_app": "Gostando do aplicativo Enphase?",
    "rate_on_play_store": "Avalie a sua experiência",
    "rate_on_play_store2": "Na play store",
    "rate_us": "Avaliar-nos agora",
    "may_be_next": "Talvez mais tarde"
  },
  "consumptionMtr": {
    "btnText": "Adicionar medidor de consumo",
    "infoText": "O medidor de consumo ajuda a rastrear o uso geral de energia"
  },
  "replacement": {
    "microinverter_not_reporting": "Os microinversores não estão reportando",
    "batteryWarning": 'Isto pode ocorrer se a comunicação sem fios entre o seu gateway e a bateria for fraca. Pode tratar-se de uma falha temporária que deverá ser resolvida em breve. Se o problema persistir, contacte o seu responsável pela manutenção para obter ajuda.',
    "controllerWarning": 'Isto pode ocorrer se a comunicação sem fios entre o seu gateway e o controlador do sistema for fraca. Pode tratar-se de uma falha temporária que deverá ser resolvida em breve. Se o problema persistir, contacte o seu responsável pela manutenção para obter ajuda.',
    "batteryError": 'A bateria não está reportando dados.',
    "controllerError": 'O controlador do sistema não está a comunicar.',
    "contactMaintainer": 'Entre em contato com o responsável pela manutenção para ajuda.',
    "systemWarning": 'aviso do sistema',
    "array_details": "Detalhes do arranjo",
    "replacement_warranty1": "",
    "replacement_warranty": "Os microinversores estão na garantia e podem ser substituídos.",
    "shipping_address": "Endereço de entrega",
    "site_address": "Endereço do local ",
    "change": "MUDAR",
    "select_microinverters": "SELECIONAR MICROINVERSORES",
    "serial_number": "Search for serial number",
    "status": "Estado",
    "normal": "Normal",
    "not_reporting": "Não reportando",
    "submit_request": "Enviar solicitação",
    "dear": "Prezados",
    "replacement_message1": "É possível que você tenha que entrar em contato com o instalador",
    "replacement_message2": "para que seja feita a reposição assim que o dispositivo substituto seja enviado. Podem haver cobranças pela reposição por parte do instalador.",
    "request_submitted": "A solicitação de devolução foi enviada com sucesso.",
    "response_message": "Use o ID de solicitação para rastrear a situação da reposição ao entrar em contato com o suporte.",
    "request_id": "ID de solicitação",
    "ok": "Ok, percebi",
    "replacement_delivery": "A reposição será entregue em seu endereço",
    "replacement_delivery_installer": "A reposição será entregue ao instalador local",
    "installer_address": "ENDEREÇO DO INSTALADOR",
    "understand": "Entendo",
    "continue_button": "Prosseguir",
    "error_message": "Falha ao gerar ID de solicitação",
    "failed_to_fetch": "Falha em obter os microinversores. Tente novamente",
    "change_address": "Mudar endereço de entrega"
  },
  "tariff": {
    "tariff": "Tarifa",
    "tariffNotAdded": "Tarifa não adicionada",
    "tariffNotSet": "Tarifa não definida",
    "tariffType": "Tipo de tarifas",
    "buying": "Compra",
    "selling": "Venda",
    "flat": "Taxa plana",
    "tou": "Tempo de utilização",
    "tiered": "Taxa Variável",
    "copyFromBuyingTariff": "Copiar a partir de tarifa de compra",
    "copyFromSellingTariff": "Cópia da tarifa de venda",
    "dayBasedTariff": "Sua tarifa varia durante o dia?",
    "unitsBasedTariff": "Sua tarifa varia de acordo com as unidades consumidas?",
    "seasonalTariff": "Sua tarifa varia de acordo com a época?",
    "weekendTariff": "Sua tarifa varia nos fins de semana?",
    "baseRateTariff": "Qual é a tarifa básica?",
    "flatLabel": "O custo da energia é fixo durante o dia.",
    "touLabel": "O custo da energia varia nos horários de pico.",
    "tieredLabel": "O custo da energia varia conforme aumenta o consumo da unidade.",
    "rate": "Tarifa",
    "addSeason": "Adicionar estação",
    "season": "Estação",
    "next": "Próximo",
    "noSeasonWeekend": "A tarifa não varia de acordo com a época ou nos fins de semana.",
    "weekendOnly": "A tarifa varia somente nos fins de semana.",
    "seasonAndWeekend": "A tarifa varia de acordo com a época e nos fins de semana.",
    "seasonOnly": "A tarifa varia somente de acordo com a época.",
    "infoText": "Informação",
    "baseRate": "Tarifa básica",
    "remove": "Remover",
    "from": "A partir de",
    "to": "até",
    "addPeak": "Adicionar pico",
    "tariffDetails": "Detalhes da tarifa",
    "off-peak": "Fora de pico",
    "above": "Acima",
    "below": "Abaixo de",
    "between": "Entre",
    "and": "e",
    "weekdays": "dias de semana",
    "weekend": "fim de semana",
    "winter": "Zima",
    "summer": "Verão",
    "fall": "Outono",
    "spring": "Primavera",
    "confirmAndSave": "Confirmar e guardar",
    "buyingTariff": "Tarifa de compra",
    "sellingTariff": "Tarifa de venda",
    "edit": "Editar",
    "offPeak": "Fora de pico",
    "peak": "ponta",
    "period": "ponta",
    "addTier": "Adicionar Tier",
    "tier": "Tier",
    "yesLabel": "Sim",
    "noLabel": "Não",
    "manualConfiguration": "Configuração manual",
    "added": "adicionada",
    "modified": "modificada",
    "successfully": "com sucesso",
    "alreadySelected": "já selecionada",
    "alreadyAdded": "já adicionada",
    "buyingTariffAdded": "Tarifa de compra adicionada com sucesso",
    "sellingTariffAdded": "Tarifa de venda adicionada com sucesso",
    "buyingTariffModified": "Tarifa de compra modificada com sucesso",
    "sellingTariffModified": "Tarifa de venda modificada com sucesso",
    "buyingTariffReset": "Tarifa de compra redefinida com sucesso",
    "sellingTariffReset": "Tarifa de venda redefinida com sucesso",
    "reset": "Restabelecer",
    "resetConfirmationText": "Deseja redefinir os detalhes da tarifa?",
    "resetErrorText": "Não foi possível redefinir os detalhes da tarifa",
    "updateErrorText": "Não foi possível atualizar os detalhes da tarifa",
    "tariffErrorText": "Entrada inválida. Este valor já existe no Tier ",
    "tierInvalidEntry": "Entrada inválida. O valor deve ser maior do que \"Tier 1\"",
    "timeInvalidEntry": "Entrada inválida. O valor deve ser maior do que \"From\"",
    "invalidValue": "O valor deve ser maior do que 0"
  },
  "currency": {
    "currencyEquivalent": "Consulte a moeda equivalente dos valores de energia",
    "currencyConversion": "Ajuste o fator de conversão da moeda",
    "currencyInfo": "O valor informado da moeda é indicativo. impostos, taxas, taxas escalonadas ou tempo de uso não são considerados.",
    "currencyFactor": "Fator de conversão de moeda",
    "currencyFactorSubtitle": "Os dados de energia são convertidos para os seus valores equivalentes em moeda, multiplicando-os pelo fator de conversão de moeda.",
    "currencyNote": "Nota: O valor informado da moeda é indicativo. impostos, taxas, taxas escalonadas ou tempo de uso não são considerados.",
    "conversionFactor": "Fator de conversão",
    "currencyEquivalentHeader": "Moeda equivalente",
    "energyImported": "Energia importada",
    "energyExported": "Energia exportada",
    "netEnergyImported": "Energia importada líquida",
    "netEnergyExported": "Energia exportada líquida",
    "currencyConversionHeader": "Conversão de moeda",
    "confirmationMessage": "Deseja continuar sem salvar as alterações?",
    "confirmationYes": "Sim",
    "confirmationNo": "Não",
    "invalidInput": "Entrada inválida"
  },
  "demo": {
    "appDemo": "Demonstração do aplicativo",
    "message": "Este é um aplicativo de demonstração",
    "enphaseInstaller": "Enphase Installer",
    "mainHeader": "Sistema de energia inteligente tudo-em-um",
    "subHeader": "Obtenha armazenamento e energia solar",
    "getStarted": "Começar",
    "appDemoDesc": "Toque para ver como um sistema funciona",
    "loginDesc": "Para usuários registrados",
    "selectLanguage": "Wybór języka"
  },
  "connectionBandwidth": {
    "low": "Baixa largura de banda. Dados reportados a cada 6 horas.",
    "high": "Largura de banda padrão. Dados reportados a cada 15 minutos."
  },
  "release_notes": {
    "appUpdateHeading": "Nova atualização para seu aplicativo Enphase",
    "appUpdateSuccessHeading": "Seu aplicativo Enphase foi atualizado.",
    "later": "Mais tarde",
    "updateNow": "Atualizar Agora",
    "update": "Atualizar",
    "whatsNew": "O que há de novo",
    "askWhatsNew": "Novidades?",
    "new": "Novo",
    "version": "Versão",
    "readMore": "Leia mais"
  },
  "storageCapacity": {
    "availableEnergy": "Energia disponível",
    "totalStorage": "Total Storage",
    "encharge": "IQ Battery",
    "acBattery": "AC Battery",
    "of": "of",
    "availablePower": "Potência disponível",
    "activeMicroinverters": "Microinversor(es) ativo(s)",
    "activeEncharge": "Bateria(s) ativa(s)",
    "microinverters": "Microinversor(es)"
  },
  "siteImage": {
    'siteImagePopUpHeading': "Faça upload de uma imagem do site de sua escolha",
    "selectImage": "Selecione a Imagem",
    "imageSizeError": "*O tamanho da imagem deve ser inferior a 5 MB",
    "hide": "Esconder",
    "apply": "Aplique",
    "hideSiteImage": "Ocultar imagem do site",
    "hideSiteImageDesc1": "A imagem do site não será exibida na página Status. Você pode alterar a preferência acessando Menu -> Sistema -> Detalhes do Site.",
    "hideSiteImageDesc2": "Você quer prosseguir?",
    "uploadSuccessToast": "A imagem do seu site foi atualizada com sucesso",
    "maxImageLimit": "Você pode fazer upload de até quatro imagens para o seu site. Exclua uma imagem para adicionar uma nova.",
    "okGotIt": "OK, compreendi!",
    "imageSIzeErrorSiteDetails": "O tamanho da imagem deve ser inferior a 5 MB. Carregue uma imagem diferente.",
    "apiError": "Não foi possível concluir a solicitação. Por favor, tente novamente mais tarde",
    "displayOnStatusPage": "Exibir na página de status",
    "displayOnStatusPageWarning": "Tem certeza de que deseja atualizar a imagem na página Status?",
    "displayOnStatusPageNote": "Nota: A imagem será ajustada automaticamente para exibição. Você sempre pode reajustá-lo na página Status",
    "deleteSiteImage": "Excluir imagem",
    "deleteSiteImageWarning": "Tem certeza de que deseja excluir a imagem?",
    "imageDeleteSuccess": "A imagem foi excluída com sucesso",
    "imageUploadSuccess": "A imagem foi enviada com sucesso",
    "imageUploadSuccessStatusPage": "Imagem atualizada com sucesso na página Status",
    "displayedOnStatusPage": "Exibido na página de status",
    "uploadImage": "Enviar imagem",
    "imagePreferenceSaved": "A preferência de imagem do seu site foi salva",
    "siteImage": "Imagem do site",
    "statusPageMaxImagePopUpDesc1": "Você pode fazer upload de até quatro imagens para o seu site. Por favor, exclua uma imagem de ",
    "statusPageMaxImagePopUpDesc2": " para adicionar uma nova aqui",
    "addSiteImage": "ADICIONAR IMAGEM DO SITE",
    "wrongFileType": "Carregue apenas uma imagem JPEG ou PNG"
  },
  "nps": {
    "question": "Como é sua experiência conosco?",
    "description": "Com base em sua recente experiência com a Enphase, qual a probabilidade de recomendar a Enphase para um amigo ou colega?",
    "dontAskAgain": "Não perguntar novamente.",
    "notNow": "Agora não",
    "notLikely": "Pouco provável",
    "mostLikely": "Muito provavelmente",
    "confirmationHeader": "Agradecemos sua resposta! Ajude-nos a compreender melhor sua resposta.",
    "surveyButton": "Participe de uma pesquisa de 2 minutos",
    "notInterested": "Não tenho interesse",
    "survey": "Pesquisa",
    "internetError": "Verifique a conexão com a Internet e tente novamente.",
    "rateEnphaseTitle": "Avalie a Enphase",
    "rateEnphaseDescription": "Qual a probabilidade de recomendar a Enphase para um amigo ou colega?",
    "rateInstallerTitle": "Avalie seu instalador",
    "rateInstallerDescription1": "Qual é a probabilidade de você recomendar",
    "rateInstallerDescription2": "para um amigo ou colega?",
    "feedbackSuccess": "Agradecemos sua valiosa opinião.",
    "ratingSuccess": "Agradecemos sua opinião.",
    "feedbackEnphaseTitle": "Sua avaliação sobre a Enphase",
    "feedbackInstallerTitle": "Sua avaliação sobre o instalador",
    "detractors": "O que podemos melhorar?",
    "passive": "Como podemos melhorar sua experiência?",
    "promoters": "Pode nos ajudar explicando sua nota?",
    "legalDisclaimer": "O seu nome e comentários/opinião serão partilhados com os instaladores."
  },
  "liveStatus": {
    "title": "Ao vivo",
    "subTitle": "Ver potência em tempo real",
    "offlineMsg": "Use LIVE STATUS quando estiver Offline",
    "streamingLocally": "Transmissão local do gateway",
    "closingMinutes": "Fechando em",
    "cfgMsg": "As baterias podem ser carregadas a partir da rede, uma vez que permitiu a configuração %{cfglink}.",
    "learn": "Aprenda",
    "pvOnlyCta": "%{learn} como pode otimizar e acompanhar a sua utilização de energia por meio da medição do consumo",
    "cfgFiller": "Carregar a bateria a partir da rede",
    "cfgVls": "As baterias podem carregar a partir da rede, uma vez que a carga da bateria está abaixo do nível de desligamento.",
    "solar": {
      "title": "Solar",
      "producing": "Em produção",
      "energyProducing": "Produção de energia"
    },
    "home": {
      "title": "Casa",
      "consuming": "Consumindo",
      "energyConsuming": "Energy Consuming"
    },
    "grid": {
      "title": "Rede",
      "gridConnectivity": "Conectividade da rede",
      "waiting": "A aguardar informação",
      "unknown": "Condição desconhecida da rede",
      "notAvailable": "Rede indisponível",
      "systemConnected": "O sistema está ligado à rede",
      "notSystemConnected": "O sistema está desligado da rede",
      "outage": "Grid Outage",
      "updating": "Atualização da condição da rede",
      "exporting": "Exportando",
      "importing": "Importando",
      "notConnected": "Não conectado",
      "offGrid": "Rede desligada",
      "onGrid": "Na rede",
      "goOnGrid": "Ligar à rede",
      "goOffGridDisabled": "Fora da rede não permitido",
      "goOffGrid": "Desligado da rede",
      "gridUpdatingMessage": "A confirmação do estado da rede está a demorar mais do que o esperado. Verifique novamente mais tarde.",
      "gridConnectedMessage": "O seu sistema está agora ligado à rede.",
      "gridDisconnectedMessage": "O seu sistema está agora desligado da rede.",
      "disconnectingGrid": "A desligar da rede...",
      "connectingGrid": "A ligar à rede...",
      "unableToConnect": "Não foi possível conectar com o Gateway",
      "initialisingOnGrid": "A inicializar o controlo da rede...",
      "gridOutage": "O sistema está fora da rede devido a uma falha da rede",
      "gridOutageToastAuto": "Não pode entrar no modo 'Na rede' devido a uma falha de energia. Quando a energia for restabelecida, o sistema irá ligar-se à rede",
      "gridOutageToastUser": "Não pode entrar no modo 'Na rede' devido a uma falha de energia. Pode controlar a ligação da rede quando a rede elétrica estiver disponível"
    },
    "generator": {
      "title": "Gerador",
      "onGenerator": "Gerador ligado",
      "offGenerator": "Gerador desligado",
      "unknown": "Estado do gerador desconhecido",
      "notConnected": "Não conectado",
      "genDisconnecting": "Desconectando...",
      "waiting": "A aguardar",
      "updating": "A atualizar"
    },
    "fuelCell": {
      "title": "Célula de combustível",
      "on": "Célula de combustível ligada",
      "off": "Célula de combustível desligada",
      "warmingUp": "Célula de combustível a aquecer",
      "coolDown": "Arrefecimento da célula de combustível",
      "unknown": "Estado desconhecido da célula de combustível",
      "notConnected": "Não ligado",
      "genDisconnecting": "A desligar...",
      "waiting": "A aguardar",
      "updating": "A atualizar"
    },
    "systemNotReporting": {
      "title": "O controlador do sistema não está a comunicar",
      "subTitle": "Não conseguimos mostrar os dados em direto uma vez que o controlador do sistema não está a comunicar com o gateway. Pode tratar-se de uma falha temporária que deverá ser resolvida em breve."
    },
    "envoy": {
      "connecting": "Conectando ao Gateway...",
      "connectingToOjas": "Connecting to Portable Energy System...",
      "notAbleToConnect": "Não foi possível conectar",
      "notAbleToConnectMultiEnv": "Não é capaz de ligar ao gateway com o número de série:",
      "negativeConsumptionTitle": "Erro de comunicação",
      "negativeConsumptionDesc": "Não conseguimos concluir o estado em direto devido à perda de comunicação entre os seus dispositivos. Trata-se de uma falha temporária que deverá ser resolvida em breve"
    },
    "onDifferentNetwork": "Seu Gateway e este dispositivo estão em uma rede diferente",
    "connectOnSameNetworkorAPMode": "Conecte seu Gateway e dispositivo à mesma rede ou habilite o modo AP em seu Gateway para conectar este dispositivo à rede Wifi %{ssid}.",
    "connectOnSameNetwork": "Conecte este dispositivo à rede Wi-Fi %{ssid}, então tente novamente visualizar ao vivo no modo Offline.",
    "apModeTutorial": "Tutorial do modo AP",
    "apMT1": "Pressione brevemente e libere (não mantenha pressionado) o  ",
    "apMT2": "Botão de Modo AP",
    "apMT3": "  até que o LED do Modo AP (",
    "apMT4": ") acende em verde sólido. O Gateway permanecerá no modo AP por oito horas."
  },
  "desktop": {
    "status": {
      "power": "Potência",
      "energy": "Energia",
      "battery": "Bateria",
      "solarEquivalent": "Equivalente solar",
      "dataUnavailable": "Dados não disponíveis"
    },
    "array": {
      "title": "Arranjo",
      "totalProduced": "Total Produzido",
      "totalConsumed": "Total consumido",
      "lifetimeProduced": "Produção ao longo de todo o tempo",
      "lifetimeConsumed": "Consumo ao longo de todo o tempo",
      "status": "Estado",
      "azimuth": "Azimuth",
      "tilt": "Inclinação",
      "microinverter": "Microinversor"
    },
    "energy": {
      "totalEnergy": "Energia total",
      "graphControls": "Gráficos de controle"
    },
    "header": {
      "switchToClassic": "Alternar para a visualização clássica"
    },
    "footer": {
      "change": "Mudar",
      "changeSite": "Mudar local",
      "copyRightsText": "©2008-%{currYear} Enphase Energy, Inc. Todos os direitos reservados",
      "privacyText": "Privacidade",
      "termsText": "Termos",
      "weatherCompany": "Instituto do Tempo",
      "weatherDataText": "Dados meteorológicos fornecidos por"
    }
  },
  "customPeriod": {
    "dialogLabel": "Visualização baseada em",
    "billingCycle": "Ciclo de cobrança",
    "billingLabel": "Combinar o gráfico de energia com seu ciclo de cobrança",
    "billingLabelStatusPage": "Período de tempo a partir de uma determinada data de início, para duração selecionada",
    "startDate": "Data de início da cobrança",
    "frequency": "Frequência da cobrança",
    "months": "Meses",
    "days": "Dias",
    "every": "A cada",
    "customDate": "Intervalo personalizado de data",
    "customDateLabel": "Selecione um intervalo personalizado de data para visualizá-lo no gráfico de energia",
    "customRange": "Selecione um intervalo de data entre 1 e 100 dias"
  },
  "systemEstimator": {
    "heading": "Estimativa do sistema",
    "exitConfirmation": "Tem a certeza que deseja fechar o Adicionar o fluxo de armazenamento?",
    "resumeButton": "Retomar",
    "systemAccess": "Obtenha acesso ao sistema",
    "statusAddStorage": "para evitar apagões",
    "addStorageLeadInfo": "ver estado",
    "postLoginWoSiteTitle": "Conheça o único sistema tudo-em-um de armazenamento e energia solar",
    "videoCTABtn": "Assista ao vídeo",
    "addStorageTitle": "Obtenha um novo sistema da Enphase",
    "orderNowBtn": "Encomendar agora"
  },
  "sgipIncentive": {
    "gotItButton": "Percebi",
    "exitButton": "Sair",
    "dontExitButton": "Não sair",
    "sgipPaymentNotDone": "O seu pedido SGIP está incompleto. Deseja sair sem concluir o seu pedido?",
    "sgipPaymentDone": "Pode regressar em qualquer momento para verificar o estado do seu pedido SGIP",
    "sgipApplyAlert": "Os incentivos SGIP são aplicáveis ​​apenas para sistemas instalados na Califórnia. Se você já tiver uma ativação do sistema em andamento na Califórnia, peça ao seu instalador para iniciar o processo de criação da instalação em seu aplicativo Enphase.",
    "sgipGetStorage": "Obter um novo sistema de armazenamento Enphase"
  },
  "gridBatteryChange": {
    "gridTag": "G",
    "batteryTag": "B",
    "gridChangeDesc": "Condição da rede alterada para",
    "gridOn": "Na rede",
    "gridOff": "Rede desligada",
    "batteryChangeDesc": "Perfil da bateria alterado para",
    "costSavings": "Redução de custos",
    "selfConsumption": "Autoconsumo",
    "savingsMode": "Modos de economia de energia",
    "backupOnly": "Somente backup",
    "stormGuardDesc": "O Storm Guard está",
    "alertIssued": " alerta emitido",
    "alertHasEnded": " alerta terminado"
  },
  "liveVitalStats": (_liveVitalStats = {
    "normal": "Normal",
    "unknown": "Desconhecida",
    "undefined": "Não definido",
    "loads": "Controlo da carga",
    "loadsInfoPart1": "A carga é mapeada para ",
    "loadsInfoPart2": "Contatos auxiliares do controlador do sistema",
    "loadsInfoPart3": " pelo seu instalador. Você pode configurar essas cargas em suas ",
    "loadsInfoPart4": "Configurações do sistema.",
    "powered": "Energizado",
    "invalidState": "Estado inválido",
    "viewMore": "Ver mais",
    "viewLess": "Ver menos",
    "ECA_BAT_IDLE": "Inativo",
    "ECA_BAT_CHARGING": "Carregando",
    "ECA_BAT_DISCHARGING": "Descarregamento",
    "MAX_ECA_BAT_STATE": "Desconhecida",
    "systemIsOnGrid": "O sistema está ligado à rede",
    "systemIsOffGrid": "O sistema está desligado da rede",
    "infoIsOnGrid": "O sistema está a funcionar no modo de ligação à rede.",
    "infoIsOffGrid": "O sistema está a funcionar no modo microrede",
    "wiredCANConn": "Ligação CAN com fios",
    "infoWiredCAN": "O IQ System Controller se comunica com o IQ Gateway por meio de uma conexão com fio. O ícone representa se ou não está conectado e comunicando com o Gateway.",
    "infoIsOffGridAvailable": "O sistema está a funcionar no modo microrede No entanto, a rede está disponível e pode ligar à rede em qualquer altura.",
    "voltageL1": {
      "val": "Tensão L1",
      "info": "A tensão entre a Linha 1 (L1) e Neutro."
    },
    "voltageL2": {
      "val": "Tensão L2",
      "info": "A tensão entre a Linha 2 (L2) e Neutro."
    },
    "voltageL3": {
      "val": "Tensão L3",
      "info": "A tensão entre a Linha 2 (L2) e Neutro."
    },
    "voltage": {
      "val": "Tensão",
      "info": "A tensão entre a Linha 1 (L1) e Neutro."
    },
    "frequency": {
      "val": "Frequência",
      "info": "A frequência de corrente alterna (CA) nominal."
    },
    "gridParameters": "Parâmetros da rede de serviço público",
    "auxiliaryContactsParameters": "Controlo da carga",
    "infoauxiliaryContactsParam": "O Controlador do Sistema possui quatro contatos auxiliares para controle de carga. O nome da carga indica que o contato correspondente está mapeado para essa carga. Para os contatos não mapeados para nenhuma carga, “Não em uso” é exibido.",
    "infoGridParam": "A tensão e a frequência são medidas no lado do serviço público do dispositivo de interligação (MID). Quando a rede não está disponível a tensão da rede e a frequência são 0.",
    "microgridParameters": "Parâmetros da microrede",
    "infoMicrogridParam": "A tensão e a frequência da microrede são medidas no lado da carga do dispositivo de interligação da microrede (MID). Se o seu MID estiver aberto quando o seu sistema estiver no modo rede fora da rede/microrede",
    "generatorParameters": "Parâmetros do gerador",
    "infoGeneratorParam": "A tensão e a frequência são medidas no lado da carga do dispositivo de interligação do gerador (GID). Se o seu GID estiver fechado quando o seu sistema estiver no modo rede fora da rede/microrede.",
    "infoEnpower": "IQ System Controller",
    "zigbeeSignal": "dBm",
    "commSignal": "Sinal de comunicação",
    "infoZigbeeSignal": "Representa a força da comunicação sem fio de 2,4 GHz com o Gateway. Mais barras ou um valor de dBm mais alto representa uma força de sinal mais forte.",
    "commStatus": "Estado da comunicação",
    "infoCommSignal": "SINAL DE COMUNICAÇÃO",
    "usbConnection": "USB Connection",
    "infoUsbSignal": "O IQ System Controller comunica com o IQ Gateway via ligação USB. O ícone representa se o USB está, ou não, ligado e a comunicar com o IQ Gateway.",
    "commStatusDesc": "A IQ Battery comunica com o IQ System Controller através de uma ligação com fios. O ícone representa se a IQ Battery está, ou não, ligada e a comunicar com o IQ System Controller.",
    "ENCMN_STATE_UNKNOWN": {
      "val": "Desconhecida"
    },
    "ENCMN_STATE_MISSING": {
      "val": "Falha de comunicação 2.4 GHz"
    },
    "ENCMN_STATE_DISCOVERED": {
      "val": "Emparelhamento de 2.4 GHz"
    },
    "ENCMN_STATE_Descarregamento": {
      "val": "Emparelhamento 2.4 GHz concluído'"
    },
    "ENCMN_STATE_INV_DONE": {
      "val": "Recuperação das informações do dispositivo concluída"
    },
    "ENPWR_STATE_GRIDMODE_WAIT": {
      "val": "Aguardando que as baterias reconheçam o estado da rede"
    },
    "ENPWR_STATE_GRIDMODE_CONFIRM": {
      "val": "Ordenando o controlador do sistema fechar o relé EC1"
    },
    "ENPWR_STATE_RELAY_CTRL_WAIT": {
      "val": "Desconhecida"
    },
    "ENPWR_STATE_GRID_PROFILE_UPD": {
      "val": "A iniciar atualização do perfil da rede"
    },
    "ENPWR_STATE_GRID_PROFILE_SET": {
      "val": "Atualização do perfil da rede em progresso"
    },
    "ENPWR_STATE_GRID_PROFILE_END": {
      "val": "Atualização do perfil da rede concluída"
    },
    "ENPWR_STATE_RELAY_QUERY": {
      "val": "Buscando os estados do relé controlador do sistema após a inicialização"
    },
    "ENPWR_STATE_OPER_SELECTOR": {
      "val": "Interpretando os estados do relé controlador do sistema"
    },
    "ENPWR_STATE_OPER_NO_GRID": {
      "val": "O controlador do sistema está fora da rede"
    },
    "ENPWR_STATE_OPER_OPEN_AC_PRESENT": {
      "val": "O controlador do sistema está fora da rede. A rede está disponível"
    },
    "ENPWR_STATE_OPER_SYNC_READY": {
      "val": "A microrede está sincronizada com a rede Pronta para ir para a rede"
    },
    "ENPWR_STATE_OPER_CLOSED": {
      "val": "O controlador do sistema está conectado a rede"
    },
    "ENPWR_STATE_GOING_ON_GRID": {
      "val": "Ordenando o controlador do sistema para conectar a rede"
    },
    "ENPWR_STATE_PREPARE_FOR_OFF_GRID": {
      "val": "A preparar para executar o comando do utilizador para desligar da rede"
    },
    "ENPWR_STATE_GOING_OFF_GRID": {
      "val": "Ordenando o controlador do sistema para desconectar da rede"
    },
    "ENPWR_STATE_OPER_CLOSED_INIT": {
      "val": "O controlador do sistema está On Grid. Descobrindo as baterias.rede"
    },
    "ENCMN_STATE_MAX": {
      "val": "Desconhecida"
    },
    "ENCMN_STATE_CONNECTED_NO_PCU": {
      "val": "Nenhum microinversor detectado"
    },
    "ENCHG_STATE_READY": {
      "val": "A bateria está operacional"
    },
    "ENCHG_STATE_GRIDMODE_UPD": {
      "val": "Enviando o modo de grade para a bateria"
    },
    "ENCHG_STATE_BACKUP_SOC_UPD": {
      "val": "Atualizando o limite do estado de carga (SoC) de reserva na bateria"
    },
    "ENCHG_STATE_GRID_PROFILE_UPD": {
      "val": "A iniciar atualização do perfil da rede"
    },
    "ENCHG_STATE_GRID_PROFILE_SET": {
      "val": "Atualização do perfil da rede em progresso"
    },
    "ENCHG_STATE_GRID_PROFILE_END": {
      "val": "Atualização do perfil da rede concluída"
    },
    "ENCHG_STATE_INVENTORY": {
      "val": "Recuperando informações de hardware e software da bateria"
    },
    "ST_NOP": {
      "val": "Desconhecida"
    },
    "ENPWR_STATE_OPER_GEN_CLOSING_INIT": {
      "val": "O controlador do sistema está desconectado da rede. Conectando ao Gerador."
    },
    "ENPWR_STATE_OPER_GEN_CLOSE": {
      "val": "O controlador do sistema está desconectado da rede. Gerador conectado."
    },
    "ENPWR_STATE_OPER_GEN_OPENING_INIT": {
      "val": "O controlador do sistema está desconectado da rede. Desconectando o Gerador."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_EC1": {
      "val": "EC1 fechado. Teste de relé concluído."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_EC1": {
      "val": "EC1 aberto. Teste de relé em progresso."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_CLOSE_GEN": {
      "val": "Relé GEN fechado. Teste de relé concluído."
    },
    "ENPWR_STATE_TEST_CHECK_WIRING_OPEN_GEN": {
      "val": "Relé GEN aberto. Teste de relé em progresso."
    },
    "default": {
      "val": "Desconhecida"
    },
    "controlState": "Estado do controlo",
    "CHECK_BUSES": {
      "val": "A verificar os barramentos e os relés",
      "info": "O controlador do sistema foi redefinido. Validando os parâmetros do sistema antes de fazer a transição para um estado de rede diferente."
    },
    "CYCLE_RELAYS": {
      "val": "Relés de ciclo",
      "info": "Seu sistema está desligando os relés do Controlador do Sistema para validar se as condições de erro do relé foram eliminadas."
    },
    "GRID_CONNECT": {
      "val": "A ligar à rede",
      "info": "Seu sistema está se conectando à rede após a redefinição do Controlador do Sistema."
    },
    "EC1_EC2_CONNECT": {
      "val": "Baterias conectadas. Conectando NFT",
      "info": "Seu sistema está em transição para microrrede. As baterias estão conectadas. O Neutral Forming Transformer (NFT) está sendo conectado."
    },
    "GRID_OP_WAIT_FOR_ENVOY": {
      "val": "Conectado à rede. Conectando baterias",
      "info": "Seu sistema está conectado à rede. As baterias estão em processo de conexão."
    },
    "GRID_OP_FULL": {
      "val": "Na rede",
      "info": "O seu sistema está a funcionar no modo de ligação à rede."
    },
    "MICROGRID_OK_NO_GENERATOR": {
      "val": "Rede desligada",
      "info": "O seu sistema está a funcionar no modo microrede."
    },
    "SYNC_TO_GRID": {
      "val": "A sincronizar com a rede",
      "info": "O seu sistema está a fazer a transição da microrede para a rede ligada."
    },
    "MICROGRID_REGULATORY_SHUTDOWN": {
      "val": "Falha da microrede",
      "info": "A microrede colapsou devido a sobrecarga ou a um erro do sistema. O sistema recuperará brevemente."
    },
    "MANUFACTURING_MODE": {
      "val": "Modo de fabrico",
      "info": "Contacte o seu apoio ao cliente"
    },
    "RESET": {
      "val": "Redefinição do Controlador do Sistema",
      "info": "Seu controlador do sistema foi redefinido. O sistema se recuperará em breve."
    },
    "GRID_OP_OPEN_NFT": {
      "val": "Rede ligada. A abrir NFT",
      "info": "O seu sistema está ligado à rede. O transformador de formação neutro (NFT) está a ser desligado."
    },
    "MANUAL_OVERRIDE": {
      "val": "Cancelamento manual ativado",
      "info": "Fechou manualmente o dispositivo de interligação microrede (MID) para ir para a rede. Contacte o apoio ao cliente se não tiver feito isto intencionalmente."
    },
    "RAPID_SHUTDOWN_STATE": {
      "val": "Rapid Shutdown State"
    },
    "UNKNOWN": {
      "val": "Desconhecida",
      "info": "Contacte o seu apoio ao cliente"
    },
    "ECA_RELAY_OPEN_AC_GRID_SYNCHED": {
      "val": "Sincronizado e a ligar à rede"
    },
    "infoControlState": "Estados do controlo",
    "faults": "Erro do controlador do sistema",
    "MID_FUSED": "O seu sistema não pode fazer a transição para o modo microrede, pois o MID está preso fechado.",
    "EC1_FUSED": {
      "ES1": "Both IQ Battery L1 and L2 relays are stuck closed.",
      "ES2": {
        "NO_BATT-PV": "Both PV L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ8 PV L1 and L2 relays are stuck closed",
        "BATT-NO_PV": ""
      }
    },
    "EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-PV": "Both IQ Battery L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery L1 and L2 relays are stuck closed"
      }
    },
    "EC1_EC2_FUSED": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Both IQ Battery and IQ8 PV, L1 and L2 relays are stuck closed",
        "BATT-NO_PV": "Both IQ Battery and PV, L1 and L2 relays are stuck closed"
      }
    },
    "NFT_FUSED": "Os relés do transformador de formação neutro (NFT) estão presos em fechados.",
    "NFT_OPEN": "O seu sistema não pode fazer a transição para o modo microrede, pois os relés do Transformador de Formação Neutra (NFT) estão abertos.",
    "MID_OPEN": "O seu sistema não pode fazer a transição para o modo ligado, pois o MID está preso em aberto.",
    "EC1_OPEN": {
      "ES1": "Your system cannot transition to the microgrid mode as one or both the IQ Battery L1 and L2 relays are stuck open.",
      "ES2": {
        "NO_BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the PV L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot use IQ8 PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot use PV as one or both of the PV L1 and L2 relays are stuck open. Only IQ Batteries will power the home in microgrid mode"
      }
    },
    "EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "Your system does not support grid forming IQ Batteries as one or both of the IQ Battery L1 and L2 relays are stuck open",
        "BATT-PV": "Your system cannot reliably transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open. Only IQ8 PV will power the home in microgrid mode",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery L1 and L2 relays are stuck open"
      }
    },
    "EC1_EC2_OPEN": {
      "ES2": {
        "NO_BATT-PV": "",
        "BATT-PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as IQ8 PV, L1 and L2 relays are stuck open",
        "BATT-NO_PV": "Your system cannot transition to the microgrid mode as one or both of the IQ Battery and as well as PV L1 and L2 relays are stuck open"
      }
    },
    "I2C_INIT": "Seu sistema não está operacional. A placa Automatic Transfer Switch (ATS) do Controlador do Sistema falhou.",
    "ADC_INIT": "Seu sistema não está operacional. A placa Automatic Transfer Switch (ATS) do Controlador do Sistema falhou.",
    "I2C_COMM": "Seu sistema não está operacional. A placa Automatic Transfer Switch (ATS) do Controlador do Sistema falhou.",
    "NFT_TEMP": "Seu sistema não está operacional. O Neutral Forming Transformer (NFT) do controlador do sistema excedeu os limites de temperatura.",
    "ATS_TEMP": "Seu sistema não está operacional. A placa ATS (Automatic Transfer Switch) do controlador do sistema excedeu os limites de temperatura.",
    "E3_TEMP": "Seu sistema não está operacional. A placa controladora do sistema excedeu os limites de temperatura.",
    "CRC_MISMATCH": "Seu sistema não está operacional. A placa controladora do sistema falhou ao inicializar.",
    "V_IMBALANCE": "O seu sistema não pode fazer a transição para o modo microrede. Um desequilíbrio de tensão L1 e L2 causou um disparo.",
    "MANUAL_OVR": "Seu sistema está no modo conectado à rede devido à substituição manual do controlador do sistema.",
    "GEN_CONN_OPEN_NFT": 'Your system is connected to the Generator. The Neutral Forming Transformer (NFT) is being disconnected.',
    "MANUAL_BACKSTART": 'Your system is trying to blackstart in off grid mode.',
    "BACKSTART_FAILED": 'Your system could not blackstart in off grid mode. It will reattempt blackstart.',
    "GRID_TIED": 'Your system is in Grid Tied mode.',
    "MID": {
      "val": "MID",
      "info": "O dispositivo de interligação Microrede (MID) liga (quando fechado) ou desligas (quando aberto) a sua rede de serviço público."
    },
    "DER_L1": {
      "val": "DER L1",
      "info": "Os relés DER do recurso de energia distribuída (DER), quando fechados, ligam as suas Encharges e sistema fotovoltaico na linha 1 ou 2, respetivamente, à sua casa"
    },
    "DER_L2": {
      "val": "DER L2"
    },
    "DER_L3": {
      "val": "DER L3"
    },
    "DER_1": {
      "val": "DER 1"
    },
    "DER_N": {
      "val": "DER N"
    },
    "EC1_L1": {
      "val": "EC1 L1",
      "info": "Os relés EC1, L1 e L2 quando fechados conectam suas baterias ou IQ8 PV às suas cargas domésticas. Operam fase-fase e não possuem neutro."
    },
    "EC1_L2": {
      "val": "EC1 L2"
    },
    "ENCHARGE_L1L2": {
      "val": "IQ Battery L1, L2",
      "info": "Os relés IQ Battery L1 e L2, quando fechados, conectam suas baterias às suas cargas domésticas. Operam linha a linha e não possuem neutro."
    },
    "PV_L1L2": {
      "val": "PV L1, L2",
      "info": "Os relés PV L1 e L2 quando fechados conectam seu IQ8 PV às suas cargas domésticas. Eles operam linha a linha e não têm neutro."
    },
    "PV_L1_L2": {
      "val": "PV L1, L2",
      "info": "Os relés PV L1 e L2 quando fechados conectam seu IQ PV às suas cargas domésticas. Eles operam linha a linha e não têm neutro."
    },
    "DER_L1_L2": {
      "val": "DER L1, L2",
      "info": "DER L1 and L2 relays when closed connects your batteries or IQ PV to your home loads. They operate line to line and do not have a neutral."
    },
    "ENCHARGE_L1": {
      "val": "IQ Battery L1"
    },
    "ENCHARGE_L2": {
      "val": "IQ Battery L2"
    },
    "PV_L1": {
      "val": "PV L1"
    },
    "PV_L2": {
      "val": "PV L2"
    },
    "NFT_L1": {
      "val": "NFT L1",
      "info": "O NFT é o Transformador de Formação Neutro. Garante que o seu sistema pode operar no modo fora da rede. O relé NFT L1 quando fechado opera o seu NFT. O relé NFT N quando fechado liga ao neutro a partir do NFT para as sua cargas domésticas."
    },
    "NFT_N": {
      "val": "NFT N"
    },
    "GID_L1": {
      "val": "GID L1",
      "info": "Os relés GID L1 e L2 quando fechados ligam o seu Gerador às cargas de sua casa."
    },
    "GID_L2": {
      "val": "GID L2"
    },
    "NFT_L2": {
      "val": "NFT L2",
      "info": "O NFT é o Transformador de Formação Neutro. Garante que o seu sistema pode operar no modo fora da rede. O relé NFT L1 quando fechado opera o seu NFT. O relé NFT N quando fechado liga ao neutro a partir do NFT para as sua cargas domésticas."
    },
    "DER1_L1": {
      "val": "DER1 L1",
      "info": "Os relés DER1, L1 e L2 quando fechados conectam suas baterias ou IQ8 PV às suas cargas domésticas. Operam fase-fase e não possuem neutro."
    },
    "DER1_L2": {
      "val": "DER1 L2"
    },
    "DER2_L1": {
      "val": "DER2 L1",
      "info": "Os relés DER2 L1 e L2 quando fechados ligam o seu IQ8 PV às cargas de sua casa. Operam linha a linha e não têm um neutro."
    },
    "DER2_L2": {
      "val": "DER2 L2"
    },
    "dryContact": {
      "val": "NC1, NC2, NO1, NO2",
      "info": "Estes relés, quando fechados, ligam as suas cargas à fonte de alimentação"
    },
    "DER_L1_L2_L3_N": {
      "val": "DER L1, L2, L3, N",
      "info": "Os relés DER L1, DER L2, DER L3 e DER N do recurso de energia distribuída (DER), quando fechados, ligam a IQ Battery e o Microinversor IQ à linha 1, 2, 3 e em Neutro, respetivamente, à sua casa."
    },
    "DER_L1_L2_N": {
      "val": "DER L1, L2, N",
      "info": "Os relés DER L1, DER L2 e DER N do recurso de energia distribuída (DER), quando fechados, ligam a IQ Battery e o Microinversor IQ à linha 1, 2 e em Neutro, respetivamente, à sua casa."
    },
    "DER_1_N": {
      "val": "DER 1, N",
      "info": "Os relés DER L1 e DER N do recurso de energia distribuída (DER), quando fechados, ligam a IQ Battery e o Microinversor IQ à linha e em Neutro, respetivamente, à sua casa"
    },
    "open": "Aberto",
    "closed": "Fechado"
  }, _defineProperty(_liveVitalStats, "powered", "Energizado"), _defineProperty(_liveVitalStats, "notPowered", "Não energizado"), _defineProperty(_liveVitalStats, "niu", "Não está a ser utilizado"), _defineProperty(_liveVitalStats, "infoEc1L1L2", "EC1 L1, L2"), _defineProperty(_liveVitalStats, "infoNftL1N", "NFT L1, N"), _defineProperty(_liveVitalStats, "infoGidL1L2", "GID L1, L2"), _defineProperty(_liveVitalStats, "infoNftL2N", "NFT L2, N"), _defineProperty(_liveVitalStats, "infoDer1L1L2", "DER1 L1, L2"), _defineProperty(_liveVitalStats, "infoDer2L1L2", "DER2 L1, L2"), _defineProperty(_liveVitalStats, "infoEnchargeL1L2", "IQ Battery L1, L2"), _defineProperty(_liveVitalStats, "infoPvL1L2", "PV L1, L2"), _defineProperty(_liveVitalStats, "enpowerDesc", "A diferença entre a rede elétrica e a tensão e frequência da Microrede é observada devido à queda de tensão no dispositivo de interligação microrede (MID)."), _defineProperty(_liveVitalStats, "infoEnpwrDiagram", "Este diagrama de blocos do Controlador do Sistema é apenas para ilustração."), _defineProperty(_liveVitalStats, "infoEnpowerRelays", "Relés do controlador do sistema"), _defineProperty(_liveVitalStats, "bmuWarning", "Aviso BMU"), _defineProperty(_liveVitalStats, "bmuL1Error", "Erro nível 1 da BMU"), _defineProperty(_liveVitalStats, "bmuL2Error", "Erro nível 2 da BMU"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_WARN_CODE", "Aviso de tensão máxima da célula da bateria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_WARN_CODE", "Aviso de tensão mínima da célula da bateria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_IMBAL_WARN_CODE", "Aviso de desequilíbrio da tensão da célula da bateria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_WARN_CODE", "Aviso de sobretensão do interruptor FET da bateria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV1_CODE", "Erro nível 1 de tensão máxima da célula da bateria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV1_CODE", "Erro nível 1 de tensão mínima da célula da bateria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV1_CODE", "Erro nível 1 de temperatura máxima da célula da bateria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV1_CODE", "Erro nível 1 de temperatura mínima da célula da bateria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_DIS_OVER_CURRENT_ELV1_CODE", "Nível 1 de erro de sobrecorrente de descarga"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_LTC6811_NO_COMMS_ELV1_CODE", "Sem comunicações com BMU."), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_CURRENT_ELV1_CODE", "Erro nível 1 Corrente do transistor de efeito de campo"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FUSE_OPEN_ELV1_CODE", "Erro nível  1 fusível aberto"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_DRIVER_ELV1_CODE", "Erro nível 1 Driver do transistor de efeito de campo"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_SENSE_LINE_OPEN_ELV1_CODE", "Erro nível 1 Sensor de tensão de linha aberto"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_FET_OVER_TEMP_ELV1_CODE", "Erro nível 1 temperatura elevada do transistor de efeito de campo "), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_THERMAL_LINE_OPEN_ELV1_CODE", "Erro nível 1 Linha térmica aberta"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_24V_ELV1_CODE", "Erro nível 1 Circuito de precarregamento de 24 V "), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_PRECHARGE_VBAT_ELV1_CODE", "Erro nível 1 Tensão de precarregamento da célula da bateria "), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MAX_ELV2_CODE", "Erro nível 2 de tensão máxima da célula da bateria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_VOLT_MIN_ELV2_CODE", "Erro nível 2 de tensão mínima da célula da bateria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MAX_ELV2_CODE", "Erro nível 2 de temperatura máxima da célula da bateria"), _defineProperty(_liveVitalStats, "ENC_BMU_STATE_CELL_TEMP_MIN_ELV2_CODE", "Erro nível 2 de temperatura mínima da célula da bateria"), _defineProperty(_liveVitalStats, "gridMode", "Modo rede"), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED", {
    "val": "Rede amarrada",
    "info": "A bateria está no modo conectado à rede. Neste estado temporário não formará uma microrrede quando a rede estiver indisponível.",
    "pcuInfo": "O microinversor está no modo ligado à rede. Não formará uma microrede quando a rede não estiver disponível."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ON_GRID", {
    "val": "Na rede",
    "info": "A bateria está no modo conectado à rede e é capaz de formar uma microrrede quando necessário.",
    "pcuInfo": "O Microinversor é o modo ligado à rede e é capaz de formar uma microrede quando precisa."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_OFF_GRID", {
    "val": "Rede desligada",
    "info": "A bateria formou uma microrrede.",
    "pcuInfo": "O microinversor formou uma microrede."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_ISLANDING", {
    "val": "Ilha detetada",
    "info": "A bateria detectou que a rede está instável/ indisponível. Está em processo de formação da microrrede.",
    "pcuInfo": "O microinversor detetou que a rede está instável/não disponível Está no processo de formação da rede."
  }), _defineProperty(_liveVitalStats, "GRID_CONN_GRID_TIED_BLACK_START", {
    "val": "A formar a microrede",
    "info": "A bateria acabou de reiniciar. Detectou que a rede elétrica não está disponível e está em processo de formação da microrrede. Reduzir a carga doméstica ajuda na formação de microrredes.",
    "pcuInfo": "O microinversor acabou de reiniciar. Detetou que a rede elétrica não está disponível e está em processo de formação da microrede. Reduzir a carga doméstica ajuda à formação da microrede."
  }), _defineProperty(_liveVitalStats, "gridModeUnknown", {
    "val": "Inválido",
    "info": "Modo de rede inválido recebido para bateria.",
    "pcuInfo": "Modo rede inválido recebido para o microinversor"
  }), _defineProperty(_liveVitalStats, "infoGridModes", "Modos rede"), _defineProperty(_liveVitalStats, "ledStatus", "Estado do LED"), _defineProperty(_liveVitalStats, "phase", "Faza"), _defineProperty(_liveVitalStats, "infoEncharge", "IQ Battery"), _defineProperty(_liveVitalStats, "infoAcb", "ACB"), _defineProperty(_liveVitalStats, "infoEnchargeDesc1", "Em cada bateria existem %{pcuLength} microinversores IQ8X-BAT."), _defineProperty(_liveVitalStats, "infoEnchargeDesc2", "Um valor positivo de energia microinversor (kW) indica que a bateria está a descarregar enquanto um valor de potência negativa (kW) indica que a bateria está a carregar."), _defineProperty(_liveVitalStats, "infoPcuMicro", "Microinversores IQ8X-BAT"), _defineProperty(_liveVitalStats, "infoEnsemble3_0", "IQ8D-BAT Microinverters"), _defineProperty(_liveVitalStats, "infoEnsemble3_0_EnchargeDesc1", "Em cada bateria há microinversores %{pcuLength} IQ8D-BAT."), _defineProperty(_liveVitalStats, "pcu", "Micro"), _defineProperty(_liveVitalStats, "enph_oper_state", "Estado"), _defineProperty(_liveVitalStats, "EN_OP_ST_Idle", {
    "val": "Inativo"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Starting", {
    "val": "A iniciar"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Discovery", {
    "val": "Descoberta através de comunicação da linha de alimentação (PLC) em progresso"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Throttled", {
    "val": "Normal"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Mppt", {
    "val": "Normal (MPPT)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Bursting", {
    "val": "Normal (Rajada)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Constant_Vin", {
    "val": "Operação constante no modo tensão DC"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Standby", {
    "val": "Normal (em espera)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Protection_Fault", {
    "val": "Desligamento (falha de proteção)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Grid_Fault", {
    "val": "Desligamento (falha de rede)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Dcr", {
    "val": "Normal (verificação DCR)"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Unknown_state", {
    "val": "Desconhecida"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_DMIR_Init_Failed", {
    "val": "Falha de firmware"
  }), _defineProperty(_liveVitalStats, "EN_OP_ST_Host_Shutoff", {
    "val": "Desativado (Host Shutoff)"
  }), _defineProperty(_liveVitalStats, "ac_power", "Alimentação CA"), _defineProperty(_liveVitalStats, "signalStrength", "Resistência do sinal"), _defineProperty(_liveVitalStats, "commOk", "Com. OK"), _defineProperty(_liveVitalStats, "noComm", "Sem com."), _defineProperty(_liveVitalStats, "Normal", {
    "val": "Normal"
  }), _defineProperty(_liveVitalStats, "Unknown", {
    "val": "Desconhecida"
  }), _defineProperty(_liveVitalStats, "pes", (_pes = {
    "voltage": "Voltage",
    "frequency": "Frequency",
    "current": "Current",
    "mode": "Mode",
    "status": "Status",
    "operatingMode": "Operating Mode",
    "systemControls": "System Controls",
    "builtInBattery": "Built-In Battery",
    "IQ8D_MicroInverters": "IQ8D-BAT Microinverters",
    "powerIn": "Power In",
    "powerOut": "Power Out",
    "idle": "Idle",
    "charging": "Charging",
    "normal": "Normal",
    "batteryFault": "Battery Fault",
    "PCUFault": "Pcu fault",
    "solarPvFault": "Solar PV fault",
    "powerOutFault": "Power out fault",
    "powerInFault": "Power in fault",
    "grid_relay": "Grid Relay",
    "pcu_relay": "PCU Relay",
    "ac_loads": "AC Loads",
    "dc_loads": "DC Loads",
    "powered": "Powered"
  }, _defineProperty(_pes, "idle", "Idle"), _defineProperty(_pes, "disabled", "Disabled"), _defineProperty(_pes, "batteryState", "Battery is "), _defineProperty(_pes, "144cellBattery", "144 Cell Battery"), _defineProperty(_pes, "powerIn", "Power In"), _defineProperty(_pes, "average", "Average"), _defineProperty(_pes, "min", "Min"), _defineProperty(_pes, "max", "Max"), _defineProperty(_pes, "cellVoltage", "Cell Voltage"), _defineProperty(_pes, "cellTemp", "Cell Temperature"), _defineProperty(_pes, "pcuMode", "PCU Mode"), _defineProperty(_pes, "micro", "Micro"), _defineProperty(_pes, "acPower", "Ac Power"), _defineProperty(_pes, "dcPower", "DC Power"), _defineProperty(_pes, "state", "State"), _defineProperty(_pes, "grid", "Grid"), _defineProperty(_pes, "solar", "Solar"), _defineProperty(_pes, "auxIn", "Aux In"), _defineProperty(_pes, "acOut", "AC Out"), _defineProperty(_pes, "usbOut", "USB Out"), _defineProperty(_pes, "auxOut", "Aux Out"), _defineProperty(_pes, "coolingFan", "Cooling Fan"), _defineProperty(_pes, "devicelight", "Device Light"), _defineProperty(_pes, "OC", "OC"), _defineProperty(_pes, "OT", "OT"), _defineProperty(_pes, "OV", "OV"), _defineProperty(_pes, "UT", "UT"), _defineProperty(_pes, "UV", "UV"), _defineProperty(_pes, "UC", "UC"), _defineProperty(_pes, "coldIdle", "Cold Idle"), _defineProperty(_pes, "hotIdle", "Hot Idle"), _defineProperty(_pes, "hotCharging", "Hot Charging"), _defineProperty(_pes, "hotDisCharging", "Hot Discharging"), _defineProperty(_pes, "cellImbalance", "Cell Imbalance"), _defineProperty(_pes, "unknown", "unknown"), _defineProperty(_pes, "powerMode", "Power Mode"), _defineProperty(_pes, "SYSTEM_OFF", "Off"), _defineProperty(_pes, "POWER_SAVE", "Save"), _defineProperty(_pes, "SYSTEM_ON", "On"), _defineProperty(_pes, "systemControlInfo", "The difference between the Utility Grid and the Microgrid voltage and frequency is observed due to voltage drop across the grid relay."), _pes)), _liveVitalStats),
  "ledStatus": {
    "title": "Estado do LED",
    "code": {
      "-1": "Desconhecida",
      "0": "Erro serviço necessário",
      "1": "Erro BMU L1",
      "2": "Temperatura alta",
      "3": "Desligar CC",
      "4": "Sem comunicações com Gateway",
      "5": "Comunicações ligadas mas não desafiadas",
      "6": "Comunicações ligadas e desafiadas",
      "7": "Atualização falhou",
      "8": "Atualização BC em progresso",
      "9": "Trwa aktualizacja BMU",
      "10": "Atualização PCU em progresso",
      "11": "Modo suspensão",
      "12": "Carregando",
      "13": "Descarregamento",
      "14": "Capacidade da bateria entre: 75-100%",
      "15": "Capacidade da bateria entre: 50-75%",
      "16": "Capacidade da bateria entre: 25-50%",
      "17": "Capacidade da bateria entre: 0-25%",
      "18": "Sistema ATIVO"
    },
    "enpowerRow": {
      "code": {
        "-1": "Desconhecido",
        "0": "Erro do controlador do sistema (na rede)",
        "1": "Erro do controlador do sistema (fora da rede)",
        "2": "O controlador do sistema está no modo de desligamento rápido/substituição manual",
        "3": "Controlador do sistema fora da rede; DER desligados",
        "4": "Controlador do sistema operacional, não é possível detetar IQ Batteries no CAN (na rede)",
        "5": "Controlador do sistema operacional, não é possível detetar pelo menos uma IQ Battery no CAN (na rede)",
        "6": "Controlador do sistema operacional, não é possível detetar pelo menos uma IQ Battery no CAN (fora da rede)",
        "7": "Controlador do sistema fora da rede; a realizar a recuperação do SoC",
        "8": "O controlador do sistema está a sincronizar com a rede",
        "9": "Atualização do FW do controlador do sistema (na rede)",
        "10": "Atualização do FW do controlador do sistema (fora da rede)",
        "11": "Controlador do sistema ligado, a iniciar",
        "12": "Controlador do sistema ligado e na rede",
        "13": "Controlador do sistema ligado e fora da rede",
        "14": "Controlador do sistema desligado"
      }
    },
    "info": {
      "safetyIssue": "Nenhum dos estados do LED apresenta um problema de segurança",
      "title": {
        "flashingRed": "Vermelho intermitente",
        "flashingYellow": "Amarelo intermitente",
        "softPulseYellow": "Impulso suave amarelo",
        "softPulseBlue": "Impulso suave azul",
        "softPulseGreen": "Impulso suave verde",
        "solidRed": "Vermelho fixo",
        "solidYellow": "Amarelo fixo",
        "solidBlueOrGreen": "Azul ou verde fixo",
        "ledOff": "Desligada"
      },
      "desc": {
        "flashingRed": "Falha na atualização ou a bateria está em estado de erro. Entre em contato com o Instalador ou com o suporte Enphase.",
        "flashingYellow": "Atualização em progresso.",
        "softPulseYellow": "Modo suspensão ativado.",
        "softPulseBlue": "Descarregamento.",
        "softPulseGreen": "Carregando.",
        "solidRed": "A iniciar.",
        "solidYellow": "Não está funcionando devido à alta temperatura. Consulte \"Solução de problemas de IQ Battery\" A para obter mais detalhes.",
        "solidBlueOrGreen": "Ocioso. Transições de cores entre azul e verde conforme o estado de carga muda. O status da cobrança é atualizado no aplicativo Enphase. Consulte \"Solução de problemas de IQ Battery\" C para obter mais detalhes.",
        "ledOff": "Não operando. Consulte \"Solução de problemas de IQ Battery\" B para obter mais detalhes."
      }
    }
  },
  "updatePending": {
    "title": "Transferência de dados em progresso",
    "content": "Seu gateway está carregando os dados do sistema para a nuvem Enphase. Isso acontece quando o gateway está offline há algum tempo. Normalmente, leva 1 hora para cada dia em que o gateway está offline. Não se preocupe, a mensagem desaparecerá assim que todos os dados forem carregados.",
    "envoyDataTitle": "Upload de dados",
    "envoyDataContent": "Seu sistema se conectou recentemente à Internet e precisa de algum tempo para fazer upload de seus dados. Pode levar até uma hora para cada dia em que esteve off-line."
  },
  "bkpConfig": {
    "title": "Configurações do backup",
    "0": "Não selecionado",
    "1": "Backup parcial da casa",
    "2": "Reserva doméstica total"
  },
  "set": "Set",
  "change": "Mudar",
  "allTopics": "Todos os tópicos",
  "referFriends": {
    "title": "Recomendar amigos",
    "subTitle_1": "para dar ",
    "subTitle_2": " e obter ",
    "description_1": "Você e o seu amigo serão elegíveis para receber um cartão de presente de ",
    "description_2": " cada um após a compra do seu amigo e ativam um novo sistema solar Enphase usando a ligação abaixo.",
    "description_3": " gift card each after your friend purchases and activates a new Enphase solar system using the link below.",
    "urlHeading": "O seu URL de referência",
    "shareButton": "Partilhe a sua ligação de recomendação",
    "copyButton": "Copie a sua ligação de recomendação",
    "termsConditions": "Termos e Condições",
    "applyTerms": "aplicar",
    "toastMessage": "Ligação de referência copiada para a sua área de transferência",
    "shareMessage_1": "Olá! Sabia que a minha casa é movida a energia solar? Se você estava pensando em instalar energia solar, este é o momento. Tenho um link exclusivo que pode ser usado para você receber",
    "shareMessage_2": " quando você ativa um novo sistema solar Enphase.",
    "shareMessageAU_1": "Olá! Adquirir o sistema solar Enphase para minha casa foi um dos melhores investimentos que fiz e agora estou compartilhando a luz solar. Caso esteja considerando formas de reduzir a conta de energia elétrica e proteger seu bolso, tenho um link que pode ser usado para você receber",
    "shareMessageAU_2": " quando adquirir a energia solar com a Enphase. Veja:",
    "tncTitle": "Termos e Condições do Programa de Referência Enphase:",
    "important_title": "Importante",
    "important_subtitle": "Você e seu amigo só estarão qualificados para o voucher se:",
    "important_1": "There is a gap of at least 15 days between completed registration and installation.",
    "important_2": "O endereço de e-mail, como qual a referência foi recebida ou registrada, é usado parar ativar o sistema, uma vez instalado.",
    "tnc": {
      "1": "Limite de 30 recomendações por cliente.",
      "2": "As recomendações devem usar o link que você compartilha e fornecer suas informações de contacto para a Enphase através do site designado da Enphase em ou antes de 31 de dezembro de 2022..",
      "3": "Se a Enphase ou os seus instaladores já tiverem a ID do e-mail fornecida pela Referência, a sua Referência não será elegível para participar neste Programa de Referência.",
      "4": "Você e sua Indicação estarão qualificados para receber os Vales-presente somente se sua Indicação comprar, instalar e concluir a ativação do produto Enphase dentro de 2 anos do recebimento pela Enphase das informações da Indicação no site da Enphase.",
      "5": "Após receber a notificação da Enphase de que a sua Referência é elegível para receber o Cartão de Presente, deve solicitar o Cartão de Presente no prazo de 90 dias após receber tal aviso.",
      "6_One": "Se os Cartões de Presente de ",
      "6_Two": " não estiverem disponíveis, a Enphase poderá substituir outro prémio de valor igual ou superior.",
      "7": "O valor do Cartão de Presente selecionado reflete uma estimativa do valor da referência em relação aos gastos de marketing economizados no recrutamento de novos clientes.",
      "8": "Se você ou a sua Referência desejarem sair do Programa de Referência ou receber a recompensa do Cartão presente, entre em contacto com o Apoio ao Cliente da Enphase.",
      "9": "A Enphase não será responsável por pedidos trocados, incorretos, incompletos ou atrasados, nem a Enphase será responsável por erros tipográficos, problemas de upload ou download das informações da Referência, ou por quaisquer outros defeitos técnicos de redes, internet, equipamentos eletrónicos ou sites.",
      "10": "A Enphase reserva-se o direito de modificar, suspender ou encerrar este Programa de Referência sem aviso prévio.",
      "11": "Este Programa de Referência é nulo quando proibido.",
      "12": "Para que a Enphase atribua uma referência, a ligação única deve ser utilizada por si e a sua referência.",
      "13": "Deve haver um intervalo de pelo menos 15 dias entre o registro completo e a instalação.",
      "14": "O endereço de e-mail, como qual a referência foi recebida ou registrada, é usado parar ativar o sistema, uma vez instalado."
    }
  },
  "contactPVMaintainer": "Contacte a manutenção solar",
  "contactStorageMaintainer": "Contacte a manutenção de armazenamento",
  "pvInstallerDetails": "Detalhes do instalador solar",
  "storageInstallerDetails": "Detalhes do instalador de armazenamento",
  "customerSupport": "Suporte ao cliente",
  "soFarToday": "Até hoje",
  "forSelectedPeriod": "Para o período selecionado,",
  "energyIndependence": {
    "title": "Independência energética",
    "subTitle": "Mede a sua independência energética da rede de serviço público.",
    "formulaText": "Cálculo de Independência Energética:",
    "formula": "[1-(Importada/Consumida)] * 100%",
    "formulaForGenerator": "[1 - {(rede importada + Gerador importado/consumido}] * 100%",
    "desc1": "Independência energética é uma medida de autossuficiência energética. Isto significa que é capaz de fornecer pessoalmente para todas as suas necessidades de energia.",
    "unknown": "é desconhecido, pois o seu sistema não comunicou nenhum dado de consumo.",
    "0": "todo o seu consumo de energia é fornecido por uma fonte externa, nomeadamente a rede de serviço público. Isto significa que a sua contagem de Independência Energética para %{periodValue} %{eiValue}%.",
    "100": "o seu consumo de energia não é fornecido por uma fonte externa, como por exemplo a rede de serviço público. Isto significa que a sua contagem de Independência Energética para %{periodValue} %{eiValue}%.",
    "value": "%{geValue}% do seu consumo de energia é fornecido por uma fonte externa, nomeadamente a rede de serviço público. Isto significa que a sua contagem de Independência Energética para %{periodValue} %{eiValue}%.",
    "forTodayPeriod": "hoje é",
    "forSelectedPeriod": "o período selecionado é",
    "addStorageTitle": "Adicionar armazenamento",
    "addStorage": "para aumentar a sua Independência Energética.",
    "addStorageTitleWB": "Adicionar Solar ou Storage",
    "addStorageWB": "aumenta a sua independência energética.",
    "clarify": "Independência Energética não inclui energia exportada e não deve ser confundida com Net Metering (ou Net Energy), que é a diferença entre energia importada e exportada."
  },
  "backupHistory": {
    "backupEvents": "Eventos de reserva totais"
  },
  "eventHistory": {
    "totalEvents": "Total de eventos",
    "events": "Item/evento",
    "deviceImpacted": "Dispositivo com impacto",
    "recommendedAction": "Ação recomendada",
    "noBackupHistoryFound": "Não foi encontrado histórico de reserva",
    "eventStatus": "Estado do evento"
  },
  "siteActivationStage": {
    "title": " Iniciou a ativação dos seu sistema Enphase, ",
    "learnToUse": "Saiba como você pode usar o aplicativo Enphase para monitorar seu novo sistema Enphase."
  },
  "sfdcChatBot": {
    "exitConfirmation": "Deseja realmente sair do Chat?",
    "sfdcChatSubject": "Bate-papo do aplicativo Enphase",
    "offlineSupport": "Infelizmente nossos agentes estão offline.  Por favor, deixe sua mensagem."
  },
  "pushN": {
    "ok": "Ok, vá para aqui",
    "stay": "Fique aqui",
    "permMsg": "Recebeu uma notificação do site %{siteName}. Mude para este site para ver a notificação."
  },
  "tariffEditor": {
    "autofillChooseModeFAQ": "Qual modo devo escolher?",
    "autofillRatePlanExistFAQ": "Porque meu plano de tarifas não está listado?",
    "autofillRatePlanMatchFAQ": "Por que meus dados não correspondem às minhas contas?",
    "autofillTariffNote": "Em caso de dificuldade em encontrar o nome / código da tarifa, por favor, entre em contato com o seu provedor de serviços públicos para obter detalhes.",
    "whtBaslineElecRate": "Qual é a sua taxa de pagamento de eletricidade da linha de base?",
    "doElecPayRateVaryWeekends": "A sua taxa de pagamento de eletricidade varia nos fins de semana?",
    "doElecPayRateVarySeasonaly": "A sua taxa de pagamento de eletricidade varia sazonalmente?",
    "elecPayGoesUpWithUsage": "A sua taxa de pagamento de eletricidade aumenta à medida que a utilização aumenta?",
    "pRatePeakOffPecakChanges": "A sua taxa de pagamento de eletricidade tem taxas de hora de ponta e de vazio?",
    "ratePerUnitOfSolar": "Qual é a sua taxa de pagamento por unidade de energia solar gerada?",
    "payOutRate": "Taxa de pagamento",
    "tarifeditorConstants1": "Estrutura da taxa de eletricidade ",
    "tarifeditorConstants2": "Converte os dados de energia em taxas de moeda equivalentes ",
    "tarifeditorConstants3": "Ver/editar a estrutura da taxa de eletricidade do seu serviço público ",
    "tarifeditorConstants4": "Pode verificar se há informações sobre a taxa de importação de eletricidade na sua conta de luz sob a seção destacando os detalhes de suas cargas elétricas. ",
    "tarifeditorConstants5": "Adicionar taxa de importação de eletricidade ",
    "tarifeditorConstants6": "Defina a estrutura da taxa à qual obtém carga do seu serviço público para importar eletricidade da rede. ",
    "tarifeditorConstants7": "Nota ",
    "tarifeditorConstants8": "As informações de taxa de eletricidade são usadas pelo Gateway para determinar o melhor cronograma de carga e descarga da bateria quando o perfil da bateria é definido como 'Modo de economia'. Alterar essas informações alterará o comportamento do sistema.",
    "tarifeditorConstants9": "Estrutura da taxa de eletricidade não adicionada ",
    "tarifeditorConstants10": "Adicionar taxa de importação de eletricidade ",
    "tarifeditorConstants11": "Selecione um modo para adicionar os seus detalhes ",
    "tarifeditorConstants12": "Preenchimento automático ",
    "tarifeditorConstants13": "Importar a estrutura da taxa de eletricidade utilizando a informação do seu serviço público ",
    "tarifeditorConstants14": "Manual ",
    "tarifeditorConstants15": "Introduza manualmente os detalhes do seu serviço público de estrutura da taxa de eletricidade ",
    "tarifeditorConstants16": "Código zip ",
    "tarifeditorConstants17": "Nome do serviço público ",
    "tarifeditorConstants18": "Nome/código da tarifa ",
    "tarifeditorConstants19": "Detalhes da taxa de importação de eletricidade ",
    "tarifeditorConstants20": "Taxa plana ",
    "tarifeditorConstants21": "Taxa variável ",
    "tarifeditorConstants22": "Tempo de utilização ",
    "tarifeditorConstants23": "Taxa fixa ",
    "tarifeditorConstants24": "Exoneração de responsabilidade ",
    "tarifeditorConstants25": "As taxas elétricas relatadas são mudanças empacotadas que incluem apenas componentes de taxa baseadas no consumo. Não são considerados encargos fixos, ajustes, créditos, incentivos, região, específicos e impostos. ",
    "tarifeditorConstants26": "Confirmar e guardar ",
    "tarifeditorConstants27": "Nome da taxa de eletricidade ",
    "tarifeditorConstants28": "Taxa de eletricidade da linha de base ",
    "tarifeditorConstants29": "Tem a certeza que deseja repor os detalhes? ",
    "tarifeditorConstants30": "A sua taxa de eletricidade tem taxas de ponta e ponta desligada? ",
    "tarifeditorConstants31": "A taxa de eletricidade aumenta à medida que a utilização aumenta? ",
    "tarifeditorConstants32": "A taxa de eletricidade fixa não varia. ",
    "tarifeditorConstants33": "A taxa de eletricidade aumenta à medida que a utilização aumenta. ",
    "tarifeditorConstants34": "A sua taxa de eletricidade varia sazonalmente? ",
    "tarifeditorConstants35": "A sua taxa de eletricidade varia nos fins de semana? ",
    "tarifeditorConstants36": "Qual é a taxa de eletricidade da linha de base? ",
    "tarifeditorConstants37": "A taxa de eletricidade fixa não varia. ",
    "tarifeditorConstants38": "A taxa da estrutura da taxa de eletricidade varia apenas sazonalmente ",
    "tarifeditorConstants39": "A taxa da estrutura da taxa de eletricidade varia nos fins de semana ",
    "tarifeditorConstants40": "A taxa da estrutura da taxa de eletricidade varia sazonalmente e nos fins de semana ",
    "tarifeditorConstants41": "A taxa de eletricidade aumenta à medida que a utilização aumenta. ",
    "tarifeditorConstants42": "Taxa de eletricidade da linha de base : ",
    "tarifeditorConstants43": "A taxa da estrutura da taxa de eletricidade varia apenas sazonalmente ",
    "tarifeditorConstants44": "A taxa de eletricidade tem taxas de ponta e ponta desligada. ",
    "tarifeditorConstants45": "A estrutura da taxa de eletricidade varia nos fins de semana ",
    "tarifeditorConstants46": "Adicionar taxa de exportação de eletricidade ",
    "tarifeditorConstants47": "Adicione a estrutura da taxa à qual é pago para exportar a sua eletricidade gerada pelo sol para a rede. ",
    "tarifeditorConstants48": "Selecione o seu plano de exportação de eletricidade ",
    "tarifeditorConstants49": "Como selecionar o seu plano de exportação de eletricidade ",
    "tarifeditorConstants50": "Pode verificar esta informação na sua fatura de serviço público na secção que destaca os seus créditos e ajustes. ",
    "tarifeditorConstants51": "NEM (Sistema de compensação de energia elétrica) ",
    "tarifeditorConstants52": "Verifique se você tem uma configuração de medidor de rede em sua casa. <b style='font-weight: bold;'>Sua taxa de importação de eletricidade será copiada como sua taxa de exportação de eletricidade.</b> ",
    "tarifeditorConstants53": "FIT (tarifa de alimentação) líquida ",
    "tarifeditorConstants54": "Verifique se apenas você recebe pela energia solar que regressa à rede a partir de sua casa. ",
    "tarifeditorConstants55": "Gross FIT (tarifa de alimentação) bruta ",
    "tarifeditorConstants56": "Verifique se receber por cada unidade de eletricidade gerada pelos seus painéis solares. ",
    "tarifeditorConstants57": "Outros ",
    "tarifeditorConstants58": "Verifique se estiver em qualquer outro plano. ",
    "tarifeditorConstants59": "Detalhes da taxa de exportação de eletricidade ",
    "tarifeditorConstants60": "Estrutura da taxa de pagamento da eletricidade ",
    "tarifeditorConstants61": "Exportar plano ",
    "tarifeditorConstants62": "Editar taxa de exportação de eletricidade ",
    "tarifeditorConstants63": "O seu plano FIT paga-lhe um preço fixo por unidade de energia sola exportada? ",
    "tarifeditorConstants64": "Taxa variável segundo a hora ",
    "tarifeditorConstants65": "A taxa de pagamento de eletricidade tem taxas de hora de ponta e de vazio ",
    "tarifeditorConstants66": "A taxa de pagamento fixo de eletricidade não varia ",
    "tec67": "Tarifa de pagamento de eletricidade da linha de base",
    "tec68": "Nome da tarifa",
    "tec69": "Lamentamos informar que a sua estrutura tarifária não é compatível para preenchimento automático. Estamos trabalhando para resolver este problema. Em quanto isso, você pode definir a sua tarifa utilizando o fluxo manual.",
    "tec70": "Não foi possível encontrar o nome da distribuidora local para o seu CEP. Defina a tarifa manualmente.",
    "tec71": "Lamentamos, não foi possível encontrar os detalhes da Tarifa.",
    "tec72": "Selecionar nome do distrubuidora local",
    "tec73": "Procurar",
    "tec74": "Nome/código da tarifa",
    "tec75": "Selecionar nome/código da tarifa",
    "tec76": "Definir a tarifa manualmente",
    "tec77": "tente novamente",
    "tec78": "Selecionar o tempo de carregamento",
    "tec79": "Carregar as baterias a partir da rede",
    "from": "A partir de",
    "to": "até",
    "tec80": "Atualização de carregar a bateria a partir da rede bem-sucedida",
    "try_again": "Tente novamente.",
    "tec81": "Avalie a sua experiência",
    "tec82": "Estes dados foram úteis e precisos?",
    "tec83": "Pouco provável",
    "tec84": "Muito provavelmente",
    "tec85": "Para quaisquer perguntas ou esclarecimentos, escreva para nós.",
    "tec86": "Não quer que as suas baterias sejam carregadas a partir da rede?",
    "tec87": "Agradecemos sua valiosa opinião.",
    "talc": "Tente novamente mais tarde",
    "tec88": "Como foi a sua experiência com o editor de tarifa?",
    "tec89": "Nota",
    "tec90": "Copiar a partir de tarifa de compra",
    "tec91": "Copie sua definição de tarifa de tarifa de compra definida",
    "tec92": "Tarifa de exportação de eletricidade",
    "tec93": "Tarifa de importação de eletricidade",
    "tec94": "A tarifa de eletricidade mostrada aqui está agrupada de acordo com os componentes da tarifa mostrados abaixo.",
    "tec95": "Responda às perguntas abaixo para definir o seu tipo de tarifa.",
    "tec96": "Intervalo de tempo inválido",
    "tec97": "%{time1} - %{time2} já selecionado",
    "peak": "Pico",
    "aPeak": "Adicionar pico",
    "aSeason": "Adicionar estação",
    "season": "Estação",
    "eSeason": "Editar estação",
    "tec98": "Entrada inválida. O valor deve ser superior a Tier %{index}",
    "tec99": "Ocorreu um erro, tente novamente mais tarde",
    "tec100": "A taxa de pagamento de eletricidade aumenta à medida que a utilização aumenta.",
    "tec101": "Taxa variável com o tempo",
    "tier": "Tier",
    "offPeak": "Fora de pico",
    "tec102": "Editar tarifa de importação de eletricidade",
    "tec103": "Configuração manual",
    "tec104": "autopreencher tarifa",
    "tec105": "Selecionar um modo",
    "tec106": "Selecionar um modo para editar seus detalhes",
    "tec107": "selecionar nome da tarifa",
    "tec108": "As informações de tarifa de eletricidade são usadas pelo Gateway para determinar o melhor cronograma de carga e descarga da bateria. A alteração desta informação irá alterar o comportamento do sistema.",
    "tec109": "As informações da tarifa de eletricidade são usadas para calcular a sua economia de energia ao longo do tempo e fornecer recomendações personalizadas para ajudá-lo a poupar no seu custo de energia.",
    "tec110": "Qual é a sua taxa de pagamento por unidade de energia solar exportada?",
    "tec111": "Taxa de importação de eletricidade guardada/adicionada com sucesso",
    "tec112": "Taxa de importação de eletricidade atualizada com sucesso",
    "tec113": "Taxa de importação de eletricidade restabelecida com sucesso",
    "tec114": "Taxa de exportação de eletricidade guardada/adicionada",
    "tec115": "A Taxa de exportação de eletricidade foi atualizada com sucesso",
    "tec116": "A Taxa de exportação de eletricidade foi redefinida com sucesso",
    "rate": "Tarifa",
    "tec117": "Tarifa de pagamento fixa",
    "tec118": "Outros (Taxa variável )",
    "tec119": "Outros (Tempo de utilização )",
    "tec120": "Outros (Taxa plana )",
    "tec121": "FIT bruto",
    "tec122": "Net FIT (Taxa variável com o tempo)",
    "tec123": 'Net FIT (Taxa plana )',
    "tec124": "NEM",
    "tec125": "A tarifa de eletricidade fixa não varia. A estrutura da tarifa de eletricidade varia apenas sazonalmente.",
    "tec126": "A tarifa de eletricidade fixa não varia. A estrutura da tarifa de eletricidade varia apenas nos fins de semana.",
    "tec127": "A tarifa de eletricidade fixa não varia. A estrutura da tarifa de eletricidade varia apenas sazonalmente e nos fins de semana.",
    "tec128": "A tarifa fixa de pagamento da eletricidade não varia. A estrutura da tarifa de eletricidade varia apenas sazonalmente.",
    "tec129": "A tarifa fixa de pagamento da eletricidade não varia. A estrutura da tarifa de eletricidade varia apenas nos fins de semana.",
    "tec130": "A tarifa fixa de pagamento da eletricidade não varia. A estrutura da tarifa de eletricidade varia apenas sazonalmente e nos fins de semana.",
    "tec131": "A tarifa de eletricidade tem taxas de pico e fora de pico. A estrutura da tarifa de eletricidade varia apenas sazonalmente.",
    "tec132": "A tarifa de eletricidade tem taxas de pico e fora de pico. A estrutura da tarifa de eletricidade varia apenas nos fins de semana.",
    "tec133": "A tarifa de eletricidade tem taxas de pico e fora de pico. A estrutura da tarifa de eletricidade varia apenas sazonalmente e nos fins de semana.",
    "tec134": "A tarifa fixa de pagamento da eletricidade tem taxas de pico e fora de pico. A estrutura da tarifa de eletricidade varia apenas sazonalmente.",
    "tec135": "A tarifa fixa de pagamento da eletricidade tem taxas de pico e fora de pico. A estrutura da tarifa de eletricidade varia nos fins de semana.",
    "tec136": "A tarifa fixa de pagamento da eletricidade tem taxas de pico e fora de pico. A estrutura da tarifa de eletricidade varia sazonalmente e nos fins de semana.",
    "tec137": "A taxa de eletricidade aumenta à medida que o uso aumenta. A estrutura da tarifa de eletricidade varia apenas sazonalmente.",
    "tec138": "A tarifa fixa de pagamento da eletricidade aumenta à medida que o uso aumenta. A estrutura da tarifa de eletricidade varia apenas sazonalmente.",
    "emptystring": "",
    "tec139": "ToU",
    "tec140": "Mostrar taxas históricas",
    "tec141": "Taxa de importação da eletricidade adicionada com êxito",
    "tec142": "Avalie a sua experiência de adição da taxa de eletricidade",
    "tec143": "Insatisfeito",
    "tec144": "Satisfeito",
    "tec145": "Ignorar",
    "tedc0": "Taxa de Potência",
    "tedc1": "Taxa de Potência durante todo o dia (24 h)",
    "tedc2": "A taxa de potência vem já incluída na taxa de eletricidade da sua fatura de eletricidade mensal.",
    "tedc3": "A sua taxa de eletricidade inclui o pedido de componente de carregamento. Durante as horas de pico, o consumo máximo para qualquer intervalo de %{time} minutos durante o mês será cobrado de acordo com os seguintes detalhes",
    "tedc4": "Consumo máx. de %{time} min.",
    "tedc5": "Selecione uma estrutura de taxa de eletricidade",
    "tet1": "Fale-me sobre como adicionar taxa de eletricidade",
    "tet2": "Em algumas áreas, o custo da eletricidade aumenta e diminui ao longo do dia ou com base na quantidade que você usa. Usamos sua taxa de eletricidade para planejar a melhor carga de bateria e cronograma de descarga quando seu perfil é definido para o modo de economia.",
    "tet3": "Iniciar",
    "tet4": "Toque em 'Adicionar taxa de importação de eletricidade'.",
    "tet5": "Insira suas informações",
    "tet6": "Use o preenchimento automático ou manual para inserir os detalhes da sua taxa. Você pode precisar de uma conta de energia elétrica atual se inserir sua tarifa manualmente.",
    "tet7": "Preenchimento Automático",
    "tet8": "Selecione sua distribuidora de energia e nome ou código do plano nos menus suspensos. O aplicativo pesquisará automaticamente sua taxa de importação de eletricidade.",
    "tet9": "Manual",
    "tet10": "Insira os detalhes em cada campo - você pode precisar consultar uma conta de luz em vigor para reunir todas as informações necessárias.",
    "tet11": "Adicionar taxa de exportação de eletricidade",
    "tet12": "Se você receber um crédito por enviar eletricidade de volta à rede, adicione sua taxa de exportação de eletricidade a seguir. Toque em 'Adicionar Taxa de Exportação de Eletricidade' para começar - você terá as mesmas opções para inserir suas informações por preenchimento automático ou manualmente.",
    "tet13": "Como determinamos e usamos sua taxa de eletricidade",
    "undefined": "outro (em camadas)",
    "timeDiffError": "A hora de início e de fim deve ter uma diferença mínima de 15 minutos",
    "periodOverlapError": "Este período está a sobrepor-se a um dos outros períodos",
    "peakConflictError": "A taxa de pico deve ser superior à taxa fora de pico",
    "isTimeValid": 'A hora de início deve ser anterior à hora de término'
  },
  "appliance": {
    "info": "Para manter a energia em sua casa durante longos períodos de falha de rede, recomendamos que reduza e gira o seu consumo de energia",
    "desc": "Desligue as cargas não essesciais da casa para aumentar o tempo de vida útil da bateria.",
    "descSystem2_0AndEncharge": "Melhores práticas durante uma falta de energia da rede.",
    "largeAppliances": "Grandes eletrodomésticos",
    "useSparingly": "uso moderado",
    "essentialAppliances": "Pequenos eletrodomésticos",
    "useNormally": "uso normal",
    "airConditioner": "Ar Condicionado",
    "dishwasher": "Máquina de lavar loiça",
    "poolPump": "Bomba para piscina",
    "washingMachine": "Máquina de lavar roupa",
    "electricVehicle": "Veículo elétrico",
    "electricDryer": "Máquina de secar roupa",
    "lights": "Luz(es)",
    "laptop": "Portátil",
    "television": "Televisão",
    "refrigerator": "Geladeira",
    "wifiRouter": "Router Wi-Fi",
    "microwave": "Micro-ondas"
  },
  "rootedAlert": {
    "exitBtn": "Sair",
    "proceedBtn": "Avançar",
    "agreeBtn": "Concordo",
    "warningLabel": "Aviso!",
    "warningTextInitial": "Seu dispositivo parece estar rooted. O rooting compromete a proteção de segurança padrão e torna os dados armazenados em seu dispositivo vulneráveis. Não é recomendado executar o aplicativo Enphase no dispositivo com root.",
    "warningTextFinal": "Ao prosseguir, entendo e concordo que a Enphase não será responsável por qualquer mau funcionamento ou consequências da execução do aplicativo Enphase neste dispositivo com root."
  },
  "generator": {
    "exerciseModeOverlap1": "O tempo de exercício está a sobrepor-se ao seu tempo de inatividade",
    "exerciseModeOverlap2": "para",
    "exerciseModeOverlap3": "Pretende continuar?",
    "dayInWeek": "Dia numa semana",
    "time": "Hora",
    "duration": "Duração",
    "frequency": "Frequência",
    "save": "Guardar",
    "edit": "Editar",
    "cancelRequest": "Cancelar pedido",
    "activate": "Ativar",
    "okayText": "OK, percebi!",
    "batteryUnavailable": "<span>Seu sistema não conta com bateria.<a href='https://estimator.enphaseenergy.com/login' target='_blank'> Adicione armazenamento</a> para controlar o seu %{device}  com base na carga da bateria.  </span>",
    "suspendedStateText": "O seu gerador está atualmente desativado. Ative o seu gerador utilizando o botão de alternância na parte superior da tela para ativar o perfil do gerador.",
    "suspendedModalHeading": "Seu gerador sempre estará desligado nesse estado.",
    "suspendedModalSubheading": " Deseja continuar?",
    "infoHeadng": "Gerador",
    "infoSubheading": "<div style='font-size: 12px; font-weight: 300; line-height: 1.5'><div>Quando <span style='color: #F37320'>ativado</span>, seu gerador ligará e desligará com base no perfil selecionado e na disponibilidade da rede. Se o seu sistema estiver On Grid, o gerador será desligado independentemente dos perfis selecionados.</div><div style='margin-top: 10px;'> Você pode desativar o gerador quando não estiver em uso, por exemplo, quando você vai de férias.<div></div>",
    "advancedSettings": "Definições avançadas",
    "pendingRequest": "pedido pendente",
    "disabled": "Desativado",
    "disable": "Desativar",
    "enabled": "Ativado",
    "waiting": "A aguardar informação",
    "active": "Ativo",
    "deviceDetails": "Selecione um perfil para dar partida no gerador",
    "autoStart": "Automático",
    "autoStartSubheading": "Ligar quando a rede estiver desligada",
    "batteryOptimizationSubheading": "Ligar com base na carga da bateria",
    "batteryChargeThreshold": "Limite de carga da bateria",
    "lowerLimit": "Limite de início: ",
    "upperLimit": "Limite de paragem: ",
    "start": "Começar: ",
    "stop": "Pare: ",
    "addQuietTime": "Definir tempo silencioso",
    "quietTime": "Hora silenciosa",
    "quietTimeToggle": "Utilize se não quiser ligar o seu gerador durante este tempo. Quando a bateria atingir o limite crítico, o gerador ligará independentemente da hora de silêncio.",
    "startTime": "Hora de início: ",
    "endTime": "Hora de fim: ",
    "criticalChargeSettings": "Definições de carga críticas:",
    "generatorLoadingToast": "A confirmação do status do gerador está demorando mais do que o esperado. Favor voltar mais tarde.",
    "exerciseMode": "Definições de exercício",
    "exerciseModeSubheading": "Este é utilizado para executar o gerador automaticamente num intervalo regular para mantê-lo em boas condições de trabalho.",
    "batteryOptimization": "Amigável com o ambiente",
    "activateBatteryProfile": "Selecionou o perfil de arranque automático Ative o perfil de início com base no nível da bateria” para adicionar o tempo silencioso.",
    "manualMode": "Modo manual",
    "manualModeDescription": "Your generator is currently operating in manual mode. Please change your generator mode to auto or contact your installer.",
    "generatorStartLimit": "O Limite de partida não pode ser menor do que 10%",
    "generatorStartStopLimit": "O Limite de partida e o Limite de parada deve ter uma diferença mínima de 5%",
    "generatorLimitDescription": "Utilize isto para evitar ligar o gerador durante períodos específicos de tempo. O gerador liga-se quando a carga da bateria fica abaixo do limite de carga crítico.",
    "generatorQuietTime": "Tempo silencioso",
    "generatorNormalTime": "Tempo normal",
    "generatorEnableGenerator": "Acionar gerador",
    "generatorDisableGenerator": "Desativar Gerador",
    "automatic": "Automatico",
    "ecoFriendly": "Eco-Amigável"
  },
  "sgipStatic": {
    "applyForIncentive": "Candidatar-se ao incentivo SGIP",
    "subheadingSgip": "Os proprietários de sistemas na Califórnia que planejam ou compraram uma bateria Enphase para sua casa podem solicitar o SGIP",
    "applyNow": "Candidatar-se agora",
    "learnMore": "Saber mais",
    "serviceFee": "* Podem aplicar-se taxas de serviço",
    "enphaseRepresentative": "* Pode ser contactado por um representante da Enphase por telefone/e-mail",
    "documentsRequired": "Os seguintes documentos são necessários para se candidatar ao incentivo SGIP:",
    "documentHeading1": "1. Última fatura de serviços (pelo menos uma fatura dos últimos 3 meses)",
    "documentHeading2": "2. Documento do contrato",
    "additionalInfo": "* Podem ser necessários documentos adicionais antes do reembolso final do incentivo"
  },
  "activationProgress": {
    "systemActivationInProgress": "A ativação do seu sistema está em progresso",
    "completed": "Concluído",
    "viewDetails": "Ver detalhes",
    "activationCompleted": "A ativação está 100% concluída",
    "activationInProgress": "Ativação em progresso",
    "devices": "Dispositivos",
    "status": "Estado",
    "envoy": "Gateway",
    "encharge": "Bateria",
    "enpower": "Controlador do sistema",
    "pvProduction": "Produção fotovoltaica",
    "cosumptionCT": "CT de consumo",
    "systemOperational": "Sistema operacional",
    "reporting": "Está a comunicar",
    "notReporting": "Não está a comunicar",
    "enabled": "Ativado",
    "notEnabled": "Não ativado",
    "producing": "Produção",
    "verified": "Verificado",
    "notVerified": "Não verificado",
    "featuresNowEnable": "As seguintes funcionalidades estão agora ativadas.",
    "featuresWillBeEnabled": "As seguintes funcionalidades serão ativadas após a ativação do sistema estar concluída:",
    "consumptionMonitoring": "Monitorização do consumo",
    "liveStatus": "Status ao vivo",
    "stormGuard": "Proteção contra tempestade",
    "batteryProfileSetting": "Definições do perfil da bateria",
    "gridControl": "Controlo da rede"
  },
  "prodIssue_faq_1": "Porque é que um dos meus painéis de produção é inferior aos outros?",
  "prodIssue_faq_2": "É comum os painéis no mesmo telhado variarem na geração de energia. Muitos fatores podem causar estas variações, tais como a direção do painel, sombras de chaminés ou árvores e outras obstruções.",
  "accountNew": {
    "account": {
      "title": "Suas informações",
      "title_alternate": "Informação pessoal",
      "save_changes": "Salvar alterações",
      "name_label": "Nome:",
      "phone_label": "Telemóvel:",
      "phone_placeholder": "Número de telefone",
      "first_name_placeholder": "Primeiro nome",
      "last_name_placeholder": "Sobrenome",
      "email_placeholder": "Endereço de correio eletrônico",
      "email_label": "Email:",
      "change_password": "Alterar senha",
      "current_password": "Palavra-passe atual:",
      "password_label": "Nova senha:",
      "password2_label": "Digite novamente a nova senha:",
      "password_footnote": "As senhas devem ter pelo menos 6 caracteres, pelo menos 1 número ou caractere especial.",
      "cancel_change_password": "Não alterar a senha",
      "units_label": "Unidades:",
      "units_metric": "Métrico (°C, km)",
      "units_us": "Imperial (°F, mi)",
      "locale_label": "Idioma:",
      "equivalent_label": "Equivalente de energia:",
      "equivalent_display": "Começa com",
      "notification_label": "E-mails:",
      "preference_monthly_email": "Quero receber mensalmente resumos do desempenho do sistema",
      "preference_enphase_email": "Quero receber boletins, promoções e pesquisas com relação aos produtos ou serviços da Enphase",
      "production_issues_email": "Quero ser notificado sobre a problemas relacionados ao serviço ou produção do sistema",
      "save_successful": "Suas informações foram salvas.",
      "save_successful_email": "Suas informações foram salvas. Veja a nota abaixo sobre sua mudança de e-mail.",
      "save_failed": "Falha ao salvar suas informações.",
      "system_info": "Informação do sistema para %{site_name}",
      "system_weather": "Clima no local do sistema",
      "show_system_weather": "Mostrar recursos meteorológicos para este site",
      "save": "Guardar"
    },
    "system_preferences": {
      "title": "Preferências do sistema",
      "name_label": "Nome:",
      "public_label": "Página pública do sistema:",
      "public_text_html": "Crie uma página pública para meu sistema",
      "public_preview_link": "Pré-visualização da página pública",
      "public_help_link": "Saiba mais",
      "public_footnote": "Isto ativará recursos de compartilhamento e permitirá visitantes em seu sistema.",
      "display_label": "Exibir nome do sistema como:",
      "save_changes": "SSalvar preferências do sistema",
      "save_location_changes": "Salvar configurações de privacidade",
      "save_successful": "As preferências de seu sistema foram salvas.",
      "save_failed": "Falha em salvar as preferências do sistema"
    },
    "validations": {
      "required": "Este campo é obrigatório.",
      "password_too_short": "Sua senha deve ter pelo menos seis caracteres e conter pelo menos um número ou caractere especial.",
      "password_too_long": "Digite menos de 50 caracteres.",
      "password_similar_to_username": "Sua senha não pode ser igual ao seu endereço de e-mail.",
      "password_too_weak": "Sua senha deve ter pelo menos seis caracteres e conter pelo menos um número ou caractere especial.",
      "password_weak": "Sua senha deve ter pelo menos seis caracteres e conter pelo menos um número ou caractere especial.",
      "password_good": "Força da senha: Bom",
      "password_strong": "PForça da senha: Forte",
      "password_policy": "Sua senha deve ter pelo menos %{pwd_min_length} - %{pwd_max_length} caracteres e incluir %{digit_in_pwd} dígitos, %{uppercase_in_pwd} maiúsculas, %{lowercase_in_pwd} minúsculas, %{special_character_in_pwd} número de caracteres especiais e apenas (~! # $% ^ & *)",
      "equalTo": "Digite o mesmo valor novamente.",
      "invalid_phone_number": "Digite um número válido de telefone.",
      "empty_phone_number": "Insira o número do seu celular.",
      "email_used": "E-mail já registrado. Tente novamente com outro e-mail ou Aqui para redefinir sua senha.",
      "emailInvalid": "Favor inserir um endereço de email válido"
    }
  },
  "accountDelete": {
    "deleteAccount": "Deletar conta",
    "deletePopUpText": "Sua conta e informações pessoais associadas seriam excluídas. Você será desconectado após excluir a conta. Você quer prosseguir?",
    "deleteCnfText": "Sua conta e informações pessoais associadas seriam excluídas, exceto as informações que somos obrigados a manter em relação ao seu Sistema de Energia. Você será desconectado após excluir a conta. Você quer prosseguir?",
    "yes": "Sim",
    "no": "Não",
    "verificationCode": "Código de verificação",
    "enterCodeText": "Digite o código de 4 dígitos que foi enviado para o seu endereço de e-mail registrado e o número do celular.",
    "didntReceive": "Não recebeu o código?",
    "resend": "Reenviar",
    "deleteCnfTextEnlm": "Sua conta e informações pessoais associadas seriam excluídas, exceto as informações que somos obrigados a manter em relação ao seu Sistema de Energia. Você também perderá o acesso ao Enlighten Manager. Você será desconectado após excluir a conta. Você quer prosseguir?",
    "deleteAdmin": "Sua conta não pode ser excluída porque você é um usuário administrador do Enphase",
    "verifyCode": "Código de verificação",
    "logOutText": "Você será desconectado após verificar o código.",
    "confirmText": "Sua conta está desativada. Nós reteremos as informações pessoais relacionadas ao seu sistema de energia para honrar sua garantia e dar suporte ao seu sistema.",
    "ok": "OK, entendi",
    "activateCnfText": "Sua conta Enphase não está ativa porque você excluiu sua conta. Deseja ativá-lo novamente?",
    "activateText": "O ID de e-mail é registrado na Enphase. No entanto, ele não está ativo, pois foi excluído.",
    "click": "Clique ",
    "activateAgain": "aqui para ativá-lo novamente",
    "activateAccount": "Ativar conta",
    "emailIDRegistered": "O ID de e-mail é registrado na Enphase. No entanto, ele não está ativo, pois foi excluído. $cHere para ativá-lo novamente.",
    "deleteAccountPopupText": "A exclusão de sua conta desativará sua conta e removerá todas as informações pessoais associadas à sua conta. Como você está associado a um Enphase Energy System, somos obrigados a reter suas informações pessoais para oferecer suporte à garantia do produto, atualizações do sistema e suporte.",
    "learnMore": "Saber mais",
    "accountdeletion": "Sua conta está em processo de exclusão. Esse processo pode levar até 30 dias e você pode criar uma nova conta depois que sua conta anterior for excluída.",
    "incorrectEmailandPass": "O e-mail e a senha que você digitou não correspondem aos nossos registros. Por favor, tente novamente.",
    "accountdeletioninfo": "Sua conta está em processo de exclusão. Pode levar até 30 dias.",
    "WOAccntdeletePopup": "A exclusão de sua conta desativará sua conta e removerá todas as informações pessoais associadas à sua conta.",
    "accountdelReq": "Solicitação de exclusão de conta",
    "verfcodedel": "Seu código de verificação para excluir a conta Enphase",
    "accountActvReq": "Solicitação de ativação de conta",
    "codedelAccount": "Código de verificação para excluir a conta Enphase",
    "codeDuration": "Este código só será válido por 15 minutos.",
    "userDelReq": "O usuário solicitou a opção de exclusão de conta no aplicativo Enphase. Por favor, encontre os detalhes do usuário abaixo",
    "requestReceived": "Recebemos sua solicitação para ativar sua conta Enphase. Para fazer isso, clique no link abaixo em até 7 dias após o recebimento deste e-mail.",
    "activate": "Ativar",
    "accActivate": "ative sua conta",
    "optdelaccount": "Seu código de verificação para excluir a conta Enphase é %{otp}. Este código é válido por 15 minutos.",
    "emailCheckInstruction": "Por favor, verifique seu e-mail para obter instruções para ativar a conta."
  },
  "phase": {
    "all": "Visualização trifásica",
    "phaseL": "Fase L",
    "msgOffGrid": "Os dados de consumo de energia relativos à fase não estão disponíveis quando o seu sistema está no modo \"Fora da rede\"."
  },
  "vls": {
    "vlsHeading": "Nível de desligamento da bateria",
    "shutdownLevelLine1": "Durante uma falha de energia, a sua bateria irá desligar-se a",
    "shutdownLevelLine1-2": "para preservar energia. Reinicia-se ao utilizar a energia preservada quando a rede elétrica recuperar energia ou painéis solares para começar a produzir energia.",
    "shutdownLevelLine2": "Escolha um valor elevado na presença de más condições meteorológicas que afetem a produção de energia solar.",
    "vlsWarning": "O nível de desligamento da bateria não pode ser superior à reserva da bateria (%{soc}%)",
    "stormVlsWarning": "O alerta de tempestades está ligado para o seu sistema. Quando a tempestade terminar, a reserva da bateria será atualizada para %{soc}%, uma vez que a reserva não pode ser inferior ao nível de desligamento",
    "batteryReserveWarning": "A reserva da bateria não pode ser definida abaixo do nível de desligamento da bateria (%{horizontal}%). Reduza o nível de desligamento da bateria em \"#Definições avançadas#\" para reduzir a reserva da bateria.",
    "editRequest": "Tem um pedido ativo. Aguarde pela confirmação ou cancele o pedido para continuar com a seleção."
  },
  "defaultLocale": {
    "popContent1": "Escolha o idioma do aplicativo",
    "popContentBody1": "Deseja continuar com ",
    "popContentBody2": " como o idioma do seu aplicativo?",
    "button1": "Ok, continuar",
    "button2": "Escolha outro idioma",
    "button3": "Não, mude para ",
    "en": "Inglês",
    "de": "Alemão",
    "es": "Espanhol",
    "fr": "Francês",
    "it": "italiano",
    "nl": "Holandês",
    "pl": "polonês",
    "pt": "Português",
    "en-AU": "English (AU)"
  },
  "woSolarWStorage": {
    "noArraysTitle": "Sem instalações!",
    "noArraysDesc": "Não tem painéis solares instalados",
    "noAccessConsumptionData": "Não tem acesso aos dados de consumo deste local."
  },
  "drEventsActive": "DR Event: Ativo",
  "pleaseGoTo": "Por favor vá ao ",
  "enlightenManager": "Enlighten Manager",
  "updateNP": " para atualizar suas preferências de notificação.",
  "loadControl": {
    "enabled": "Ativado",
    "disabled": "Desativado",
    "smartEnabled": "Controle inteligente ativado",
    "offGridBehaviour": "Comportamento fora da rede",
    "modeDetails": "Detalhes do modo de controle inteligente",
    "newModeDetails": "Detalhes do modo de controle de carga",
    "basicMode": "Modo básico",
    "cannotUse": "%{loadName} não pode ser usado",
    "genOnUSe": "%{loadName} pode ser usado quando o gerador estiver ligado",
    "genMode": "Modo gerador",
    "batteryMode": "Modo bateria",
    "batteryModePercent": "%{loadName} pode ser usado quando a carga da bateria estiver em %{lowerSoc}% ou mais.",
    "batteryModeSoc": "Caso a carga da bateria esteja abaixo de %{lowerSoc}%, %{loadName}% não poderá ser usado até que a carga da bateria atinja %{upperSoc}%.",
    "loadControlHeading": "Controle a energia das cargas quando desconectado de rede",
    "loadControlSubHeading": "Todas as cargas estão ligadas quando conectado a rede",
    "powered": "Energizado",
    "unknown": "Desconhecida",
    "notPowered": "Não energizado",
    "permissionOfIntstaller": "Não tem autorização para editar quaisquer definições para este aparelho. Contacte o seu instalador ou o apoio ao cliente da Enphase para saber mais sobre isto.",
    "willbePowered": "Seu %{loadName} será sempreenergizado nesse estado.",
    "poweredOnOffGrid": "Seu %{loadName} será sempre energizado com base no comportamento fora da rede selecionado.",
    "continueModal": "Deseja continuar?",
    "infoDetails": "Quando o controle inteligente está desativado ou o sistema está conectado a rede, as cargas estarão sempre alimentadas.",
    "newInfoDetails": "Controle a potência de suas cargas com base no recurso de energia ou na hora do dia. Você também pode usar o modo Manual se quiser controlar a energia de suas cargas instantaneamente",
    "enableSmartComtrol": "Ative o controle inteligente para utilizar este recurso.",
    "enableToggle": "Ativar o controle inteligente?",
    "disableToggle": "Desativar o controle inteligente?",
    "apply": "Aplique",
    "modalPara1": "<div>Quanto o controle inteligente está<span style='color: #F37320'>Ativado</span>, é possível escolher um dos três modos de comportamento Off-grid.</div>",
    "disabledModalText": "A função do controle inteligente está desativada para esta carga. Ative a função controle inteligente utilizando o botão de alternância para atualizar o comportamento fora da rede.",
    "batteryChargeLowerLimit": "O limite inferior da carga da bateria não pode ser menor do que 10%",
    "batteryChargeHigherLimit": "Limite de Nível mínimo de Carga da Bateria não pode ser acima de 10%",
    "loadControlLoadingToast": "A confirmação de estado de %{loadName} está a demorar mais do que o esperado. Verifique novamente mais tarde.",
    "loadControlTakingLonger": "A confirmação de estado da carga está a demorar mais do que o esperado. Verifique novamente mais tarde.",
    "batteryChargeLowerHigherLimit": "O limite inferior e o limite superior da carga da bateria deve ter uma diferença mínima de 5%",
    "mode": "Modo",
    "lcMainHeading": "Controle de potência das suas cargas",
    "basic": "Básico",
    "scheduled": "Agendado",
    "advanced": "Avançado",
    "manual": "Manual",
    "notSelected": "Não Selecionado",
    "poweredWhen": "Alimentado quando a carga da bateria é superior a",
    "poweredGenOn": "Alimentado quando o gerador está ligado",
    "poweredBetweenTime": "Alimentado entre %{startTime} e %{endTime}",
    "onceDisconnected": "Depois de desligada da fonte de alimentação, a carga não será alimentada a menos que a bateria recarregue a 100%.",
    "alwaysPowered": "Sempre alimentado",
    "neverPowered": "Nunca alimentado",
    "minDiff": "A Hora de Início e a Hora de Término devem ter uma diferença de no mínimo 15 minutos.",
    "startLessThanEnd": "A hora de início não pode ser anterior à hora de fim",
    "notValidTime": "A hora de início e a hora de fim devem ser entre %{startTime} e %{endTime}.",
    "completed": "Modo %{loadName} atualizado com sucesso.",
    "notCompleted": "O seu pedido não pôde ser concluído. Tente novamente mais tarde",
    "completedAll": "Loads updated successfully.",
    "emptyLoadControls": "Não foram encontrados controlos de carga",
    "allowedWarning": "Ao modificar esta janela de tempo, garanta que a sua produção de energia solar é suficiente para suportar o seu consumo durante esta janela de tempo.",
    "advancedMode": {
      "subtitle": "Controle a carga utilizando:",
      "notPowered": "Alimentado quando a carga é superior a ",
      "batterySocDesc1": "Não alimentado quando a carga está abaixo de ",
      "batterySocDesc2": "Alimentado apenas após a bateria recarregar até ",
      "batterySocDesc3": " (mesmo com o gerador ligado)",
      "notAvailable": "Não disponível",
      "onGridGenPowered": "Ligado",
      "offGridGenPowered": "Alimentado quando o gerador está ligado"
    }
  },
  "app_info": {
    "update_available": "Atualização disponível do aplicativo",
    "already_updatec": "A sua App está agora atualizada",
    "update_now": "Atualizar Agora",
    "latest_update": "Última Atualização",
    "update_history": "Atualizar Histórico",
    "show_more": "Ver Mais",
    "show_less": "Mostrar menos"
  },
  "s1": "Ajude-me a selecionar um perfil",
  "s2": "Saiba mais sobre perfis de bateria",
  "s3": "Sugira um perfil para mim",
  "s4": "A carga da bateria é maior do que a reserva",
  "s5": "Independência de energia após horário de pico:",
  "s6": "Fora dos horários de pico, os painéis solares carregam a bateria primeiro, antes de fornecer energia à sua casa. Qualquer excesso de energia solar será enviado de volta à rede para reduzir sua conta de luz.",
  "s7": "Se sua casa precisa de mais energia do que os painéis solares estão produzindo, a eletricidade será usada da rede.",
  "s8": "Comportamento do sistema durante os horários de pico",
  "s9": "Reduza suas contas de luz",
  "s10": "Em algumas áreas, o custo da eletricidade muda ao longo do dia, tornando-se mais caro durante os horários de pico, quando a eletricidade está em alta demanda.",
  "s11": "Para evitar a compra de eletricidade a um custo mais alto, sua casa usará a bateria. Se sua casa precisa de mais energia do que a bateria pode fornecer, a energia solar é usada em seguida e a rede elétrica é usada por último. Qualquer excesso de energia solar seria exportado para a rede.",
  "s12": "À noite, quando os painéis solares não estão produzindo nada, sua casa usa a energia da bateria até que o nível de carga de reserva seja alcançado.",
  "s13": "A eletricidade é importada da rede quando a energia solar não está disponível e sua casa precisa de mais energia do que a bateria pode fornecer.",
  "s14": "Energize sua casa com energia limpa",
  "s15": "Sua casa priorizará o uso de energia limpa. Durante o dia, a energia solar fornece energia à casa e, em seguida, à bateria. Qualquer excesso é exportado para a rede. Durante a noite, a bateria fornece energia para a casa.",
  "s16": "A eletricidade é importada da rede quando sua casa precisa de mais energia do que a energia solar e a bateria podem fornecer juntas.",
  "s17": "A bateria está totalmente carregada",
  "s18": "Comportamento do sistema fora do horário de pico",
  "s19": "Seus painéis irão alimentar sua bateria primeiro e depois sua casa. Qualquer energia extra será enviada para a rede.",
  "s20": "À noite ou a qualquer hora que você precisar de mais energia do que os painéis estão produzindo, sua casa usará eletricidade da rede. Sua bateria nunca é usada, exceto durante uma queda de energia.",
  "s21": "Toque em um perfil para pular para suas páginas.",
  "s22": "Deslize para a esquerda ou direita para ler mais.",
  "s23": "Suas baterias irão descarregar mesmo após os horários de pico.",
  "s24": "A eletricidade é importada da rede quando a energia solar não está disponível e sua casa precisa de mais energia do que a bateria pode fornecer.",
  "s25": "Comportamento do sistema fora do horário de pico",
  "s26": "Permaneça alimentado durante interrupções",
  "guestUser": "Guest",
  "systemOwner": {
    "savings": {
      "infoPopUpContent": "Este é o valor estimado de poupanças monetárias do seu sistema com base na produção solar. Este é calculado com base nos dados introduzidos da taxa de eletricidade.",
      "noTeriffMsg": "Adicione a tarifa de eletricidade para saber suas economias",
      "noBillingCyclefMsg": "Add billing cycle to know your savings",
      "getStarted": "Começar",
      "billingCycle": {
        "more": "superior à do último ciclo de faturação na mesma altura",
        "less": "inferior à do último ciclo de faturação na mesma altura",
        "same": "Semelhante à do último ciclo de faturação na mesma altura"
      },
      "calendarMonth": {
        "more": "após esta hora no mês anterior",
        "less": "antes desta hora no mês anterior",
        "same": "Por volta desta hora no mês anterior"
      },
      "day": {
        "more": "após esta hora no dia anterior",
        "less": "antes desta hora no dia anterior",
        "same": "Por volta desta hora no dia anterior",
        "significantMore": "Significativamente superior ao dia anterior"
      },
      "week": {
        "more": "após esta hora na semana anterior",
        "less": "antes desta hora na semana anterior",
        "same": "Por volta desta hora na semana anterior"
      },
      "year": {
        "more": "após esta hora no ano anterior",
        "less": "antes desta hora no ano anterior",
        "same": "Por volta desta hora no ano anterior"
      },
      "editElectricity": "EDITAR A TAXA DE ELETRICIDADE",
      "viewSavingsBased": "Veja as poupanças em",
      "calendarMonthTitle": "Mês do calendário",
      "calendarMonthDesc": "Período de tempo do primeiro até ao último dia do mês",
      "noExportRate": "Adicione %{exportCTA} para ver sua economia total",
      "exportRate": "Taxa de exportação"
    }
  },
  "offline": (_offline = {
    "unableToConnectLocally": "Não foi possível conectar localmente",
    "limitedAppFunctionality": "Funcionalidade limitada de aplicativo",
    "needHelpGatewayWifi": "Ajuda com a configuração da ligação Wi-Fi do gateway",
    "howToConnectGatewayNetwork": "Como ligar à rede do gateway",
    "connectGatewayToWifi": "Ligar o gateway à rede Wi-Fi",
    "connectLocally": "CONECTAR LOCALMENTE",
    "checkNetworkConnection": "Por favor verifique a sua conexão a rede.",
    "noInternetModalSubText1": "Por favor verifique sua conexão com a rede. Enquanto isso, você pode ver o status atual do seu sistema.",
    "noInternetModalSubText2": "Verifique a ligação à sua rede. Entretanto, se estiver perto do seu sistema, pode ligar localmente ao gateway para ver o estado atual.",
    "refereshing": "Atualizando",
    "pullToReferesh": "Puxe para atualizar",
    "connectionStatus": "O seu telemóvel esta, agora, ligado localmente à rede do gateway.",
    "connectivityErrorMsg1": "Certifique-se de que seu telefone e o Gateway estejam na mesma rede",
    "connectivityErrorMsg2": 'O gateway foi conectado recentemente à rede %{wifiName}',
    "connectivityErrorMsg3": "Alternativamente, conecte seu telefone ao Gateway Wifi ativando o modo AP no seu Gateway",
    "connecting": "Seu telefone está tentando se conectar localmente com o Gateway para visualizar o status ao vivo.",
    "viewLiveStatus": "Ver Status ao vivo",
    "pleaseTryAgainInSomeTime": "Por favor tente novamente mais tarde.",
    "connectedLocally": "Ligado localmente",
    "ssidNotMatchedError": "Não ligou o seu telemóvel à rede de gateway correta. Ligue o seu telemóvel à rede deste gateway: %{envoySSID}",
    "envoySSIDListDialog": {
      "title": "Redes de gateway para este local",
      "message": "Ligue o seu telemóvel apenas à rede de um dos gateways deste local. A seguir estão as redes do gateway para este local:",
      "buttonText": "OK, compreendi!"
    },
    "multiEnvoySiteSSIDNotMatchedMsg": "Não ligou o seu telemóvel à rede de gateway correta. Ligue o seu telemóvel apenas à rede de um dos gateways deste local.",
    "configureButtonMultiEnvoyMsg": "Não ligou o seu telemóvel à rede de gateway correta. Ligue o seu telemóvel apenas à rede de um dos gateways deste local. A seguir estão as redes do gateway para este local:",
    "listOfGatewayNetworks": "Lista de redes de gateway para este local",
    "configureWifiMultiEnvoyMsg": "Para configurar o Wi-Fi para o gateway (n.º de série: XXXX) ligue o seu telemóvel ao modo AP deste gateway. Atualmente está ligado ao modo AP do gateway (n.º de série:XX_%{sNumber}).",
    "deviceOfflineModal": {
      "title": "Como ligar ao Wi-Fi do gateway",
      "okGotIt": "OK, compreendi",
      "subText": "Please make sure your phone and the gateway are on the same Wi-Fi network to connect locally",
      "gatewayNetwork": "",
      "subText1": "Ligue a rede do seu gateway localmente, se pretender alterar as definições do sistema.",
      "subText2": 'Certifique-se de que o seu telemóvel e o gateway estão na mesma rede %{recentlyConnectedWifiMsg}.',
      "wifiSSIDMsg": "(o gateway foi ligado recentemente \xE0 rede \"%{lastConnection}\")",
      "subText3": "Alternativamente, ligue o seu telemóvel ao Wi-Fi do gateway ativando o modo AP no seu gateway",
      "connectToAPGateway": "Connect your phone to gateway's Wi-Fi by enabling AP mode on your gateway."
    },
    "systemStatus": {
      "recentWifiTitle": "Ligações Wi-Fi recentes dos gateways",
      "gatewayPrefix": "NS do gateway",
      "gatewayBtn": "Redes Wi-Fi do gateway para este local",
      "alternetively": "Alternativamente, ligue o seu telemóvel a qualquer uma das redes do gateway, ativando o modo AP no seu gateway."
    },
    "isTouPopupMsg": "O modo de poupança não pode ser ativado uma vez que o mesmo funciona apenas se tiver uma contagem de energia líquida (CEL) e a sua taxa de eletricidade variar com tempo de utilização (TdU). Só é possível definir ou atualizar a taxa de eletricidade se o seu telemóvel estiver ligado à Internet.",
    "configWifiToGateway": "CONFIGURAR O WI-FI DO GATEWAY",
    "phoneNtConnectedToGateway": "O telemóvel não está ligado ao gateway",
    "chooseWifiNetwork": "Escolha a rede Wi-Fi que pretende utilizar com o gateway.",
    "learnWifiConfigToGatway": "Aprenda a configurar o Wi-Fi do gateway",
    "step": "Passo",
    "connectPhoneToGateway": "Ligue o telemóvel ao gateway",
    "connectToGatewayNetwork": "Ligue a rede do gateway para configurar o Wi-Fi do gateway",
    "gatewayNtReachable": "O gateway não está contactável",
    "pleaseEnsure": "Certifique-se de que:",
    "gatewayAPModeOn": "O modo AP do gateway está ligado",
    "phoneInCloseProximity": "O telemóvel está perto do gateway",
    "mobileDataOff": "Os dados móveis estão desligados",
    "searchingGateway": "A procurar a rede do gateway…",
    "devicePluggedIn": "Certifique-se de que o dispositivo está próximo e ligado e o modo AP está ligado",
    "connectingTo": "A ligar a",
    "reflectedInApp": "Pode demorar alguns minutos a ser refletido na aplicação",
    "connectionFailed": "Falha ao ligar à rede do gateway",
    "connectedToGateway": "O telemóvel está ligado ao gateway"
  }, _defineProperty(_offline, "connectGatewayToWifi", "Ligue o gateway ao Wi-Fi"), _defineProperty(_offline, "chooseNetworkToConnectGateway", "Escolha a rede Wi-Fi à qual gostaria de ligar o gateway."), _defineProperty(_offline, "scanNetwork", "Ler rede Wi-Fi"), _defineProperty(_offline, "enterPassword", "Introduza a palavra-passe deß"), _defineProperty(_offline, "join", "Ligar"), _defineProperty(_offline, "gatewayConnected", "O gateway foi ligado com êxito a %{selectedWifi}"), _defineProperty(_offline, "disconnectPhoneFromGateway", "Pode, agora, desligar o telemóvel da rede do gateway e ligá-lo ao Wi-Fi/ativar os dados móveis"), _defineProperty(_offline, "failedToConnect", "Falha ao ligar a"), _defineProperty(_offline, "gatewayConnectedToPoerSource", "Certifique-se de que o gateway está ligado a uma fonte de alimentação e que está perto do gateway."), _defineProperty(_offline, "routerIsOn", "Certifique-se de que o router Wi-Fi está ligado e que está perto do router Wi-Fi"), _defineProperty(_offline, "unableToDisplayNetworks", "Não é possível apresentar as rede Wi-Fi"), _defineProperty(_offline, "errorDisplayingNetworks", "Ocorreu um erro ao apresentar as redes Wi-Fi devido a alguns problemas técnicos. Tente novamente."), _defineProperty(_offline, "errorInConnectingToWifi", "Ocorreu um erro ao ligar à rede Wi-Fi. Tente mais tarde ou ligue-se a uma rede diferente."), _defineProperty(_offline, "unableToConnect", "Não é possível ligar"), _defineProperty(_offline, "pairGateway", "Emparelhe o gateway com o telemóvel via Bluetooth."), _offline),
  "tutorial": {
    "back": "Voltar",
    "apMode": "Como ligar o modo AP",
    "step1": "Passo 1 de 3",
    "step2": "Passo 2 de 3",
    "step3": "Passo 3 de 3",
    "powerOnGateway": "Ligue o gateway",
    "title2": "Prima o botão do modo AP",
    "brieflyPressGateway": "Briefly press and release (do not hold) the gateway menu button next the phone icon",
    "getStarted": "Começar",
    "next": "Passo seguinte",
    "prev": "Passo anterior",
    "via": "Via",
    "chooseWifi": "After connecting your phone to the gateway, choose the Wi-Fi you want to connect your gateway to",
    "connectGateway": "Connect to gateway's network to configue Wi-Fi  for your gateway",
    "selectGateway": "Select your gateway type",
    "thatsIt": "Já está!",
    "step1of2": "Passo 1 de 2",
    "step2of2": "Passo 2 de 2",
    "learnHow": "Learn how",
    "tryConnectingGateway": "Vamos tentar ligar o gateway ao telemóvel. Certifique-se de que está perto do gateway e que os dados móveis estão desligados."
  }
};
module.exports = mobile;